/*! jQuery v1.10.2 | (c) 2005, 2013 jQuery Foundation, Inc. | jquery.org/license
//@ sourceMappingURL=jquery-1.10.2.min.map
*/
(function(e,t){var n,r,i=typeof t,o=e.location,a=e.document,s=a.documentElement,l=e.jQuery,u=e.$,c={},p=[],f="1.10.2",d=p.concat,h=p.push,g=p.slice,m=p.indexOf,y=c.toString,v=c.hasOwnProperty,b=f.trim,x=function(e,t){return new x.fn.init(e,t,r)},w=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,T=/\S+/g,C=/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,N=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,k=/^<(\w+)\s*\/?>(?:<\/\1>|)$/,E=/^[\],:{}\s]*$/,S=/(?:^|:|,)(?:\s*\[)+/g,A=/\\(?:["\\\/bfnrt]|u[\da-fA-F]{4})/g,j=/"[^"\\\r\n]*"|true|false|null|-?(?:\d+\.|)\d+(?:[eE][+-]?\d+|)/g,D=/^-ms-/,L=/-([\da-z])/gi,H=function(e,t){return t.toUpperCase()},q=function(e){(a.addEventListener||"load"===e.type||"complete"===a.readyState)&&(_(),x.ready())},_=function(){a.addEventListener?(a.removeEventListener("DOMContentLoaded",q,!1),e.removeEventListener("load",q,!1)):(a.detachEvent("onreadystatechange",q),e.detachEvent("onload",q))};x.fn=x.prototype={jquery:f,constructor:x,init:function(e,n,r){var i,o;if(!e)return this;if("string"==typeof e){if(i="<"===e.charAt(0)&&">"===e.charAt(e.length-1)&&e.length>=3?[null,e,null]:N.exec(e),!i||!i[1]&&n)return!n||n.jquery?(n||r).find(e):this.constructor(n).find(e);if(i[1]){if(n=n instanceof x?n[0]:n,x.merge(this,x.parseHTML(i[1],n&&n.nodeType?n.ownerDocument||n:a,!0)),k.test(i[1])&&x.isPlainObject(n))for(i in n)x.isFunction(this[i])?this[i](n[i]):this.attr(i,n[i]);return this}if(o=a.getElementById(i[2]),o&&o.parentNode){if(o.id!==i[2])return r.find(e);this.length=1,this[0]=o}return this.context=a,this.selector=e,this}return e.nodeType?(this.context=this[0]=e,this.length=1,this):x.isFunction(e)?r.ready(e):(e.selector!==t&&(this.selector=e.selector,this.context=e.context),x.makeArray(e,this))},selector:"",length:0,toArray:function(){return g.call(this)},get:function(e){return null==e?this.toArray():0>e?this[this.length+e]:this[e]},pushStack:function(e){var t=x.merge(this.constructor(),e);return t.prevObject=this,t.context=this.context,t},each:function(e,t){return x.each(this,e,t)},ready:function(e){return x.ready.promise().done(e),this},slice:function(){return this.pushStack(g.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},eq:function(e){var t=this.length,n=+e+(0>e?t:0);return this.pushStack(n>=0&&t>n?[this[n]]:[])},map:function(e){return this.pushStack(x.map(this,function(t,n){return e.call(t,n,t)}))},end:function(){return this.prevObject||this.constructor(null)},push:h,sort:[].sort,splice:[].splice},x.fn.init.prototype=x.fn,x.extend=x.fn.extend=function(){var e,n,r,i,o,a,s=arguments[0]||{},l=1,u=arguments.length,c=!1;for("boolean"==typeof s&&(c=s,s=arguments[1]||{},l=2),"object"==typeof s||x.isFunction(s)||(s={}),u===l&&(s=this,--l);u>l;l++)if(null!=(o=arguments[l]))for(i in o)e=s[i],r=o[i],s!==r&&(c&&r&&(x.isPlainObject(r)||(n=x.isArray(r)))?(n?(n=!1,a=e&&x.isArray(e)?e:[]):a=e&&x.isPlainObject(e)?e:{},s[i]=x.extend(c,a,r)):r!==t&&(s[i]=r));return s},x.extend({expando:"jQuery"+(f+Math.random()).replace(/\D/g,""),noConflict:function(t){return e.$===x&&(e.$=u),t&&e.jQuery===x&&(e.jQuery=l),x},isReady:!1,readyWait:1,holdReady:function(e){e?x.readyWait++:x.ready(!0)},ready:function(e){if(e===!0?!--x.readyWait:!x.isReady){if(!a.body)return setTimeout(x.ready);x.isReady=!0,e!==!0&&--x.readyWait>0||(n.resolveWith(a,[x]),x.fn.trigger&&x(a).trigger("ready").off("ready"))}},isFunction:function(e){return"function"===x.type(e)},isArray:Array.isArray||function(e){return"array"===x.type(e)},isWindow:function(e){return null!=e&&e==e.window},isNumeric:function(e){return!isNaN(parseFloat(e))&&isFinite(e)},type:function(e){return null==e?e+"":"object"==typeof e||"function"==typeof e?c[y.call(e)]||"object":typeof e},isPlainObject:function(e){var n;if(!e||"object"!==x.type(e)||e.nodeType||x.isWindow(e))return!1;try{if(e.constructor&&!v.call(e,"constructor")&&!v.call(e.constructor.prototype,"isPrototypeOf"))return!1}catch(r){return!1}if(x.support.ownLast)for(n in e)return v.call(e,n);for(n in e);return n===t||v.call(e,n)},isEmptyObject:function(e){var t;for(t in e)return!1;return!0},error:function(e){throw Error(e)},parseHTML:function(e,t,n){if(!e||"string"!=typeof e)return null;"boolean"==typeof t&&(n=t,t=!1),t=t||a;var r=k.exec(e),i=!n&&[];return r?[t.createElement(r[1])]:(r=x.buildFragment([e],t,i),i&&x(i).remove(),x.merge([],r.childNodes))},parseJSON:function(n){return e.JSON&&e.JSON.parse?e.JSON.parse(n):null===n?n:"string"==typeof n&&(n=x.trim(n),n&&E.test(n.replace(A,"@").replace(j,"]").replace(S,"")))?Function("return "+n)():(x.error("Invalid JSON: "+n),t)},parseXML:function(n){var r,i;if(!n||"string"!=typeof n)return null;try{e.DOMParser?(i=new DOMParser,r=i.parseFromString(n,"text/xml")):(r=new ActiveXObject("Microsoft.XMLDOM"),r.async="false",r.loadXML(n))}catch(o){r=t}return r&&r.documentElement&&!r.getElementsByTagName("parsererror").length||x.error("Invalid XML: "+n),r},noop:function(){},globalEval:function(t){t&&x.trim(t)&&(e.execScript||function(t){e.eval.call(e,t)})(t)},camelCase:function(e){return e.replace(D,"ms-").replace(L,H)},nodeName:function(e,t){return e.nodeName&&e.nodeName.toLowerCase()===t.toLowerCase()},each:function(e,t,n){var r,i=0,o=e.length,a=M(e);if(n){if(a){for(;o>i;i++)if(r=t.apply(e[i],n),r===!1)break}else for(i in e)if(r=t.apply(e[i],n),r===!1)break}else if(a){for(;o>i;i++)if(r=t.call(e[i],i,e[i]),r===!1)break}else for(i in e)if(r=t.call(e[i],i,e[i]),r===!1)break;return e},trim:b&&!b.call("\ufeff\u00a0")?function(e){return null==e?"":b.call(e)}:function(e){return null==e?"":(e+"").replace(C,"")},makeArray:function(e,t){var n=t||[];return null!=e&&(M(Object(e))?x.merge(n,"string"==typeof e?[e]:e):h.call(n,e)),n},inArray:function(e,t,n){var r;if(t){if(m)return m.call(t,e,n);for(r=t.length,n=n?0>n?Math.max(0,r+n):n:0;r>n;n++)if(n in t&&t[n]===e)return n}return-1},merge:function(e,n){var r=n.length,i=e.length,o=0;if("number"==typeof r)for(;r>o;o++)e[i++]=n[o];else while(n[o]!==t)e[i++]=n[o++];return e.length=i,e},grep:function(e,t,n){var r,i=[],o=0,a=e.length;for(n=!!n;a>o;o++)r=!!t(e[o],o),n!==r&&i.push(e[o]);return i},map:function(e,t,n){var r,i=0,o=e.length,a=M(e),s=[];if(a)for(;o>i;i++)r=t(e[i],i,n),null!=r&&(s[s.length]=r);else for(i in e)r=t(e[i],i,n),null!=r&&(s[s.length]=r);return d.apply([],s)},guid:1,proxy:function(e,n){var r,i,o;return"string"==typeof n&&(o=e[n],n=e,e=o),x.isFunction(e)?(r=g.call(arguments,2),i=function(){return e.apply(n||this,r.concat(g.call(arguments)))},i.guid=e.guid=e.guid||x.guid++,i):t},access:function(e,n,r,i,o,a,s){var l=0,u=e.length,c=null==r;if("object"===x.type(r)){o=!0;for(l in r)x.access(e,n,l,r[l],!0,a,s)}else if(i!==t&&(o=!0,x.isFunction(i)||(s=!0),c&&(s?(n.call(e,i),n=null):(c=n,n=function(e,t,n){return c.call(x(e),n)})),n))for(;u>l;l++)n(e[l],r,s?i:i.call(e[l],l,n(e[l],r)));return o?e:c?n.call(e):u?n(e[0],r):a},now:function(){return(new Date).getTime()},swap:function(e,t,n,r){var i,o,a={};for(o in t)a[o]=e.style[o],e.style[o]=t[o];i=n.apply(e,r||[]);for(o in t)e.style[o]=a[o];return i}}),x.ready.promise=function(t){if(!n)if(n=x.Deferred(),"complete"===a.readyState)setTimeout(x.ready);else if(a.addEventListener)a.addEventListener("DOMContentLoaded",q,!1),e.addEventListener("load",q,!1);else{a.attachEvent("onreadystatechange",q),e.attachEvent("onload",q);var r=!1;try{r=null==e.frameElement&&a.documentElement}catch(i){}r&&r.doScroll&&function o(){if(!x.isReady){try{r.doScroll("left")}catch(e){return setTimeout(o,50)}_(),x.ready()}}()}return n.promise(t)},x.each("Boolean Number String Function Array Date RegExp Object Error".split(" "),function(e,t){c["[object "+t+"]"]=t.toLowerCase()});function M(e){var t=e.length,n=x.type(e);return x.isWindow(e)?!1:1===e.nodeType&&t?!0:"array"===n||"function"!==n&&(0===t||"number"==typeof t&&t>0&&t-1 in e)}r=x(a),function(e,t){var n,r,i,o,a,s,l,u,c,p,f,d,h,g,m,y,v,b="sizzle"+-new Date,w=e.document,T=0,C=0,N=st(),k=st(),E=st(),S=!1,A=function(e,t){return e===t?(S=!0,0):0},j=typeof t,D=1<<31,L={}.hasOwnProperty,H=[],q=H.pop,_=H.push,M=H.push,O=H.slice,F=H.indexOf||function(e){var t=0,n=this.length;for(;n>t;t++)if(this[t]===e)return t;return-1},B="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",P="[\\x20\\t\\r\\n\\f]",R="(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",W=R.replace("w","w#"),$="\\["+P+"*("+R+")"+P+"*(?:([*^$|!~]?=)"+P+"*(?:(['\"])((?:\\\\.|[^\\\\])*?)\\3|("+W+")|)|)"+P+"*\\]",I=":("+R+")(?:\\(((['\"])((?:\\\\.|[^\\\\])*?)\\3|((?:\\\\.|[^\\\\()[\\]]|"+$.replace(3,8)+")*)|.*)\\)|)",z=RegExp("^"+P+"+|((?:^|[^\\\\])(?:\\\\.)*)"+P+"+$","g"),X=RegExp("^"+P+"*,"+P+"*"),U=RegExp("^"+P+"*([>+~]|"+P+")"+P+"*"),V=RegExp(P+"*[+~]"),Y=RegExp("="+P+"*([^\\]'\"]*)"+P+"*\\]","g"),J=RegExp(I),G=RegExp("^"+W+"$"),Q={ID:RegExp("^#("+R+")"),CLASS:RegExp("^\\.("+R+")"),TAG:RegExp("^("+R.replace("w","w*")+")"),ATTR:RegExp("^"+$),PSEUDO:RegExp("^"+I),CHILD:RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+P+"*(even|odd|(([+-]|)(\\d*)n|)"+P+"*(?:([+-]|)"+P+"*(\\d+)|))"+P+"*\\)|)","i"),bool:RegExp("^(?:"+B+")$","i"),needsContext:RegExp("^"+P+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+P+"*((?:-\\d)?\\d*)"+P+"*\\)|)(?=[^-]|$)","i")},K=/^[^{]+\{\s*\[native \w/,Z=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,et=/^(?:input|select|textarea|button)$/i,tt=/^h\d$/i,nt=/'|\\/g,rt=RegExp("\\\\([\\da-f]{1,6}"+P+"?|("+P+")|.)","ig"),it=function(e,t,n){var r="0x"+t-65536;return r!==r||n?t:0>r?String.fromCharCode(r+65536):String.fromCharCode(55296|r>>10,56320|1023&r)};try{M.apply(H=O.call(w.childNodes),w.childNodes),H[w.childNodes.length].nodeType}catch(ot){M={apply:H.length?function(e,t){_.apply(e,O.call(t))}:function(e,t){var n=e.length,r=0;while(e[n++]=t[r++]);e.length=n-1}}}function at(e,t,n,i){var o,a,s,l,u,c,d,m,y,x;if((t?t.ownerDocument||t:w)!==f&&p(t),t=t||f,n=n||[],!e||"string"!=typeof e)return n;if(1!==(l=t.nodeType)&&9!==l)return[];if(h&&!i){if(o=Z.exec(e))if(s=o[1]){if(9===l){if(a=t.getElementById(s),!a||!a.parentNode)return n;if(a.id===s)return n.push(a),n}else if(t.ownerDocument&&(a=t.ownerDocument.getElementById(s))&&v(t,a)&&a.id===s)return n.push(a),n}else{if(o[2])return M.apply(n,t.getElementsByTagName(e)),n;if((s=o[3])&&r.getElementsByClassName&&t.getElementsByClassName)return M.apply(n,t.getElementsByClassName(s)),n}if(r.qsa&&(!g||!g.test(e))){if(m=d=b,y=t,x=9===l&&e,1===l&&"object"!==t.nodeName.toLowerCase()){c=mt(e),(d=t.getAttribute("id"))?m=d.replace(nt,"\\$&"):t.setAttribute("id",m),m="[id='"+m+"'] ",u=c.length;while(u--)c[u]=m+yt(c[u]);y=V.test(e)&&t.parentNode||t,x=c.join(",")}if(x)try{return M.apply(n,y.querySelectorAll(x)),n}catch(T){}finally{d||t.removeAttribute("id")}}}return kt(e.replace(z,"$1"),t,n,i)}function st(){var e=[];function t(n,r){return e.push(n+=" ")>o.cacheLength&&delete t[e.shift()],t[n]=r}return t}function lt(e){return e[b]=!0,e}function ut(e){var t=f.createElement("div");try{return!!e(t)}catch(n){return!1}finally{t.parentNode&&t.parentNode.removeChild(t),t=null}}function ct(e,t){var n=e.split("|"),r=e.length;while(r--)o.attrHandle[n[r]]=t}function pt(e,t){var n=t&&e,r=n&&1===e.nodeType&&1===t.nodeType&&(~t.sourceIndex||D)-(~e.sourceIndex||D);if(r)return r;if(n)while(n=n.nextSibling)if(n===t)return-1;return e?1:-1}function ft(e){return function(t){var n=t.nodeName.toLowerCase();return"input"===n&&t.type===e}}function dt(e){return function(t){var n=t.nodeName.toLowerCase();return("input"===n||"button"===n)&&t.type===e}}function ht(e){return lt(function(t){return t=+t,lt(function(n,r){var i,o=e([],n.length,t),a=o.length;while(a--)n[i=o[a]]&&(n[i]=!(r[i]=n[i]))})})}s=at.isXML=function(e){var t=e&&(e.ownerDocument||e).documentElement;return t?"HTML"!==t.nodeName:!1},r=at.support={},p=at.setDocument=function(e){var n=e?e.ownerDocument||e:w,i=n.defaultView;return n!==f&&9===n.nodeType&&n.documentElement?(f=n,d=n.documentElement,h=!s(n),i&&i.attachEvent&&i!==i.top&&i.attachEvent("onbeforeunload",function(){p()}),r.attributes=ut(function(e){return e.className="i",!e.getAttribute("className")}),r.getElementsByTagName=ut(function(e){return e.appendChild(n.createComment("")),!e.getElementsByTagName("*").length}),r.getElementsByClassName=ut(function(e){return e.innerHTML="<div class='a'></div><div class='a i'></div>",e.firstChild.className="i",2===e.getElementsByClassName("i").length}),r.getById=ut(function(e){return d.appendChild(e).id=b,!n.getElementsByName||!n.getElementsByName(b).length}),r.getById?(o.find.ID=function(e,t){if(typeof t.getElementById!==j&&h){var n=t.getElementById(e);return n&&n.parentNode?[n]:[]}},o.filter.ID=function(e){var t=e.replace(rt,it);return function(e){return e.getAttribute("id")===t}}):(delete o.find.ID,o.filter.ID=function(e){var t=e.replace(rt,it);return function(e){var n=typeof e.getAttributeNode!==j&&e.getAttributeNode("id");return n&&n.value===t}}),o.find.TAG=r.getElementsByTagName?function(e,n){return typeof n.getElementsByTagName!==j?n.getElementsByTagName(e):t}:function(e,t){var n,r=[],i=0,o=t.getElementsByTagName(e);if("*"===e){while(n=o[i++])1===n.nodeType&&r.push(n);return r}return o},o.find.CLASS=r.getElementsByClassName&&function(e,n){return typeof n.getElementsByClassName!==j&&h?n.getElementsByClassName(e):t},m=[],g=[],(r.qsa=K.test(n.querySelectorAll))&&(ut(function(e){e.innerHTML="<select><option selected=''></option></select>",e.querySelectorAll("[selected]").length||g.push("\\["+P+"*(?:value|"+B+")"),e.querySelectorAll(":checked").length||g.push(":checked")}),ut(function(e){var t=n.createElement("input");t.setAttribute("type","hidden"),e.appendChild(t).setAttribute("t",""),e.querySelectorAll("[t^='']").length&&g.push("[*^$]="+P+"*(?:''|\"\")"),e.querySelectorAll(":enabled").length||g.push(":enabled",":disabled"),e.querySelectorAll("*,:x"),g.push(",.*:")})),(r.matchesSelector=K.test(y=d.webkitMatchesSelector||d.mozMatchesSelector||d.oMatchesSelector||d.msMatchesSelector))&&ut(function(e){r.disconnectedMatch=y.call(e,"div"),y.call(e,"[s!='']:x"),m.push("!=",I)}),g=g.length&&RegExp(g.join("|")),m=m.length&&RegExp(m.join("|")),v=K.test(d.contains)||d.compareDocumentPosition?function(e,t){var n=9===e.nodeType?e.documentElement:e,r=t&&t.parentNode;return e===r||!(!r||1!==r.nodeType||!(n.contains?n.contains(r):e.compareDocumentPosition&&16&e.compareDocumentPosition(r)))}:function(e,t){if(t)while(t=t.parentNode)if(t===e)return!0;return!1},A=d.compareDocumentPosition?function(e,t){if(e===t)return S=!0,0;var i=t.compareDocumentPosition&&e.compareDocumentPosition&&e.compareDocumentPosition(t);return i?1&i||!r.sortDetached&&t.compareDocumentPosition(e)===i?e===n||v(w,e)?-1:t===n||v(w,t)?1:c?F.call(c,e)-F.call(c,t):0:4&i?-1:1:e.compareDocumentPosition?-1:1}:function(e,t){var r,i=0,o=e.parentNode,a=t.parentNode,s=[e],l=[t];if(e===t)return S=!0,0;if(!o||!a)return e===n?-1:t===n?1:o?-1:a?1:c?F.call(c,e)-F.call(c,t):0;if(o===a)return pt(e,t);r=e;while(r=r.parentNode)s.unshift(r);r=t;while(r=r.parentNode)l.unshift(r);while(s[i]===l[i])i++;return i?pt(s[i],l[i]):s[i]===w?-1:l[i]===w?1:0},n):f},at.matches=function(e,t){return at(e,null,null,t)},at.matchesSelector=function(e,t){if((e.ownerDocument||e)!==f&&p(e),t=t.replace(Y,"='$1']"),!(!r.matchesSelector||!h||m&&m.test(t)||g&&g.test(t)))try{var n=y.call(e,t);if(n||r.disconnectedMatch||e.document&&11!==e.document.nodeType)return n}catch(i){}return at(t,f,null,[e]).length>0},at.contains=function(e,t){return(e.ownerDocument||e)!==f&&p(e),v(e,t)},at.attr=function(e,n){(e.ownerDocument||e)!==f&&p(e);var i=o.attrHandle[n.toLowerCase()],a=i&&L.call(o.attrHandle,n.toLowerCase())?i(e,n,!h):t;return a===t?r.attributes||!h?e.getAttribute(n):(a=e.getAttributeNode(n))&&a.specified?a.value:null:a},at.error=function(e){throw Error("Syntax error, unrecognized expression: "+e)},at.uniqueSort=function(e){var t,n=[],i=0,o=0;if(S=!r.detectDuplicates,c=!r.sortStable&&e.slice(0),e.sort(A),S){while(t=e[o++])t===e[o]&&(i=n.push(o));while(i--)e.splice(n[i],1)}return e},a=at.getText=function(e){var t,n="",r=0,i=e.nodeType;if(i){if(1===i||9===i||11===i){if("string"==typeof e.textContent)return e.textContent;for(e=e.firstChild;e;e=e.nextSibling)n+=a(e)}else if(3===i||4===i)return e.nodeValue}else for(;t=e[r];r++)n+=a(t);return n},o=at.selectors={cacheLength:50,createPseudo:lt,match:Q,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(e){return e[1]=e[1].replace(rt,it),e[3]=(e[4]||e[5]||"").replace(rt,it),"~="===e[2]&&(e[3]=" "+e[3]+" "),e.slice(0,4)},CHILD:function(e){return e[1]=e[1].toLowerCase(),"nth"===e[1].slice(0,3)?(e[3]||at.error(e[0]),e[4]=+(e[4]?e[5]+(e[6]||1):2*("even"===e[3]||"odd"===e[3])),e[5]=+(e[7]+e[8]||"odd"===e[3])):e[3]&&at.error(e[0]),e},PSEUDO:function(e){var n,r=!e[5]&&e[2];return Q.CHILD.test(e[0])?null:(e[3]&&e[4]!==t?e[2]=e[4]:r&&J.test(r)&&(n=mt(r,!0))&&(n=r.indexOf(")",r.length-n)-r.length)&&(e[0]=e[0].slice(0,n),e[2]=r.slice(0,n)),e.slice(0,3))}},filter:{TAG:function(e){var t=e.replace(rt,it).toLowerCase();return"*"===e?function(){return!0}:function(e){return e.nodeName&&e.nodeName.toLowerCase()===t}},CLASS:function(e){var t=N[e+" "];return t||(t=RegExp("(^|"+P+")"+e+"("+P+"|$)"))&&N(e,function(e){return t.test("string"==typeof e.className&&e.className||typeof e.getAttribute!==j&&e.getAttribute("class")||"")})},ATTR:function(e,t,n){return function(r){var i=at.attr(r,e);return null==i?"!="===t:t?(i+="","="===t?i===n:"!="===t?i!==n:"^="===t?n&&0===i.indexOf(n):"*="===t?n&&i.indexOf(n)>-1:"$="===t?n&&i.slice(-n.length)===n:"~="===t?(" "+i+" ").indexOf(n)>-1:"|="===t?i===n||i.slice(0,n.length+1)===n+"-":!1):!0}},CHILD:function(e,t,n,r,i){var o="nth"!==e.slice(0,3),a="last"!==e.slice(-4),s="of-type"===t;return 1===r&&0===i?function(e){return!!e.parentNode}:function(t,n,l){var u,c,p,f,d,h,g=o!==a?"nextSibling":"previousSibling",m=t.parentNode,y=s&&t.nodeName.toLowerCase(),v=!l&&!s;if(m){if(o){while(g){p=t;while(p=p[g])if(s?p.nodeName.toLowerCase()===y:1===p.nodeType)return!1;h=g="only"===e&&!h&&"nextSibling"}return!0}if(h=[a?m.firstChild:m.lastChild],a&&v){c=m[b]||(m[b]={}),u=c[e]||[],d=u[0]===T&&u[1],f=u[0]===T&&u[2],p=d&&m.childNodes[d];while(p=++d&&p&&p[g]||(f=d=0)||h.pop())if(1===p.nodeType&&++f&&p===t){c[e]=[T,d,f];break}}else if(v&&(u=(t[b]||(t[b]={}))[e])&&u[0]===T)f=u[1];else while(p=++d&&p&&p[g]||(f=d=0)||h.pop())if((s?p.nodeName.toLowerCase()===y:1===p.nodeType)&&++f&&(v&&((p[b]||(p[b]={}))[e]=[T,f]),p===t))break;return f-=i,f===r||0===f%r&&f/r>=0}}},PSEUDO:function(e,t){var n,r=o.pseudos[e]||o.setFilters[e.toLowerCase()]||at.error("unsupported pseudo: "+e);return r[b]?r(t):r.length>1?(n=[e,e,"",t],o.setFilters.hasOwnProperty(e.toLowerCase())?lt(function(e,n){var i,o=r(e,t),a=o.length;while(a--)i=F.call(e,o[a]),e[i]=!(n[i]=o[a])}):function(e){return r(e,0,n)}):r}},pseudos:{not:lt(function(e){var t=[],n=[],r=l(e.replace(z,"$1"));return r[b]?lt(function(e,t,n,i){var o,a=r(e,null,i,[]),s=e.length;while(s--)(o=a[s])&&(e[s]=!(t[s]=o))}):function(e,i,o){return t[0]=e,r(t,null,o,n),!n.pop()}}),has:lt(function(e){return function(t){return at(e,t).length>0}}),contains:lt(function(e){return function(t){return(t.textContent||t.innerText||a(t)).indexOf(e)>-1}}),lang:lt(function(e){return G.test(e||"")||at.error("unsupported lang: "+e),e=e.replace(rt,it).toLowerCase(),function(t){var n;do if(n=h?t.lang:t.getAttribute("xml:lang")||t.getAttribute("lang"))return n=n.toLowerCase(),n===e||0===n.indexOf(e+"-");while((t=t.parentNode)&&1===t.nodeType);return!1}}),target:function(t){var n=e.location&&e.location.hash;return n&&n.slice(1)===t.id},root:function(e){return e===d},focus:function(e){return e===f.activeElement&&(!f.hasFocus||f.hasFocus())&&!!(e.type||e.href||~e.tabIndex)},enabled:function(e){return e.disabled===!1},disabled:function(e){return e.disabled===!0},checked:function(e){var t=e.nodeName.toLowerCase();return"input"===t&&!!e.checked||"option"===t&&!!e.selected},selected:function(e){return e.parentNode&&e.parentNode.selectedIndex,e.selected===!0},empty:function(e){for(e=e.firstChild;e;e=e.nextSibling)if(e.nodeName>"@"||3===e.nodeType||4===e.nodeType)return!1;return!0},parent:function(e){return!o.pseudos.empty(e)},header:function(e){return tt.test(e.nodeName)},input:function(e){return et.test(e.nodeName)},button:function(e){var t=e.nodeName.toLowerCase();return"input"===t&&"button"===e.type||"button"===t},text:function(e){var t;return"input"===e.nodeName.toLowerCase()&&"text"===e.type&&(null==(t=e.getAttribute("type"))||t.toLowerCase()===e.type)},first:ht(function(){return[0]}),last:ht(function(e,t){return[t-1]}),eq:ht(function(e,t,n){return[0>n?n+t:n]}),even:ht(function(e,t){var n=0;for(;t>n;n+=2)e.push(n);return e}),odd:ht(function(e,t){var n=1;for(;t>n;n+=2)e.push(n);return e}),lt:ht(function(e,t,n){var r=0>n?n+t:n;for(;--r>=0;)e.push(r);return e}),gt:ht(function(e,t,n){var r=0>n?n+t:n;for(;t>++r;)e.push(r);return e})}},o.pseudos.nth=o.pseudos.eq;for(n in{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})o.pseudos[n]=ft(n);for(n in{submit:!0,reset:!0})o.pseudos[n]=dt(n);function gt(){}gt.prototype=o.filters=o.pseudos,o.setFilters=new gt;function mt(e,t){var n,r,i,a,s,l,u,c=k[e+" "];if(c)return t?0:c.slice(0);s=e,l=[],u=o.preFilter;while(s){(!n||(r=X.exec(s)))&&(r&&(s=s.slice(r[0].length)||s),l.push(i=[])),n=!1,(r=U.exec(s))&&(n=r.shift(),i.push({value:n,type:r[0].replace(z," ")}),s=s.slice(n.length));for(a in o.filter)!(r=Q[a].exec(s))||u[a]&&!(r=u[a](r))||(n=r.shift(),i.push({value:n,type:a,matches:r}),s=s.slice(n.length));if(!n)break}return t?s.length:s?at.error(e):k(e,l).slice(0)}function yt(e){var t=0,n=e.length,r="";for(;n>t;t++)r+=e[t].value;return r}function vt(e,t,n){var r=t.dir,o=n&&"parentNode"===r,a=C++;return t.first?function(t,n,i){while(t=t[r])if(1===t.nodeType||o)return e(t,n,i)}:function(t,n,s){var l,u,c,p=T+" "+a;if(s){while(t=t[r])if((1===t.nodeType||o)&&e(t,n,s))return!0}else while(t=t[r])if(1===t.nodeType||o)if(c=t[b]||(t[b]={}),(u=c[r])&&u[0]===p){if((l=u[1])===!0||l===i)return l===!0}else if(u=c[r]=[p],u[1]=e(t,n,s)||i,u[1]===!0)return!0}}function bt(e){return e.length>1?function(t,n,r){var i=e.length;while(i--)if(!e[i](t,n,r))return!1;return!0}:e[0]}function xt(e,t,n,r,i){var o,a=[],s=0,l=e.length,u=null!=t;for(;l>s;s++)(o=e[s])&&(!n||n(o,r,i))&&(a.push(o),u&&t.push(s));return a}function wt(e,t,n,r,i,o){return r&&!r[b]&&(r=wt(r)),i&&!i[b]&&(i=wt(i,o)),lt(function(o,a,s,l){var u,c,p,f=[],d=[],h=a.length,g=o||Nt(t||"*",s.nodeType?[s]:s,[]),m=!e||!o&&t?g:xt(g,f,e,s,l),y=n?i||(o?e:h||r)?[]:a:m;if(n&&n(m,y,s,l),r){u=xt(y,d),r(u,[],s,l),c=u.length;while(c--)(p=u[c])&&(y[d[c]]=!(m[d[c]]=p))}if(o){if(i||e){if(i){u=[],c=y.length;while(c--)(p=y[c])&&u.push(m[c]=p);i(null,y=[],u,l)}c=y.length;while(c--)(p=y[c])&&(u=i?F.call(o,p):f[c])>-1&&(o[u]=!(a[u]=p))}}else y=xt(y===a?y.splice(h,y.length):y),i?i(null,a,y,l):M.apply(a,y)})}function Tt(e){var t,n,r,i=e.length,a=o.relative[e[0].type],s=a||o.relative[" "],l=a?1:0,c=vt(function(e){return e===t},s,!0),p=vt(function(e){return F.call(t,e)>-1},s,!0),f=[function(e,n,r){return!a&&(r||n!==u)||((t=n).nodeType?c(e,n,r):p(e,n,r))}];for(;i>l;l++)if(n=o.relative[e[l].type])f=[vt(bt(f),n)];else{if(n=o.filter[e[l].type].apply(null,e[l].matches),n[b]){for(r=++l;i>r;r++)if(o.relative[e[r].type])break;return wt(l>1&&bt(f),l>1&&yt(e.slice(0,l-1).concat({value:" "===e[l-2].type?"*":""})).replace(z,"$1"),n,r>l&&Tt(e.slice(l,r)),i>r&&Tt(e=e.slice(r)),i>r&&yt(e))}f.push(n)}return bt(f)}function Ct(e,t){var n=0,r=t.length>0,a=e.length>0,s=function(s,l,c,p,d){var h,g,m,y=[],v=0,b="0",x=s&&[],w=null!=d,C=u,N=s||a&&o.find.TAG("*",d&&l.parentNode||l),k=T+=null==C?1:Math.random()||.1;for(w&&(u=l!==f&&l,i=n);null!=(h=N[b]);b++){if(a&&h){g=0;while(m=e[g++])if(m(h,l,c)){p.push(h);break}w&&(T=k,i=++n)}r&&((h=!m&&h)&&v--,s&&x.push(h))}if(v+=b,r&&b!==v){g=0;while(m=t[g++])m(x,y,l,c);if(s){if(v>0)while(b--)x[b]||y[b]||(y[b]=q.call(p));y=xt(y)}M.apply(p,y),w&&!s&&y.length>0&&v+t.length>1&&at.uniqueSort(p)}return w&&(T=k,u=C),x};return r?lt(s):s}l=at.compile=function(e,t){var n,r=[],i=[],o=E[e+" "];if(!o){t||(t=mt(e)),n=t.length;while(n--)o=Tt(t[n]),o[b]?r.push(o):i.push(o);o=E(e,Ct(i,r))}return o};function Nt(e,t,n){var r=0,i=t.length;for(;i>r;r++)at(e,t[r],n);return n}function kt(e,t,n,i){var a,s,u,c,p,f=mt(e);if(!i&&1===f.length){if(s=f[0]=f[0].slice(0),s.length>2&&"ID"===(u=s[0]).type&&r.getById&&9===t.nodeType&&h&&o.relative[s[1].type]){if(t=(o.find.ID(u.matches[0].replace(rt,it),t)||[])[0],!t)return n;e=e.slice(s.shift().value.length)}a=Q.needsContext.test(e)?0:s.length;while(a--){if(u=s[a],o.relative[c=u.type])break;if((p=o.find[c])&&(i=p(u.matches[0].replace(rt,it),V.test(s[0].type)&&t.parentNode||t))){if(s.splice(a,1),e=i.length&&yt(s),!e)return M.apply(n,i),n;break}}}return l(e,f)(i,t,!h,n,V.test(e)),n}r.sortStable=b.split("").sort(A).join("")===b,r.detectDuplicates=S,p(),r.sortDetached=ut(function(e){return 1&e.compareDocumentPosition(f.createElement("div"))}),ut(function(e){return e.innerHTML="<a href='#'></a>","#"===e.firstChild.getAttribute("href")})||ct("type|href|height|width",function(e,n,r){return r?t:e.getAttribute(n,"type"===n.toLowerCase()?1:2)}),r.attributes&&ut(function(e){return e.innerHTML="<input/>",e.firstChild.setAttribute("value",""),""===e.firstChild.getAttribute("value")})||ct("value",function(e,n,r){return r||"input"!==e.nodeName.toLowerCase()?t:e.defaultValue}),ut(function(e){return null==e.getAttribute("disabled")})||ct(B,function(e,n,r){var i;return r?t:(i=e.getAttributeNode(n))&&i.specified?i.value:e[n]===!0?n.toLowerCase():null}),x.find=at,x.expr=at.selectors,x.expr[":"]=x.expr.pseudos,x.unique=at.uniqueSort,x.text=at.getText,x.isXMLDoc=at.isXML,x.contains=at.contains}(e);var O={};function F(e){var t=O[e]={};return x.each(e.match(T)||[],function(e,n){t[n]=!0}),t}x.Callbacks=function(e){e="string"==typeof e?O[e]||F(e):x.extend({},e);var n,r,i,o,a,s,l=[],u=!e.once&&[],c=function(t){for(r=e.memory&&t,i=!0,a=s||0,s=0,o=l.length,n=!0;l&&o>a;a++)if(l[a].apply(t[0],t[1])===!1&&e.stopOnFalse){r=!1;break}n=!1,l&&(u?u.length&&c(u.shift()):r?l=[]:p.disable())},p={add:function(){if(l){var t=l.length;(function i(t){x.each(t,function(t,n){var r=x.type(n);"function"===r?e.unique&&p.has(n)||l.push(n):n&&n.length&&"string"!==r&&i(n)})})(arguments),n?o=l.length:r&&(s=t,c(r))}return this},remove:function(){return l&&x.each(arguments,function(e,t){var r;while((r=x.inArray(t,l,r))>-1)l.splice(r,1),n&&(o>=r&&o--,a>=r&&a--)}),this},has:function(e){return e?x.inArray(e,l)>-1:!(!l||!l.length)},empty:function(){return l=[],o=0,this},disable:function(){return l=u=r=t,this},disabled:function(){return!l},lock:function(){return u=t,r||p.disable(),this},locked:function(){return!u},fireWith:function(e,t){return!l||i&&!u||(t=t||[],t=[e,t.slice?t.slice():t],n?u.push(t):c(t)),this},fire:function(){return p.fireWith(this,arguments),this},fired:function(){return!!i}};return p},x.extend({Deferred:function(e){var t=[["resolve","done",x.Callbacks("once memory"),"resolved"],["reject","fail",x.Callbacks("once memory"),"rejected"],["notify","progress",x.Callbacks("memory")]],n="pending",r={state:function(){return n},always:function(){return i.done(arguments).fail(arguments),this},then:function(){var e=arguments;return x.Deferred(function(n){x.each(t,function(t,o){var a=o[0],s=x.isFunction(e[t])&&e[t];i[o[1]](function(){var e=s&&s.apply(this,arguments);e&&x.isFunction(e.promise)?e.promise().done(n.resolve).fail(n.reject).progress(n.notify):n[a+"With"](this===r?n.promise():this,s?[e]:arguments)})}),e=null}).promise()},promise:function(e){return null!=e?x.extend(e,r):r}},i={};return r.pipe=r.then,x.each(t,function(e,o){var a=o[2],s=o[3];r[o[1]]=a.add,s&&a.add(function(){n=s},t[1^e][2].disable,t[2][2].lock),i[o[0]]=function(){return i[o[0]+"With"](this===i?r:this,arguments),this},i[o[0]+"With"]=a.fireWith}),r.promise(i),e&&e.call(i,i),i},when:function(e){var t=0,n=g.call(arguments),r=n.length,i=1!==r||e&&x.isFunction(e.promise)?r:0,o=1===i?e:x.Deferred(),a=function(e,t,n){return function(r){t[e]=this,n[e]=arguments.length>1?g.call(arguments):r,n===s?o.notifyWith(t,n):--i||o.resolveWith(t,n)}},s,l,u;if(r>1)for(s=Array(r),l=Array(r),u=Array(r);r>t;t++)n[t]&&x.isFunction(n[t].promise)?n[t].promise().done(a(t,u,n)).fail(o.reject).progress(a(t,l,s)):--i;return i||o.resolveWith(u,n),o.promise()}}),x.support=function(t){var n,r,o,s,l,u,c,p,f,d=a.createElement("div");if(d.setAttribute("className","t"),d.innerHTML="  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>",n=d.getElementsByTagName("*")||[],r=d.getElementsByTagName("a")[0],!r||!r.style||!n.length)return t;s=a.createElement("select"),u=s.appendChild(a.createElement("option")),o=d.getElementsByTagName("input")[0],r.style.cssText="top:1px;float:left;opacity:.5",t.getSetAttribute="t"!==d.className,t.leadingWhitespace=3===d.firstChild.nodeType,t.tbody=!d.getElementsByTagName("tbody").length,t.htmlSerialize=!!d.getElementsByTagName("link").length,t.style=/top/.test(r.getAttribute("style")),t.hrefNormalized="/a"===r.getAttribute("href"),t.opacity=/^0.5/.test(r.style.opacity),t.cssFloat=!!r.style.cssFloat,t.checkOn=!!o.value,t.optSelected=u.selected,t.enctype=!!a.createElement("form").enctype,t.html5Clone="<:nav></:nav>"!==a.createElement("nav").cloneNode(!0).outerHTML,t.inlineBlockNeedsLayout=!1,t.shrinkWrapBlocks=!1,t.pixelPosition=!1,t.deleteExpando=!0,t.noCloneEvent=!0,t.reliableMarginRight=!0,t.boxSizingReliable=!0,o.checked=!0,t.noCloneChecked=o.cloneNode(!0).checked,s.disabled=!0,t.optDisabled=!u.disabled;try{delete d.test}catch(h){t.deleteExpando=!1}o=a.createElement("input"),o.setAttribute("value",""),t.input=""===o.getAttribute("value"),o.value="t",o.setAttribute("type","radio"),t.radioValue="t"===o.value,o.setAttribute("checked","t"),o.setAttribute("name","t"),l=a.createDocumentFragment(),l.appendChild(o),t.appendChecked=o.checked,t.checkClone=l.cloneNode(!0).cloneNode(!0).lastChild.checked,d.attachEvent&&(d.attachEvent("onclick",function(){t.noCloneEvent=!1}),d.cloneNode(!0).click());for(f in{submit:!0,change:!0,focusin:!0})d.setAttribute(c="on"+f,"t"),t[f+"Bubbles"]=c in e||d.attributes[c].expando===!1;d.style.backgroundClip="content-box",d.cloneNode(!0).style.backgroundClip="",t.clearCloneStyle="content-box"===d.style.backgroundClip;for(f in x(t))break;return t.ownLast="0"!==f,x(function(){var n,r,o,s="padding:0;margin:0;border:0;display:block;box-sizing:content-box;-moz-box-sizing:content-box;-webkit-box-sizing:content-box;",l=a.getElementsByTagName("body")[0];l&&(n=a.createElement("div"),n.style.cssText="border:0;width:0;height:0;position:absolute;top:0;left:-9999px;margin-top:1px",l.appendChild(n).appendChild(d),d.innerHTML="<table><tr><td></td><td>t</td></tr></table>",o=d.getElementsByTagName("td"),o[0].style.cssText="padding:0;margin:0;border:0;display:none",p=0===o[0].offsetHeight,o[0].style.display="",o[1].style.display="none",t.reliableHiddenOffsets=p&&0===o[0].offsetHeight,d.innerHTML="",d.style.cssText="box-sizing:border-box;-moz-box-sizing:border-box;-webkit-box-sizing:border-box;padding:1px;border:1px;display:block;width:4px;margin-top:1%;position:absolute;top:1%;",x.swap(l,null!=l.style.zoom?{zoom:1}:{},function(){t.boxSizing=4===d.offsetWidth}),e.getComputedStyle&&(t.pixelPosition="1%"!==(e.getComputedStyle(d,null)||{}).top,t.boxSizingReliable="4px"===(e.getComputedStyle(d,null)||{width:"4px"}).width,r=d.appendChild(a.createElement("div")),r.style.cssText=d.style.cssText=s,r.style.marginRight=r.style.width="0",d.style.width="1px",t.reliableMarginRight=!parseFloat((e.getComputedStyle(r,null)||{}).marginRight)),typeof d.style.zoom!==i&&(d.innerHTML="",d.style.cssText=s+"width:1px;padding:1px;display:inline;zoom:1",t.inlineBlockNeedsLayout=3===d.offsetWidth,d.style.display="block",d.innerHTML="<div></div>",d.firstChild.style.width="5px",t.shrinkWrapBlocks=3!==d.offsetWidth,t.inlineBlockNeedsLayout&&(l.style.zoom=1)),l.removeChild(n),n=d=o=r=null)}),n=s=l=u=r=o=null,t
}({});var B=/(?:\{[\s\S]*\}|\[[\s\S]*\])$/,P=/([A-Z])/g;function R(e,n,r,i){if(x.acceptData(e)){var o,a,s=x.expando,l=e.nodeType,u=l?x.cache:e,c=l?e[s]:e[s]&&s;if(c&&u[c]&&(i||u[c].data)||r!==t||"string"!=typeof n)return c||(c=l?e[s]=p.pop()||x.guid++:s),u[c]||(u[c]=l?{}:{toJSON:x.noop}),("object"==typeof n||"function"==typeof n)&&(i?u[c]=x.extend(u[c],n):u[c].data=x.extend(u[c].data,n)),a=u[c],i||(a.data||(a.data={}),a=a.data),r!==t&&(a[x.camelCase(n)]=r),"string"==typeof n?(o=a[n],null==o&&(o=a[x.camelCase(n)])):o=a,o}}function W(e,t,n){if(x.acceptData(e)){var r,i,o=e.nodeType,a=o?x.cache:e,s=o?e[x.expando]:x.expando;if(a[s]){if(t&&(r=n?a[s]:a[s].data)){x.isArray(t)?t=t.concat(x.map(t,x.camelCase)):t in r?t=[t]:(t=x.camelCase(t),t=t in r?[t]:t.split(" ")),i=t.length;while(i--)delete r[t[i]];if(n?!I(r):!x.isEmptyObject(r))return}(n||(delete a[s].data,I(a[s])))&&(o?x.cleanData([e],!0):x.support.deleteExpando||a!=a.window?delete a[s]:a[s]=null)}}}x.extend({cache:{},noData:{applet:!0,embed:!0,object:"clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"},hasData:function(e){return e=e.nodeType?x.cache[e[x.expando]]:e[x.expando],!!e&&!I(e)},data:function(e,t,n){return R(e,t,n)},removeData:function(e,t){return W(e,t)},_data:function(e,t,n){return R(e,t,n,!0)},_removeData:function(e,t){return W(e,t,!0)},acceptData:function(e){if(e.nodeType&&1!==e.nodeType&&9!==e.nodeType)return!1;var t=e.nodeName&&x.noData[e.nodeName.toLowerCase()];return!t||t!==!0&&e.getAttribute("classid")===t}}),x.fn.extend({data:function(e,n){var r,i,o=null,a=0,s=this[0];if(e===t){if(this.length&&(o=x.data(s),1===s.nodeType&&!x._data(s,"parsedAttrs"))){for(r=s.attributes;r.length>a;a++)i=r[a].name,0===i.indexOf("data-")&&(i=x.camelCase(i.slice(5)),$(s,i,o[i]));x._data(s,"parsedAttrs",!0)}return o}return"object"==typeof e?this.each(function(){x.data(this,e)}):arguments.length>1?this.each(function(){x.data(this,e,n)}):s?$(s,e,x.data(s,e)):null},removeData:function(e){return this.each(function(){x.removeData(this,e)})}});function $(e,n,r){if(r===t&&1===e.nodeType){var i="data-"+n.replace(P,"-$1").toLowerCase();if(r=e.getAttribute(i),"string"==typeof r){try{r="true"===r?!0:"false"===r?!1:"null"===r?null:+r+""===r?+r:B.test(r)?x.parseJSON(r):r}catch(o){}x.data(e,n,r)}else r=t}return r}function I(e){var t;for(t in e)if(("data"!==t||!x.isEmptyObject(e[t]))&&"toJSON"!==t)return!1;return!0}x.extend({queue:function(e,n,r){var i;return e?(n=(n||"fx")+"queue",i=x._data(e,n),r&&(!i||x.isArray(r)?i=x._data(e,n,x.makeArray(r)):i.push(r)),i||[]):t},dequeue:function(e,t){t=t||"fx";var n=x.queue(e,t),r=n.length,i=n.shift(),o=x._queueHooks(e,t),a=function(){x.dequeue(e,t)};"inprogress"===i&&(i=n.shift(),r--),i&&("fx"===t&&n.unshift("inprogress"),delete o.stop,i.call(e,a,o)),!r&&o&&o.empty.fire()},_queueHooks:function(e,t){var n=t+"queueHooks";return x._data(e,n)||x._data(e,n,{empty:x.Callbacks("once memory").add(function(){x._removeData(e,t+"queue"),x._removeData(e,n)})})}}),x.fn.extend({queue:function(e,n){var r=2;return"string"!=typeof e&&(n=e,e="fx",r--),r>arguments.length?x.queue(this[0],e):n===t?this:this.each(function(){var t=x.queue(this,e,n);x._queueHooks(this,e),"fx"===e&&"inprogress"!==t[0]&&x.dequeue(this,e)})},dequeue:function(e){return this.each(function(){x.dequeue(this,e)})},delay:function(e,t){return e=x.fx?x.fx.speeds[e]||e:e,t=t||"fx",this.queue(t,function(t,n){var r=setTimeout(t,e);n.stop=function(){clearTimeout(r)}})},clearQueue:function(e){return this.queue(e||"fx",[])},promise:function(e,n){var r,i=1,o=x.Deferred(),a=this,s=this.length,l=function(){--i||o.resolveWith(a,[a])};"string"!=typeof e&&(n=e,e=t),e=e||"fx";while(s--)r=x._data(a[s],e+"queueHooks"),r&&r.empty&&(i++,r.empty.add(l));return l(),o.promise(n)}});var z,X,U=/[\t\r\n\f]/g,V=/\r/g,Y=/^(?:input|select|textarea|button|object)$/i,J=/^(?:a|area)$/i,G=/^(?:checked|selected)$/i,Q=x.support.getSetAttribute,K=x.support.input;x.fn.extend({attr:function(e,t){return x.access(this,x.attr,e,t,arguments.length>1)},removeAttr:function(e){return this.each(function(){x.removeAttr(this,e)})},prop:function(e,t){return x.access(this,x.prop,e,t,arguments.length>1)},removeProp:function(e){return e=x.propFix[e]||e,this.each(function(){try{this[e]=t,delete this[e]}catch(n){}})},addClass:function(e){var t,n,r,i,o,a=0,s=this.length,l="string"==typeof e&&e;if(x.isFunction(e))return this.each(function(t){x(this).addClass(e.call(this,t,this.className))});if(l)for(t=(e||"").match(T)||[];s>a;a++)if(n=this[a],r=1===n.nodeType&&(n.className?(" "+n.className+" ").replace(U," "):" ")){o=0;while(i=t[o++])0>r.indexOf(" "+i+" ")&&(r+=i+" ");n.className=x.trim(r)}return this},removeClass:function(e){var t,n,r,i,o,a=0,s=this.length,l=0===arguments.length||"string"==typeof e&&e;if(x.isFunction(e))return this.each(function(t){x(this).removeClass(e.call(this,t,this.className))});if(l)for(t=(e||"").match(T)||[];s>a;a++)if(n=this[a],r=1===n.nodeType&&(n.className?(" "+n.className+" ").replace(U," "):"")){o=0;while(i=t[o++])while(r.indexOf(" "+i+" ")>=0)r=r.replace(" "+i+" "," ");n.className=e?x.trim(r):""}return this},toggleClass:function(e,t){var n=typeof e;return"boolean"==typeof t&&"string"===n?t?this.addClass(e):this.removeClass(e):x.isFunction(e)?this.each(function(n){x(this).toggleClass(e.call(this,n,this.className,t),t)}):this.each(function(){if("string"===n){var t,r=0,o=x(this),a=e.match(T)||[];while(t=a[r++])o.hasClass(t)?o.removeClass(t):o.addClass(t)}else(n===i||"boolean"===n)&&(this.className&&x._data(this,"__className__",this.className),this.className=this.className||e===!1?"":x._data(this,"__className__")||"")})},hasClass:function(e){var t=" "+e+" ",n=0,r=this.length;for(;r>n;n++)if(1===this[n].nodeType&&(" "+this[n].className+" ").replace(U," ").indexOf(t)>=0)return!0;return!1},val:function(e){var n,r,i,o=this[0];{if(arguments.length)return i=x.isFunction(e),this.each(function(n){var o;1===this.nodeType&&(o=i?e.call(this,n,x(this).val()):e,null==o?o="":"number"==typeof o?o+="":x.isArray(o)&&(o=x.map(o,function(e){return null==e?"":e+""})),r=x.valHooks[this.type]||x.valHooks[this.nodeName.toLowerCase()],r&&"set"in r&&r.set(this,o,"value")!==t||(this.value=o))});if(o)return r=x.valHooks[o.type]||x.valHooks[o.nodeName.toLowerCase()],r&&"get"in r&&(n=r.get(o,"value"))!==t?n:(n=o.value,"string"==typeof n?n.replace(V,""):null==n?"":n)}}}),x.extend({valHooks:{option:{get:function(e){var t=x.find.attr(e,"value");return null!=t?t:e.text}},select:{get:function(e){var t,n,r=e.options,i=e.selectedIndex,o="select-one"===e.type||0>i,a=o?null:[],s=o?i+1:r.length,l=0>i?s:o?i:0;for(;s>l;l++)if(n=r[l],!(!n.selected&&l!==i||(x.support.optDisabled?n.disabled:null!==n.getAttribute("disabled"))||n.parentNode.disabled&&x.nodeName(n.parentNode,"optgroup"))){if(t=x(n).val(),o)return t;a.push(t)}return a},set:function(e,t){var n,r,i=e.options,o=x.makeArray(t),a=i.length;while(a--)r=i[a],(r.selected=x.inArray(x(r).val(),o)>=0)&&(n=!0);return n||(e.selectedIndex=-1),o}}},attr:function(e,n,r){var o,a,s=e.nodeType;if(e&&3!==s&&8!==s&&2!==s)return typeof e.getAttribute===i?x.prop(e,n,r):(1===s&&x.isXMLDoc(e)||(n=n.toLowerCase(),o=x.attrHooks[n]||(x.expr.match.bool.test(n)?X:z)),r===t?o&&"get"in o&&null!==(a=o.get(e,n))?a:(a=x.find.attr(e,n),null==a?t:a):null!==r?o&&"set"in o&&(a=o.set(e,r,n))!==t?a:(e.setAttribute(n,r+""),r):(x.removeAttr(e,n),t))},removeAttr:function(e,t){var n,r,i=0,o=t&&t.match(T);if(o&&1===e.nodeType)while(n=o[i++])r=x.propFix[n]||n,x.expr.match.bool.test(n)?K&&Q||!G.test(n)?e[r]=!1:e[x.camelCase("default-"+n)]=e[r]=!1:x.attr(e,n,""),e.removeAttribute(Q?n:r)},attrHooks:{type:{set:function(e,t){if(!x.support.radioValue&&"radio"===t&&x.nodeName(e,"input")){var n=e.value;return e.setAttribute("type",t),n&&(e.value=n),t}}}},propFix:{"for":"htmlFor","class":"className"},prop:function(e,n,r){var i,o,a,s=e.nodeType;if(e&&3!==s&&8!==s&&2!==s)return a=1!==s||!x.isXMLDoc(e),a&&(n=x.propFix[n]||n,o=x.propHooks[n]),r!==t?o&&"set"in o&&(i=o.set(e,r,n))!==t?i:e[n]=r:o&&"get"in o&&null!==(i=o.get(e,n))?i:e[n]},propHooks:{tabIndex:{get:function(e){var t=x.find.attr(e,"tabindex");return t?parseInt(t,10):Y.test(e.nodeName)||J.test(e.nodeName)&&e.href?0:-1}}}}),X={set:function(e,t,n){return t===!1?x.removeAttr(e,n):K&&Q||!G.test(n)?e.setAttribute(!Q&&x.propFix[n]||n,n):e[x.camelCase("default-"+n)]=e[n]=!0,n}},x.each(x.expr.match.bool.source.match(/\w+/g),function(e,n){var r=x.expr.attrHandle[n]||x.find.attr;x.expr.attrHandle[n]=K&&Q||!G.test(n)?function(e,n,i){var o=x.expr.attrHandle[n],a=i?t:(x.expr.attrHandle[n]=t)!=r(e,n,i)?n.toLowerCase():null;return x.expr.attrHandle[n]=o,a}:function(e,n,r){return r?t:e[x.camelCase("default-"+n)]?n.toLowerCase():null}}),K&&Q||(x.attrHooks.value={set:function(e,n,r){return x.nodeName(e,"input")?(e.defaultValue=n,t):z&&z.set(e,n,r)}}),Q||(z={set:function(e,n,r){var i=e.getAttributeNode(r);return i||e.setAttributeNode(i=e.ownerDocument.createAttribute(r)),i.value=n+="","value"===r||n===e.getAttribute(r)?n:t}},x.expr.attrHandle.id=x.expr.attrHandle.name=x.expr.attrHandle.coords=function(e,n,r){var i;return r?t:(i=e.getAttributeNode(n))&&""!==i.value?i.value:null},x.valHooks.button={get:function(e,n){var r=e.getAttributeNode(n);return r&&r.specified?r.value:t},set:z.set},x.attrHooks.contenteditable={set:function(e,t,n){z.set(e,""===t?!1:t,n)}},x.each(["width","height"],function(e,n){x.attrHooks[n]={set:function(e,r){return""===r?(e.setAttribute(n,"auto"),r):t}}})),x.support.hrefNormalized||x.each(["href","src"],function(e,t){x.propHooks[t]={get:function(e){return e.getAttribute(t,4)}}}),x.support.style||(x.attrHooks.style={get:function(e){return e.style.cssText||t},set:function(e,t){return e.style.cssText=t+""}}),x.support.optSelected||(x.propHooks.selected={get:function(e){var t=e.parentNode;return t&&(t.selectedIndex,t.parentNode&&t.parentNode.selectedIndex),null}}),x.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){x.propFix[this.toLowerCase()]=this}),x.support.enctype||(x.propFix.enctype="encoding"),x.each(["radio","checkbox"],function(){x.valHooks[this]={set:function(e,n){return x.isArray(n)?e.checked=x.inArray(x(e).val(),n)>=0:t}},x.support.checkOn||(x.valHooks[this].get=function(e){return null===e.getAttribute("value")?"on":e.value})});var Z=/^(?:input|select|textarea)$/i,et=/^key/,tt=/^(?:mouse|contextmenu)|click/,nt=/^(?:focusinfocus|focusoutblur)$/,rt=/^([^.]*)(?:\.(.+)|)$/;function it(){return!0}function ot(){return!1}function at(){try{return a.activeElement}catch(e){}}x.event={global:{},add:function(e,n,r,o,a){var s,l,u,c,p,f,d,h,g,m,y,v=x._data(e);if(v){r.handler&&(c=r,r=c.handler,a=c.selector),r.guid||(r.guid=x.guid++),(l=v.events)||(l=v.events={}),(f=v.handle)||(f=v.handle=function(e){return typeof x===i||e&&x.event.triggered===e.type?t:x.event.dispatch.apply(f.elem,arguments)},f.elem=e),n=(n||"").match(T)||[""],u=n.length;while(u--)s=rt.exec(n[u])||[],g=y=s[1],m=(s[2]||"").split(".").sort(),g&&(p=x.event.special[g]||{},g=(a?p.delegateType:p.bindType)||g,p=x.event.special[g]||{},d=x.extend({type:g,origType:y,data:o,handler:r,guid:r.guid,selector:a,needsContext:a&&x.expr.match.needsContext.test(a),namespace:m.join(".")},c),(h=l[g])||(h=l[g]=[],h.delegateCount=0,p.setup&&p.setup.call(e,o,m,f)!==!1||(e.addEventListener?e.addEventListener(g,f,!1):e.attachEvent&&e.attachEvent("on"+g,f))),p.add&&(p.add.call(e,d),d.handler.guid||(d.handler.guid=r.guid)),a?h.splice(h.delegateCount++,0,d):h.push(d),x.event.global[g]=!0);e=null}},remove:function(e,t,n,r,i){var o,a,s,l,u,c,p,f,d,h,g,m=x.hasData(e)&&x._data(e);if(m&&(c=m.events)){t=(t||"").match(T)||[""],u=t.length;while(u--)if(s=rt.exec(t[u])||[],d=g=s[1],h=(s[2]||"").split(".").sort(),d){p=x.event.special[d]||{},d=(r?p.delegateType:p.bindType)||d,f=c[d]||[],s=s[2]&&RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"),l=o=f.length;while(o--)a=f[o],!i&&g!==a.origType||n&&n.guid!==a.guid||s&&!s.test(a.namespace)||r&&r!==a.selector&&("**"!==r||!a.selector)||(f.splice(o,1),a.selector&&f.delegateCount--,p.remove&&p.remove.call(e,a));l&&!f.length&&(p.teardown&&p.teardown.call(e,h,m.handle)!==!1||x.removeEvent(e,d,m.handle),delete c[d])}else for(d in c)x.event.remove(e,d+t[u],n,r,!0);x.isEmptyObject(c)&&(delete m.handle,x._removeData(e,"events"))}},trigger:function(n,r,i,o){var s,l,u,c,p,f,d,h=[i||a],g=v.call(n,"type")?n.type:n,m=v.call(n,"namespace")?n.namespace.split("."):[];if(u=f=i=i||a,3!==i.nodeType&&8!==i.nodeType&&!nt.test(g+x.event.triggered)&&(g.indexOf(".")>=0&&(m=g.split("."),g=m.shift(),m.sort()),l=0>g.indexOf(":")&&"on"+g,n=n[x.expando]?n:new x.Event(g,"object"==typeof n&&n),n.isTrigger=o?2:3,n.namespace=m.join("."),n.namespace_re=n.namespace?RegExp("(^|\\.)"+m.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,n.result=t,n.target||(n.target=i),r=null==r?[n]:x.makeArray(r,[n]),p=x.event.special[g]||{},o||!p.trigger||p.trigger.apply(i,r)!==!1)){if(!o&&!p.noBubble&&!x.isWindow(i)){for(c=p.delegateType||g,nt.test(c+g)||(u=u.parentNode);u;u=u.parentNode)h.push(u),f=u;f===(i.ownerDocument||a)&&h.push(f.defaultView||f.parentWindow||e)}d=0;while((u=h[d++])&&!n.isPropagationStopped())n.type=d>1?c:p.bindType||g,s=(x._data(u,"events")||{})[n.type]&&x._data(u,"handle"),s&&s.apply(u,r),s=l&&u[l],s&&x.acceptData(u)&&s.apply&&s.apply(u,r)===!1&&n.preventDefault();if(n.type=g,!o&&!n.isDefaultPrevented()&&(!p._default||p._default.apply(h.pop(),r)===!1)&&x.acceptData(i)&&l&&i[g]&&!x.isWindow(i)){f=i[l],f&&(i[l]=null),x.event.triggered=g;try{i[g]()}catch(y){}x.event.triggered=t,f&&(i[l]=f)}return n.result}},dispatch:function(e){e=x.event.fix(e);var n,r,i,o,a,s=[],l=g.call(arguments),u=(x._data(this,"events")||{})[e.type]||[],c=x.event.special[e.type]||{};if(l[0]=e,e.delegateTarget=this,!c.preDispatch||c.preDispatch.call(this,e)!==!1){s=x.event.handlers.call(this,e,u),n=0;while((o=s[n++])&&!e.isPropagationStopped()){e.currentTarget=o.elem,a=0;while((i=o.handlers[a++])&&!e.isImmediatePropagationStopped())(!e.namespace_re||e.namespace_re.test(i.namespace))&&(e.handleObj=i,e.data=i.data,r=((x.event.special[i.origType]||{}).handle||i.handler).apply(o.elem,l),r!==t&&(e.result=r)===!1&&(e.preventDefault(),e.stopPropagation()))}return c.postDispatch&&c.postDispatch.call(this,e),e.result}},handlers:function(e,n){var r,i,o,a,s=[],l=n.delegateCount,u=e.target;if(l&&u.nodeType&&(!e.button||"click"!==e.type))for(;u!=this;u=u.parentNode||this)if(1===u.nodeType&&(u.disabled!==!0||"click"!==e.type)){for(o=[],a=0;l>a;a++)i=n[a],r=i.selector+" ",o[r]===t&&(o[r]=i.needsContext?x(r,this).index(u)>=0:x.find(r,this,null,[u]).length),o[r]&&o.push(i);o.length&&s.push({elem:u,handlers:o})}return n.length>l&&s.push({elem:this,handlers:n.slice(l)}),s},fix:function(e){if(e[x.expando])return e;var t,n,r,i=e.type,o=e,s=this.fixHooks[i];s||(this.fixHooks[i]=s=tt.test(i)?this.mouseHooks:et.test(i)?this.keyHooks:{}),r=s.props?this.props.concat(s.props):this.props,e=new x.Event(o),t=r.length;while(t--)n=r[t],e[n]=o[n];return e.target||(e.target=o.srcElement||a),3===e.target.nodeType&&(e.target=e.target.parentNode),e.metaKey=!!e.metaKey,s.filter?s.filter(e,o):e},props:"altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),fixHooks:{},keyHooks:{props:"char charCode key keyCode".split(" "),filter:function(e,t){return null==e.which&&(e.which=null!=t.charCode?t.charCode:t.keyCode),e}},mouseHooks:{props:"button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(" "),filter:function(e,n){var r,i,o,s=n.button,l=n.fromElement;return null==e.pageX&&null!=n.clientX&&(i=e.target.ownerDocument||a,o=i.documentElement,r=i.body,e.pageX=n.clientX+(o&&o.scrollLeft||r&&r.scrollLeft||0)-(o&&o.clientLeft||r&&r.clientLeft||0),e.pageY=n.clientY+(o&&o.scrollTop||r&&r.scrollTop||0)-(o&&o.clientTop||r&&r.clientTop||0)),!e.relatedTarget&&l&&(e.relatedTarget=l===e.target?n.toElement:l),e.which||s===t||(e.which=1&s?1:2&s?3:4&s?2:0),e}},special:{load:{noBubble:!0},focus:{trigger:function(){if(this!==at()&&this.focus)try{return this.focus(),!1}catch(e){}},delegateType:"focusin"},blur:{trigger:function(){return this===at()&&this.blur?(this.blur(),!1):t},delegateType:"focusout"},click:{trigger:function(){return x.nodeName(this,"input")&&"checkbox"===this.type&&this.click?(this.click(),!1):t},_default:function(e){return x.nodeName(e.target,"a")}},beforeunload:{postDispatch:function(e){e.result!==t&&(e.originalEvent.returnValue=e.result)}}},simulate:function(e,t,n,r){var i=x.extend(new x.Event,n,{type:e,isSimulated:!0,originalEvent:{}});r?x.event.trigger(i,null,t):x.event.dispatch.call(t,i),i.isDefaultPrevented()&&n.preventDefault()}},x.removeEvent=a.removeEventListener?function(e,t,n){e.removeEventListener&&e.removeEventListener(t,n,!1)}:function(e,t,n){var r="on"+t;e.detachEvent&&(typeof e[r]===i&&(e[r]=null),e.detachEvent(r,n))},x.Event=function(e,n){return this instanceof x.Event?(e&&e.type?(this.originalEvent=e,this.type=e.type,this.isDefaultPrevented=e.defaultPrevented||e.returnValue===!1||e.getPreventDefault&&e.getPreventDefault()?it:ot):this.type=e,n&&x.extend(this,n),this.timeStamp=e&&e.timeStamp||x.now(),this[x.expando]=!0,t):new x.Event(e,n)},x.Event.prototype={isDefaultPrevented:ot,isPropagationStopped:ot,isImmediatePropagationStopped:ot,preventDefault:function(){var e=this.originalEvent;this.isDefaultPrevented=it,e&&(e.preventDefault?e.preventDefault():e.returnValue=!1)},stopPropagation:function(){var e=this.originalEvent;this.isPropagationStopped=it,e&&(e.stopPropagation&&e.stopPropagation(),e.cancelBubble=!0)},stopImmediatePropagation:function(){this.isImmediatePropagationStopped=it,this.stopPropagation()}},x.each({mouseenter:"mouseover",mouseleave:"mouseout"},function(e,t){x.event.special[e]={delegateType:t,bindType:t,handle:function(e){var n,r=this,i=e.relatedTarget,o=e.handleObj;return(!i||i!==r&&!x.contains(r,i))&&(e.type=o.origType,n=o.handler.apply(this,arguments),e.type=t),n}}}),x.support.submitBubbles||(x.event.special.submit={setup:function(){return x.nodeName(this,"form")?!1:(x.event.add(this,"click._submit keypress._submit",function(e){var n=e.target,r=x.nodeName(n,"input")||x.nodeName(n,"button")?n.form:t;r&&!x._data(r,"submitBubbles")&&(x.event.add(r,"submit._submit",function(e){e._submit_bubble=!0}),x._data(r,"submitBubbles",!0))}),t)},postDispatch:function(e){e._submit_bubble&&(delete e._submit_bubble,this.parentNode&&!e.isTrigger&&x.event.simulate("submit",this.parentNode,e,!0))},teardown:function(){return x.nodeName(this,"form")?!1:(x.event.remove(this,"._submit"),t)}}),x.support.changeBubbles||(x.event.special.change={setup:function(){return Z.test(this.nodeName)?(("checkbox"===this.type||"radio"===this.type)&&(x.event.add(this,"propertychange._change",function(e){"checked"===e.originalEvent.propertyName&&(this._just_changed=!0)}),x.event.add(this,"click._change",function(e){this._just_changed&&!e.isTrigger&&(this._just_changed=!1),x.event.simulate("change",this,e,!0)})),!1):(x.event.add(this,"beforeactivate._change",function(e){var t=e.target;Z.test(t.nodeName)&&!x._data(t,"changeBubbles")&&(x.event.add(t,"change._change",function(e){!this.parentNode||e.isSimulated||e.isTrigger||x.event.simulate("change",this.parentNode,e,!0)}),x._data(t,"changeBubbles",!0))}),t)},handle:function(e){var n=e.target;return this!==n||e.isSimulated||e.isTrigger||"radio"!==n.type&&"checkbox"!==n.type?e.handleObj.handler.apply(this,arguments):t},teardown:function(){return x.event.remove(this,"._change"),!Z.test(this.nodeName)}}),x.support.focusinBubbles||x.each({focus:"focusin",blur:"focusout"},function(e,t){var n=0,r=function(e){x.event.simulate(t,e.target,x.event.fix(e),!0)};x.event.special[t]={setup:function(){0===n++&&a.addEventListener(e,r,!0)},teardown:function(){0===--n&&a.removeEventListener(e,r,!0)}}}),x.fn.extend({on:function(e,n,r,i,o){var a,s;if("object"==typeof e){"string"!=typeof n&&(r=r||n,n=t);for(a in e)this.on(a,n,r,e[a],o);return this}if(null==r&&null==i?(i=n,r=n=t):null==i&&("string"==typeof n?(i=r,r=t):(i=r,r=n,n=t)),i===!1)i=ot;else if(!i)return this;return 1===o&&(s=i,i=function(e){return x().off(e),s.apply(this,arguments)},i.guid=s.guid||(s.guid=x.guid++)),this.each(function(){x.event.add(this,e,i,r,n)})},one:function(e,t,n,r){return this.on(e,t,n,r,1)},off:function(e,n,r){var i,o;if(e&&e.preventDefault&&e.handleObj)return i=e.handleObj,x(e.delegateTarget).off(i.namespace?i.origType+"."+i.namespace:i.origType,i.selector,i.handler),this;if("object"==typeof e){for(o in e)this.off(o,n,e[o]);return this}return(n===!1||"function"==typeof n)&&(r=n,n=t),r===!1&&(r=ot),this.each(function(){x.event.remove(this,e,r,n)})},trigger:function(e,t){return this.each(function(){x.event.trigger(e,t,this)})},triggerHandler:function(e,n){var r=this[0];return r?x.event.trigger(e,n,r,!0):t}});var st=/^.[^:#\[\.,]*$/,lt=/^(?:parents|prev(?:Until|All))/,ut=x.expr.match.needsContext,ct={children:!0,contents:!0,next:!0,prev:!0};x.fn.extend({find:function(e){var t,n=[],r=this,i=r.length;if("string"!=typeof e)return this.pushStack(x(e).filter(function(){for(t=0;i>t;t++)if(x.contains(r[t],this))return!0}));for(t=0;i>t;t++)x.find(e,r[t],n);return n=this.pushStack(i>1?x.unique(n):n),n.selector=this.selector?this.selector+" "+e:e,n},has:function(e){var t,n=x(e,this),r=n.length;return this.filter(function(){for(t=0;r>t;t++)if(x.contains(this,n[t]))return!0})},not:function(e){return this.pushStack(ft(this,e||[],!0))},filter:function(e){return this.pushStack(ft(this,e||[],!1))},is:function(e){return!!ft(this,"string"==typeof e&&ut.test(e)?x(e):e||[],!1).length},closest:function(e,t){var n,r=0,i=this.length,o=[],a=ut.test(e)||"string"!=typeof e?x(e,t||this.context):0;for(;i>r;r++)for(n=this[r];n&&n!==t;n=n.parentNode)if(11>n.nodeType&&(a?a.index(n)>-1:1===n.nodeType&&x.find.matchesSelector(n,e))){n=o.push(n);break}return this.pushStack(o.length>1?x.unique(o):o)},index:function(e){return e?"string"==typeof e?x.inArray(this[0],x(e)):x.inArray(e.jquery?e[0]:e,this):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(e,t){var n="string"==typeof e?x(e,t):x.makeArray(e&&e.nodeType?[e]:e),r=x.merge(this.get(),n);return this.pushStack(x.unique(r))},addBack:function(e){return this.add(null==e?this.prevObject:this.prevObject.filter(e))}});function pt(e,t){do e=e[t];while(e&&1!==e.nodeType);return e}x.each({parent:function(e){var t=e.parentNode;return t&&11!==t.nodeType?t:null},parents:function(e){return x.dir(e,"parentNode")},parentsUntil:function(e,t,n){return x.dir(e,"parentNode",n)},next:function(e){return pt(e,"nextSibling")},prev:function(e){return pt(e,"previousSibling")},nextAll:function(e){return x.dir(e,"nextSibling")},prevAll:function(e){return x.dir(e,"previousSibling")},nextUntil:function(e,t,n){return x.dir(e,"nextSibling",n)},prevUntil:function(e,t,n){return x.dir(e,"previousSibling",n)},siblings:function(e){return x.sibling((e.parentNode||{}).firstChild,e)},children:function(e){return x.sibling(e.firstChild)},contents:function(e){return x.nodeName(e,"iframe")?e.contentDocument||e.contentWindow.document:x.merge([],e.childNodes)}},function(e,t){x.fn[e]=function(n,r){var i=x.map(this,t,n);return"Until"!==e.slice(-5)&&(r=n),r&&"string"==typeof r&&(i=x.filter(r,i)),this.length>1&&(ct[e]||(i=x.unique(i)),lt.test(e)&&(i=i.reverse())),this.pushStack(i)}}),x.extend({filter:function(e,t,n){var r=t[0];return n&&(e=":not("+e+")"),1===t.length&&1===r.nodeType?x.find.matchesSelector(r,e)?[r]:[]:x.find.matches(e,x.grep(t,function(e){return 1===e.nodeType}))},dir:function(e,n,r){var i=[],o=e[n];while(o&&9!==o.nodeType&&(r===t||1!==o.nodeType||!x(o).is(r)))1===o.nodeType&&i.push(o),o=o[n];return i},sibling:function(e,t){var n=[];for(;e;e=e.nextSibling)1===e.nodeType&&e!==t&&n.push(e);return n}});function ft(e,t,n){if(x.isFunction(t))return x.grep(e,function(e,r){return!!t.call(e,r,e)!==n});if(t.nodeType)return x.grep(e,function(e){return e===t!==n});if("string"==typeof t){if(st.test(t))return x.filter(t,e,n);t=x.filter(t,e)}return x.grep(e,function(e){return x.inArray(e,t)>=0!==n})}function dt(e){var t=ht.split("|"),n=e.createDocumentFragment();if(n.createElement)while(t.length)n.createElement(t.pop());return n}var ht="abbr|article|aside|audio|bdi|canvas|data|datalist|details|figcaption|figure|footer|header|hgroup|mark|meter|nav|output|progress|section|summary|time|video",gt=/ jQuery\d+="(?:null|\d+)"/g,mt=RegExp("<(?:"+ht+")[\\s/>]","i"),yt=/^\s+/,vt=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,bt=/<([\w:]+)/,xt=/<tbody/i,wt=/<|&#?\w+;/,Tt=/<(?:script|style|link)/i,Ct=/^(?:checkbox|radio)$/i,Nt=/checked\s*(?:[^=]|=\s*.checked.)/i,kt=/^$|\/(?:java|ecma)script/i,Et=/^true\/(.*)/,St=/^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,At={option:[1,"<select multiple='multiple'>","</select>"],legend:[1,"<fieldset>","</fieldset>"],area:[1,"<map>","</map>"],param:[1,"<object>","</object>"],thead:[1,"<table>","</table>"],tr:[2,"<table><tbody>","</tbody></table>"],col:[2,"<table><tbody></tbody><colgroup>","</colgroup></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:x.support.htmlSerialize?[0,"",""]:[1,"X<div>","</div>"]},jt=dt(a),Dt=jt.appendChild(a.createElement("div"));At.optgroup=At.option,At.tbody=At.tfoot=At.colgroup=At.caption=At.thead,At.th=At.td,x.fn.extend({text:function(e){return x.access(this,function(e){return e===t?x.text(this):this.empty().append((this[0]&&this[0].ownerDocument||a).createTextNode(e))},null,e,arguments.length)},append:function(){return this.domManip(arguments,function(e){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var t=Lt(this,e);t.appendChild(e)}})},prepend:function(){return this.domManip(arguments,function(e){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var t=Lt(this,e);t.insertBefore(e,t.firstChild)}})},before:function(){return this.domManip(arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this)})},after:function(){return this.domManip(arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this.nextSibling)})},remove:function(e,t){var n,r=e?x.filter(e,this):this,i=0;for(;null!=(n=r[i]);i++)t||1!==n.nodeType||x.cleanData(Ft(n)),n.parentNode&&(t&&x.contains(n.ownerDocument,n)&&_t(Ft(n,"script")),n.parentNode.removeChild(n));return this},empty:function(){var e,t=0;for(;null!=(e=this[t]);t++){1===e.nodeType&&x.cleanData(Ft(e,!1));while(e.firstChild)e.removeChild(e.firstChild);e.options&&x.nodeName(e,"select")&&(e.options.length=0)}return this},clone:function(e,t){return e=null==e?!1:e,t=null==t?e:t,this.map(function(){return x.clone(this,e,t)})},html:function(e){return x.access(this,function(e){var n=this[0]||{},r=0,i=this.length;if(e===t)return 1===n.nodeType?n.innerHTML.replace(gt,""):t;if(!("string"!=typeof e||Tt.test(e)||!x.support.htmlSerialize&&mt.test(e)||!x.support.leadingWhitespace&&yt.test(e)||At[(bt.exec(e)||["",""])[1].toLowerCase()])){e=e.replace(vt,"<$1></$2>");try{for(;i>r;r++)n=this[r]||{},1===n.nodeType&&(x.cleanData(Ft(n,!1)),n.innerHTML=e);n=0}catch(o){}}n&&this.empty().append(e)},null,e,arguments.length)},replaceWith:function(){var e=x.map(this,function(e){return[e.nextSibling,e.parentNode]}),t=0;return this.domManip(arguments,function(n){var r=e[t++],i=e[t++];i&&(r&&r.parentNode!==i&&(r=this.nextSibling),x(this).remove(),i.insertBefore(n,r))},!0),t?this:this.remove()},detach:function(e){return this.remove(e,!0)},domManip:function(e,t,n){e=d.apply([],e);var r,i,o,a,s,l,u=0,c=this.length,p=this,f=c-1,h=e[0],g=x.isFunction(h);if(g||!(1>=c||"string"!=typeof h||x.support.checkClone)&&Nt.test(h))return this.each(function(r){var i=p.eq(r);g&&(e[0]=h.call(this,r,i.html())),i.domManip(e,t,n)});if(c&&(l=x.buildFragment(e,this[0].ownerDocument,!1,!n&&this),r=l.firstChild,1===l.childNodes.length&&(l=r),r)){for(a=x.map(Ft(l,"script"),Ht),o=a.length;c>u;u++)i=l,u!==f&&(i=x.clone(i,!0,!0),o&&x.merge(a,Ft(i,"script"))),t.call(this[u],i,u);if(o)for(s=a[a.length-1].ownerDocument,x.map(a,qt),u=0;o>u;u++)i=a[u],kt.test(i.type||"")&&!x._data(i,"globalEval")&&x.contains(s,i)&&(i.src?x._evalUrl(i.src):x.globalEval((i.text||i.textContent||i.innerHTML||"").replace(St,"")));l=r=null}return this}});function Lt(e,t){return x.nodeName(e,"table")&&x.nodeName(1===t.nodeType?t:t.firstChild,"tr")?e.getElementsByTagName("tbody")[0]||e.appendChild(e.ownerDocument.createElement("tbody")):e}function Ht(e){return e.type=(null!==x.find.attr(e,"type"))+"/"+e.type,e}function qt(e){var t=Et.exec(e.type);return t?e.type=t[1]:e.removeAttribute("type"),e}function _t(e,t){var n,r=0;for(;null!=(n=e[r]);r++)x._data(n,"globalEval",!t||x._data(t[r],"globalEval"))}function Mt(e,t){if(1===t.nodeType&&x.hasData(e)){var n,r,i,o=x._data(e),a=x._data(t,o),s=o.events;if(s){delete a.handle,a.events={};for(n in s)for(r=0,i=s[n].length;i>r;r++)x.event.add(t,n,s[n][r])}a.data&&(a.data=x.extend({},a.data))}}function Ot(e,t){var n,r,i;if(1===t.nodeType){if(n=t.nodeName.toLowerCase(),!x.support.noCloneEvent&&t[x.expando]){i=x._data(t);for(r in i.events)x.removeEvent(t,r,i.handle);t.removeAttribute(x.expando)}"script"===n&&t.text!==e.text?(Ht(t).text=e.text,qt(t)):"object"===n?(t.parentNode&&(t.outerHTML=e.outerHTML),x.support.html5Clone&&e.innerHTML&&!x.trim(t.innerHTML)&&(t.innerHTML=e.innerHTML)):"input"===n&&Ct.test(e.type)?(t.defaultChecked=t.checked=e.checked,t.value!==e.value&&(t.value=e.value)):"option"===n?t.defaultSelected=t.selected=e.defaultSelected:("input"===n||"textarea"===n)&&(t.defaultValue=e.defaultValue)}}x.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(e,t){x.fn[e]=function(e){var n,r=0,i=[],o=x(e),a=o.length-1;for(;a>=r;r++)n=r===a?this:this.clone(!0),x(o[r])[t](n),h.apply(i,n.get());return this.pushStack(i)}});function Ft(e,n){var r,o,a=0,s=typeof e.getElementsByTagName!==i?e.getElementsByTagName(n||"*"):typeof e.querySelectorAll!==i?e.querySelectorAll(n||"*"):t;if(!s)for(s=[],r=e.childNodes||e;null!=(o=r[a]);a++)!n||x.nodeName(o,n)?s.push(o):x.merge(s,Ft(o,n));return n===t||n&&x.nodeName(e,n)?x.merge([e],s):s}function Bt(e){Ct.test(e.type)&&(e.defaultChecked=e.checked)}x.extend({clone:function(e,t,n){var r,i,o,a,s,l=x.contains(e.ownerDocument,e);if(x.support.html5Clone||x.isXMLDoc(e)||!mt.test("<"+e.nodeName+">")?o=e.cloneNode(!0):(Dt.innerHTML=e.outerHTML,Dt.removeChild(o=Dt.firstChild)),!(x.support.noCloneEvent&&x.support.noCloneChecked||1!==e.nodeType&&11!==e.nodeType||x.isXMLDoc(e)))for(r=Ft(o),s=Ft(e),a=0;null!=(i=s[a]);++a)r[a]&&Ot(i,r[a]);if(t)if(n)for(s=s||Ft(e),r=r||Ft(o),a=0;null!=(i=s[a]);a++)Mt(i,r[a]);else Mt(e,o);return r=Ft(o,"script"),r.length>0&&_t(r,!l&&Ft(e,"script")),r=s=i=null,o},buildFragment:function(e,t,n,r){var i,o,a,s,l,u,c,p=e.length,f=dt(t),d=[],h=0;for(;p>h;h++)if(o=e[h],o||0===o)if("object"===x.type(o))x.merge(d,o.nodeType?[o]:o);else if(wt.test(o)){s=s||f.appendChild(t.createElement("div")),l=(bt.exec(o)||["",""])[1].toLowerCase(),c=At[l]||At._default,s.innerHTML=c[1]+o.replace(vt,"<$1></$2>")+c[2],i=c[0];while(i--)s=s.lastChild;if(!x.support.leadingWhitespace&&yt.test(o)&&d.push(t.createTextNode(yt.exec(o)[0])),!x.support.tbody){o="table"!==l||xt.test(o)?"<table>"!==c[1]||xt.test(o)?0:s:s.firstChild,i=o&&o.childNodes.length;while(i--)x.nodeName(u=o.childNodes[i],"tbody")&&!u.childNodes.length&&o.removeChild(u)}x.merge(d,s.childNodes),s.textContent="";while(s.firstChild)s.removeChild(s.firstChild);s=f.lastChild}else d.push(t.createTextNode(o));s&&f.removeChild(s),x.support.appendChecked||x.grep(Ft(d,"input"),Bt),h=0;while(o=d[h++])if((!r||-1===x.inArray(o,r))&&(a=x.contains(o.ownerDocument,o),s=Ft(f.appendChild(o),"script"),a&&_t(s),n)){i=0;while(o=s[i++])kt.test(o.type||"")&&n.push(o)}return s=null,f},cleanData:function(e,t){var n,r,o,a,s=0,l=x.expando,u=x.cache,c=x.support.deleteExpando,f=x.event.special;for(;null!=(n=e[s]);s++)if((t||x.acceptData(n))&&(o=n[l],a=o&&u[o])){if(a.events)for(r in a.events)f[r]?x.event.remove(n,r):x.removeEvent(n,r,a.handle);
u[o]&&(delete u[o],c?delete n[l]:typeof n.removeAttribute!==i?n.removeAttribute(l):n[l]=null,p.push(o))}},_evalUrl:function(e){return x.ajax({url:e,type:"GET",dataType:"script",async:!1,global:!1,"throws":!0})}}),x.fn.extend({wrapAll:function(e){if(x.isFunction(e))return this.each(function(t){x(this).wrapAll(e.call(this,t))});if(this[0]){var t=x(e,this[0].ownerDocument).eq(0).clone(!0);this[0].parentNode&&t.insertBefore(this[0]),t.map(function(){var e=this;while(e.firstChild&&1===e.firstChild.nodeType)e=e.firstChild;return e}).append(this)}return this},wrapInner:function(e){return x.isFunction(e)?this.each(function(t){x(this).wrapInner(e.call(this,t))}):this.each(function(){var t=x(this),n=t.contents();n.length?n.wrapAll(e):t.append(e)})},wrap:function(e){var t=x.isFunction(e);return this.each(function(n){x(this).wrapAll(t?e.call(this,n):e)})},unwrap:function(){return this.parent().each(function(){x.nodeName(this,"body")||x(this).replaceWith(this.childNodes)}).end()}});var Pt,Rt,Wt,$t=/alpha\([^)]*\)/i,It=/opacity\s*=\s*([^)]*)/,zt=/^(top|right|bottom|left)$/,Xt=/^(none|table(?!-c[ea]).+)/,Ut=/^margin/,Vt=RegExp("^("+w+")(.*)$","i"),Yt=RegExp("^("+w+")(?!px)[a-z%]+$","i"),Jt=RegExp("^([+-])=("+w+")","i"),Gt={BODY:"block"},Qt={position:"absolute",visibility:"hidden",display:"block"},Kt={letterSpacing:0,fontWeight:400},Zt=["Top","Right","Bottom","Left"],en=["Webkit","O","Moz","ms"];function tn(e,t){if(t in e)return t;var n=t.charAt(0).toUpperCase()+t.slice(1),r=t,i=en.length;while(i--)if(t=en[i]+n,t in e)return t;return r}function nn(e,t){return e=t||e,"none"===x.css(e,"display")||!x.contains(e.ownerDocument,e)}function rn(e,t){var n,r,i,o=[],a=0,s=e.length;for(;s>a;a++)r=e[a],r.style&&(o[a]=x._data(r,"olddisplay"),n=r.style.display,t?(o[a]||"none"!==n||(r.style.display=""),""===r.style.display&&nn(r)&&(o[a]=x._data(r,"olddisplay",ln(r.nodeName)))):o[a]||(i=nn(r),(n&&"none"!==n||!i)&&x._data(r,"olddisplay",i?n:x.css(r,"display"))));for(a=0;s>a;a++)r=e[a],r.style&&(t&&"none"!==r.style.display&&""!==r.style.display||(r.style.display=t?o[a]||"":"none"));return e}x.fn.extend({css:function(e,n){return x.access(this,function(e,n,r){var i,o,a={},s=0;if(x.isArray(n)){for(o=Rt(e),i=n.length;i>s;s++)a[n[s]]=x.css(e,n[s],!1,o);return a}return r!==t?x.style(e,n,r):x.css(e,n)},e,n,arguments.length>1)},show:function(){return rn(this,!0)},hide:function(){return rn(this)},toggle:function(e){return"boolean"==typeof e?e?this.show():this.hide():this.each(function(){nn(this)?x(this).show():x(this).hide()})}}),x.extend({cssHooks:{opacity:{get:function(e,t){if(t){var n=Wt(e,"opacity");return""===n?"1":n}}}},cssNumber:{columnCount:!0,fillOpacity:!0,fontWeight:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{"float":x.support.cssFloat?"cssFloat":"styleFloat"},style:function(e,n,r,i){if(e&&3!==e.nodeType&&8!==e.nodeType&&e.style){var o,a,s,l=x.camelCase(n),u=e.style;if(n=x.cssProps[l]||(x.cssProps[l]=tn(u,l)),s=x.cssHooks[n]||x.cssHooks[l],r===t)return s&&"get"in s&&(o=s.get(e,!1,i))!==t?o:u[n];if(a=typeof r,"string"===a&&(o=Jt.exec(r))&&(r=(o[1]+1)*o[2]+parseFloat(x.css(e,n)),a="number"),!(null==r||"number"===a&&isNaN(r)||("number"!==a||x.cssNumber[l]||(r+="px"),x.support.clearCloneStyle||""!==r||0!==n.indexOf("background")||(u[n]="inherit"),s&&"set"in s&&(r=s.set(e,r,i))===t)))try{u[n]=r}catch(c){}}},css:function(e,n,r,i){var o,a,s,l=x.camelCase(n);return n=x.cssProps[l]||(x.cssProps[l]=tn(e.style,l)),s=x.cssHooks[n]||x.cssHooks[l],s&&"get"in s&&(a=s.get(e,!0,r)),a===t&&(a=Wt(e,n,i)),"normal"===a&&n in Kt&&(a=Kt[n]),""===r||r?(o=parseFloat(a),r===!0||x.isNumeric(o)?o||0:a):a}}),e.getComputedStyle?(Rt=function(t){return e.getComputedStyle(t,null)},Wt=function(e,n,r){var i,o,a,s=r||Rt(e),l=s?s.getPropertyValue(n)||s[n]:t,u=e.style;return s&&(""!==l||x.contains(e.ownerDocument,e)||(l=x.style(e,n)),Yt.test(l)&&Ut.test(n)&&(i=u.width,o=u.minWidth,a=u.maxWidth,u.minWidth=u.maxWidth=u.width=l,l=s.width,u.width=i,u.minWidth=o,u.maxWidth=a)),l}):a.documentElement.currentStyle&&(Rt=function(e){return e.currentStyle},Wt=function(e,n,r){var i,o,a,s=r||Rt(e),l=s?s[n]:t,u=e.style;return null==l&&u&&u[n]&&(l=u[n]),Yt.test(l)&&!zt.test(n)&&(i=u.left,o=e.runtimeStyle,a=o&&o.left,a&&(o.left=e.currentStyle.left),u.left="fontSize"===n?"1em":l,l=u.pixelLeft+"px",u.left=i,a&&(o.left=a)),""===l?"auto":l});function on(e,t,n){var r=Vt.exec(t);return r?Math.max(0,r[1]-(n||0))+(r[2]||"px"):t}function an(e,t,n,r,i){var o=n===(r?"border":"content")?4:"width"===t?1:0,a=0;for(;4>o;o+=2)"margin"===n&&(a+=x.css(e,n+Zt[o],!0,i)),r?("content"===n&&(a-=x.css(e,"padding"+Zt[o],!0,i)),"margin"!==n&&(a-=x.css(e,"border"+Zt[o]+"Width",!0,i))):(a+=x.css(e,"padding"+Zt[o],!0,i),"padding"!==n&&(a+=x.css(e,"border"+Zt[o]+"Width",!0,i)));return a}function sn(e,t,n){var r=!0,i="width"===t?e.offsetWidth:e.offsetHeight,o=Rt(e),a=x.support.boxSizing&&"border-box"===x.css(e,"boxSizing",!1,o);if(0>=i||null==i){if(i=Wt(e,t,o),(0>i||null==i)&&(i=e.style[t]),Yt.test(i))return i;r=a&&(x.support.boxSizingReliable||i===e.style[t]),i=parseFloat(i)||0}return i+an(e,t,n||(a?"border":"content"),r,o)+"px"}function ln(e){var t=a,n=Gt[e];return n||(n=un(e,t),"none"!==n&&n||(Pt=(Pt||x("<iframe frameborder='0' width='0' height='0'/>").css("cssText","display:block !important")).appendTo(t.documentElement),t=(Pt[0].contentWindow||Pt[0].contentDocument).document,t.write("<!doctype html><html><body>"),t.close(),n=un(e,t),Pt.detach()),Gt[e]=n),n}function un(e,t){var n=x(t.createElement(e)).appendTo(t.body),r=x.css(n[0],"display");return n.remove(),r}x.each(["height","width"],function(e,n){x.cssHooks[n]={get:function(e,r,i){return r?0===e.offsetWidth&&Xt.test(x.css(e,"display"))?x.swap(e,Qt,function(){return sn(e,n,i)}):sn(e,n,i):t},set:function(e,t,r){var i=r&&Rt(e);return on(e,t,r?an(e,n,r,x.support.boxSizing&&"border-box"===x.css(e,"boxSizing",!1,i),i):0)}}}),x.support.opacity||(x.cssHooks.opacity={get:function(e,t){return It.test((t&&e.currentStyle?e.currentStyle.filter:e.style.filter)||"")?.01*parseFloat(RegExp.$1)+"":t?"1":""},set:function(e,t){var n=e.style,r=e.currentStyle,i=x.isNumeric(t)?"alpha(opacity="+100*t+")":"",o=r&&r.filter||n.filter||"";n.zoom=1,(t>=1||""===t)&&""===x.trim(o.replace($t,""))&&n.removeAttribute&&(n.removeAttribute("filter"),""===t||r&&!r.filter)||(n.filter=$t.test(o)?o.replace($t,i):o+" "+i)}}),x(function(){x.support.reliableMarginRight||(x.cssHooks.marginRight={get:function(e,n){return n?x.swap(e,{display:"inline-block"},Wt,[e,"marginRight"]):t}}),!x.support.pixelPosition&&x.fn.position&&x.each(["top","left"],function(e,n){x.cssHooks[n]={get:function(e,r){return r?(r=Wt(e,n),Yt.test(r)?x(e).position()[n]+"px":r):t}}})}),x.expr&&x.expr.filters&&(x.expr.filters.hidden=function(e){return 0>=e.offsetWidth&&0>=e.offsetHeight||!x.support.reliableHiddenOffsets&&"none"===(e.style&&e.style.display||x.css(e,"display"))},x.expr.filters.visible=function(e){return!x.expr.filters.hidden(e)}),x.each({margin:"",padding:"",border:"Width"},function(e,t){x.cssHooks[e+t]={expand:function(n){var r=0,i={},o="string"==typeof n?n.split(" "):[n];for(;4>r;r++)i[e+Zt[r]+t]=o[r]||o[r-2]||o[0];return i}},Ut.test(e)||(x.cssHooks[e+t].set=on)});var cn=/%20/g,pn=/\[\]$/,fn=/\r?\n/g,dn=/^(?:submit|button|image|reset|file)$/i,hn=/^(?:input|select|textarea|keygen)/i;x.fn.extend({serialize:function(){return x.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var e=x.prop(this,"elements");return e?x.makeArray(e):this}).filter(function(){var e=this.type;return this.name&&!x(this).is(":disabled")&&hn.test(this.nodeName)&&!dn.test(e)&&(this.checked||!Ct.test(e))}).map(function(e,t){var n=x(this).val();return null==n?null:x.isArray(n)?x.map(n,function(e){return{name:t.name,value:e.replace(fn,"\r\n")}}):{name:t.name,value:n.replace(fn,"\r\n")}}).get()}}),x.param=function(e,n){var r,i=[],o=function(e,t){t=x.isFunction(t)?t():null==t?"":t,i[i.length]=encodeURIComponent(e)+"="+encodeURIComponent(t)};if(n===t&&(n=x.ajaxSettings&&x.ajaxSettings.traditional),x.isArray(e)||e.jquery&&!x.isPlainObject(e))x.each(e,function(){o(this.name,this.value)});else for(r in e)gn(r,e[r],n,o);return i.join("&").replace(cn,"+")};function gn(e,t,n,r){var i;if(x.isArray(t))x.each(t,function(t,i){n||pn.test(e)?r(e,i):gn(e+"["+("object"==typeof i?t:"")+"]",i,n,r)});else if(n||"object"!==x.type(t))r(e,t);else for(i in t)gn(e+"["+i+"]",t[i],n,r)}x.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "),function(e,t){x.fn[t]=function(e,n){return arguments.length>0?this.on(t,null,e,n):this.trigger(t)}}),x.fn.extend({hover:function(e,t){return this.mouseenter(e).mouseleave(t||e)},bind:function(e,t,n){return this.on(e,null,t,n)},unbind:function(e,t){return this.off(e,null,t)},delegate:function(e,t,n,r){return this.on(t,e,n,r)},undelegate:function(e,t,n){return 1===arguments.length?this.off(e,"**"):this.off(t,e||"**",n)}});var mn,yn,vn=x.now(),bn=/\?/,xn=/#.*$/,wn=/([?&])_=[^&]*/,Tn=/^(.*?):[ \t]*([^\r\n]*)\r?$/gm,Cn=/^(?:about|app|app-storage|.+-extension|file|res|widget):$/,Nn=/^(?:GET|HEAD)$/,kn=/^\/\//,En=/^([\w.+-]+:)(?:\/\/([^\/?#:]*)(?::(\d+)|)|)/,Sn=x.fn.load,An={},jn={},Dn="*/".concat("*");try{yn=o.href}catch(Ln){yn=a.createElement("a"),yn.href="",yn=yn.href}mn=En.exec(yn.toLowerCase())||[];function Hn(e){return function(t,n){"string"!=typeof t&&(n=t,t="*");var r,i=0,o=t.toLowerCase().match(T)||[];if(x.isFunction(n))while(r=o[i++])"+"===r[0]?(r=r.slice(1)||"*",(e[r]=e[r]||[]).unshift(n)):(e[r]=e[r]||[]).push(n)}}function qn(e,n,r,i){var o={},a=e===jn;function s(l){var u;return o[l]=!0,x.each(e[l]||[],function(e,l){var c=l(n,r,i);return"string"!=typeof c||a||o[c]?a?!(u=c):t:(n.dataTypes.unshift(c),s(c),!1)}),u}return s(n.dataTypes[0])||!o["*"]&&s("*")}function _n(e,n){var r,i,o=x.ajaxSettings.flatOptions||{};for(i in n)n[i]!==t&&((o[i]?e:r||(r={}))[i]=n[i]);return r&&x.extend(!0,e,r),e}x.fn.load=function(e,n,r){if("string"!=typeof e&&Sn)return Sn.apply(this,arguments);var i,o,a,s=this,l=e.indexOf(" ");return l>=0&&(i=e.slice(l,e.length),e=e.slice(0,l)),x.isFunction(n)?(r=n,n=t):n&&"object"==typeof n&&(a="POST"),s.length>0&&x.ajax({url:e,type:a,dataType:"html",data:n}).done(function(e){o=arguments,s.html(i?x("<div>").append(x.parseHTML(e)).find(i):e)}).complete(r&&function(e,t){s.each(r,o||[e.responseText,t,e])}),this},x.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(e,t){x.fn[t]=function(e){return this.on(t,e)}}),x.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:yn,type:"GET",isLocal:Cn.test(mn[1]),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":Dn,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/xml/,html:/html/,json:/json/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":x.parseJSON,"text xml":x.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(e,t){return t?_n(_n(e,x.ajaxSettings),t):_n(x.ajaxSettings,e)},ajaxPrefilter:Hn(An),ajaxTransport:Hn(jn),ajax:function(e,n){"object"==typeof e&&(n=e,e=t),n=n||{};var r,i,o,a,s,l,u,c,p=x.ajaxSetup({},n),f=p.context||p,d=p.context&&(f.nodeType||f.jquery)?x(f):x.event,h=x.Deferred(),g=x.Callbacks("once memory"),m=p.statusCode||{},y={},v={},b=0,w="canceled",C={readyState:0,getResponseHeader:function(e){var t;if(2===b){if(!c){c={};while(t=Tn.exec(a))c[t[1].toLowerCase()]=t[2]}t=c[e.toLowerCase()]}return null==t?null:t},getAllResponseHeaders:function(){return 2===b?a:null},setRequestHeader:function(e,t){var n=e.toLowerCase();return b||(e=v[n]=v[n]||e,y[e]=t),this},overrideMimeType:function(e){return b||(p.mimeType=e),this},statusCode:function(e){var t;if(e)if(2>b)for(t in e)m[t]=[m[t],e[t]];else C.always(e[C.status]);return this},abort:function(e){var t=e||w;return u&&u.abort(t),k(0,t),this}};if(h.promise(C).complete=g.add,C.success=C.done,C.error=C.fail,p.url=((e||p.url||yn)+"").replace(xn,"").replace(kn,mn[1]+"//"),p.type=n.method||n.type||p.method||p.type,p.dataTypes=x.trim(p.dataType||"*").toLowerCase().match(T)||[""],null==p.crossDomain&&(r=En.exec(p.url.toLowerCase()),p.crossDomain=!(!r||r[1]===mn[1]&&r[2]===mn[2]&&(r[3]||("http:"===r[1]?"80":"443"))===(mn[3]||("http:"===mn[1]?"80":"443")))),p.data&&p.processData&&"string"!=typeof p.data&&(p.data=x.param(p.data,p.traditional)),qn(An,p,n,C),2===b)return C;l=p.global,l&&0===x.active++&&x.event.trigger("ajaxStart"),p.type=p.type.toUpperCase(),p.hasContent=!Nn.test(p.type),o=p.url,p.hasContent||(p.data&&(o=p.url+=(bn.test(o)?"&":"?")+p.data,delete p.data),p.cache===!1&&(p.url=wn.test(o)?o.replace(wn,"$1_="+vn++):o+(bn.test(o)?"&":"?")+"_="+vn++)),p.ifModified&&(x.lastModified[o]&&C.setRequestHeader("If-Modified-Since",x.lastModified[o]),x.etag[o]&&C.setRequestHeader("If-None-Match",x.etag[o])),(p.data&&p.hasContent&&p.contentType!==!1||n.contentType)&&C.setRequestHeader("Content-Type",p.contentType),C.setRequestHeader("Accept",p.dataTypes[0]&&p.accepts[p.dataTypes[0]]?p.accepts[p.dataTypes[0]]+("*"!==p.dataTypes[0]?", "+Dn+"; q=0.01":""):p.accepts["*"]);for(i in p.headers)C.setRequestHeader(i,p.headers[i]);if(p.beforeSend&&(p.beforeSend.call(f,C,p)===!1||2===b))return C.abort();w="abort";for(i in{success:1,error:1,complete:1})C[i](p[i]);if(u=qn(jn,p,n,C)){C.readyState=1,l&&d.trigger("ajaxSend",[C,p]),p.async&&p.timeout>0&&(s=setTimeout(function(){C.abort("timeout")},p.timeout));try{b=1,u.send(y,k)}catch(N){if(!(2>b))throw N;k(-1,N)}}else k(-1,"No Transport");function k(e,n,r,i){var c,y,v,w,T,N=n;2!==b&&(b=2,s&&clearTimeout(s),u=t,a=i||"",C.readyState=e>0?4:0,c=e>=200&&300>e||304===e,r&&(w=Mn(p,C,r)),w=On(p,w,C,c),c?(p.ifModified&&(T=C.getResponseHeader("Last-Modified"),T&&(x.lastModified[o]=T),T=C.getResponseHeader("etag"),T&&(x.etag[o]=T)),204===e||"HEAD"===p.type?N="nocontent":304===e?N="notmodified":(N=w.state,y=w.data,v=w.error,c=!v)):(v=N,(e||!N)&&(N="error",0>e&&(e=0))),C.status=e,C.statusText=(n||N)+"",c?h.resolveWith(f,[y,N,C]):h.rejectWith(f,[C,N,v]),C.statusCode(m),m=t,l&&d.trigger(c?"ajaxSuccess":"ajaxError",[C,p,c?y:v]),g.fireWith(f,[C,N]),l&&(d.trigger("ajaxComplete",[C,p]),--x.active||x.event.trigger("ajaxStop")))}return C},getJSON:function(e,t,n){return x.get(e,t,n,"json")},getScript:function(e,n){return x.get(e,t,n,"script")}}),x.each(["get","post"],function(e,n){x[n]=function(e,r,i,o){return x.isFunction(r)&&(o=o||i,i=r,r=t),x.ajax({url:e,type:n,dataType:o,data:r,success:i})}});function Mn(e,n,r){var i,o,a,s,l=e.contents,u=e.dataTypes;while("*"===u[0])u.shift(),o===t&&(o=e.mimeType||n.getResponseHeader("Content-Type"));if(o)for(s in l)if(l[s]&&l[s].test(o)){u.unshift(s);break}if(u[0]in r)a=u[0];else{for(s in r){if(!u[0]||e.converters[s+" "+u[0]]){a=s;break}i||(i=s)}a=a||i}return a?(a!==u[0]&&u.unshift(a),r[a]):t}function On(e,t,n,r){var i,o,a,s,l,u={},c=e.dataTypes.slice();if(c[1])for(a in e.converters)u[a.toLowerCase()]=e.converters[a];o=c.shift();while(o)if(e.responseFields[o]&&(n[e.responseFields[o]]=t),!l&&r&&e.dataFilter&&(t=e.dataFilter(t,e.dataType)),l=o,o=c.shift())if("*"===o)o=l;else if("*"!==l&&l!==o){if(a=u[l+" "+o]||u["* "+o],!a)for(i in u)if(s=i.split(" "),s[1]===o&&(a=u[l+" "+s[0]]||u["* "+s[0]])){a===!0?a=u[i]:u[i]!==!0&&(o=s[0],c.unshift(s[1]));break}if(a!==!0)if(a&&e["throws"])t=a(t);else try{t=a(t)}catch(p){return{state:"parsererror",error:a?p:"No conversion from "+l+" to "+o}}}return{state:"success",data:t}}x.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/(?:java|ecma)script/},converters:{"text script":function(e){return x.globalEval(e),e}}}),x.ajaxPrefilter("script",function(e){e.cache===t&&(e.cache=!1),e.crossDomain&&(e.type="GET",e.global=!1)}),x.ajaxTransport("script",function(e){if(e.crossDomain){var n,r=a.head||x("head")[0]||a.documentElement;return{send:function(t,i){n=a.createElement("script"),n.async=!0,e.scriptCharset&&(n.charset=e.scriptCharset),n.src=e.url,n.onload=n.onreadystatechange=function(e,t){(t||!n.readyState||/loaded|complete/.test(n.readyState))&&(n.onload=n.onreadystatechange=null,n.parentNode&&n.parentNode.removeChild(n),n=null,t||i(200,"success"))},r.insertBefore(n,r.firstChild)},abort:function(){n&&n.onload(t,!0)}}}});var Fn=[],Bn=/(=)\?(?=&|$)|\?\?/;x.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var e=Fn.pop()||x.expando+"_"+vn++;return this[e]=!0,e}}),x.ajaxPrefilter("json jsonp",function(n,r,i){var o,a,s,l=n.jsonp!==!1&&(Bn.test(n.url)?"url":"string"==typeof n.data&&!(n.contentType||"").indexOf("application/x-www-form-urlencoded")&&Bn.test(n.data)&&"data");return l||"jsonp"===n.dataTypes[0]?(o=n.jsonpCallback=x.isFunction(n.jsonpCallback)?n.jsonpCallback():n.jsonpCallback,l?n[l]=n[l].replace(Bn,"$1"+o):n.jsonp!==!1&&(n.url+=(bn.test(n.url)?"&":"?")+n.jsonp+"="+o),n.converters["script json"]=function(){return s||x.error(o+" was not called"),s[0]},n.dataTypes[0]="json",a=e[o],e[o]=function(){s=arguments},i.always(function(){e[o]=a,n[o]&&(n.jsonpCallback=r.jsonpCallback,Fn.push(o)),s&&x.isFunction(a)&&a(s[0]),s=a=t}),"script"):t});var Pn,Rn,Wn=0,$n=e.ActiveXObject&&function(){var e;for(e in Pn)Pn[e](t,!0)};function In(){try{return new e.XMLHttpRequest}catch(t){}}function zn(){try{return new e.ActiveXObject("Microsoft.XMLHTTP")}catch(t){}}x.ajaxSettings.xhr=e.ActiveXObject?function(){return!this.isLocal&&In()||zn()}:In,Rn=x.ajaxSettings.xhr(),x.support.cors=!!Rn&&"withCredentials"in Rn,Rn=x.support.ajax=!!Rn,Rn&&x.ajaxTransport(function(n){if(!n.crossDomain||x.support.cors){var r;return{send:function(i,o){var a,s,l=n.xhr();if(n.username?l.open(n.type,n.url,n.async,n.username,n.password):l.open(n.type,n.url,n.async),n.xhrFields)for(s in n.xhrFields)l[s]=n.xhrFields[s];n.mimeType&&l.overrideMimeType&&l.overrideMimeType(n.mimeType),n.crossDomain||i["X-Requested-With"]||(i["X-Requested-With"]="XMLHttpRequest");try{for(s in i)l.setRequestHeader(s,i[s])}catch(u){}l.send(n.hasContent&&n.data||null),r=function(e,i){var s,u,c,p;try{if(r&&(i||4===l.readyState))if(r=t,a&&(l.onreadystatechange=x.noop,$n&&delete Pn[a]),i)4!==l.readyState&&l.abort();else{p={},s=l.status,u=l.getAllResponseHeaders(),"string"==typeof l.responseText&&(p.text=l.responseText);try{c=l.statusText}catch(f){c=""}s||!n.isLocal||n.crossDomain?1223===s&&(s=204):s=p.text?200:404}}catch(d){i||o(-1,d)}p&&o(s,c,p,u)},n.async?4===l.readyState?setTimeout(r):(a=++Wn,$n&&(Pn||(Pn={},x(e).unload($n)),Pn[a]=r),l.onreadystatechange=r):r()},abort:function(){r&&r(t,!0)}}}});var Xn,Un,Vn=/^(?:toggle|show|hide)$/,Yn=RegExp("^(?:([+-])=|)("+w+")([a-z%]*)$","i"),Jn=/queueHooks$/,Gn=[nr],Qn={"*":[function(e,t){var n=this.createTween(e,t),r=n.cur(),i=Yn.exec(t),o=i&&i[3]||(x.cssNumber[e]?"":"px"),a=(x.cssNumber[e]||"px"!==o&&+r)&&Yn.exec(x.css(n.elem,e)),s=1,l=20;if(a&&a[3]!==o){o=o||a[3],i=i||[],a=+r||1;do s=s||".5",a/=s,x.style(n.elem,e,a+o);while(s!==(s=n.cur()/r)&&1!==s&&--l)}return i&&(a=n.start=+a||+r||0,n.unit=o,n.end=i[1]?a+(i[1]+1)*i[2]:+i[2]),n}]};function Kn(){return setTimeout(function(){Xn=t}),Xn=x.now()}function Zn(e,t,n){var r,i=(Qn[t]||[]).concat(Qn["*"]),o=0,a=i.length;for(;a>o;o++)if(r=i[o].call(n,t,e))return r}function er(e,t,n){var r,i,o=0,a=Gn.length,s=x.Deferred().always(function(){delete l.elem}),l=function(){if(i)return!1;var t=Xn||Kn(),n=Math.max(0,u.startTime+u.duration-t),r=n/u.duration||0,o=1-r,a=0,l=u.tweens.length;for(;l>a;a++)u.tweens[a].run(o);return s.notifyWith(e,[u,o,n]),1>o&&l?n:(s.resolveWith(e,[u]),!1)},u=s.promise({elem:e,props:x.extend({},t),opts:x.extend(!0,{specialEasing:{}},n),originalProperties:t,originalOptions:n,startTime:Xn||Kn(),duration:n.duration,tweens:[],createTween:function(t,n){var r=x.Tween(e,u.opts,t,n,u.opts.specialEasing[t]||u.opts.easing);return u.tweens.push(r),r},stop:function(t){var n=0,r=t?u.tweens.length:0;if(i)return this;for(i=!0;r>n;n++)u.tweens[n].run(1);return t?s.resolveWith(e,[u,t]):s.rejectWith(e,[u,t]),this}}),c=u.props;for(tr(c,u.opts.specialEasing);a>o;o++)if(r=Gn[o].call(u,e,c,u.opts))return r;return x.map(c,Zn,u),x.isFunction(u.opts.start)&&u.opts.start.call(e,u),x.fx.timer(x.extend(l,{elem:e,anim:u,queue:u.opts.queue})),u.progress(u.opts.progress).done(u.opts.done,u.opts.complete).fail(u.opts.fail).always(u.opts.always)}function tr(e,t){var n,r,i,o,a;for(n in e)if(r=x.camelCase(n),i=t[r],o=e[n],x.isArray(o)&&(i=o[1],o=e[n]=o[0]),n!==r&&(e[r]=o,delete e[n]),a=x.cssHooks[r],a&&"expand"in a){o=a.expand(o),delete e[r];for(n in o)n in e||(e[n]=o[n],t[n]=i)}else t[r]=i}x.Animation=x.extend(er,{tweener:function(e,t){x.isFunction(e)?(t=e,e=["*"]):e=e.split(" ");var n,r=0,i=e.length;for(;i>r;r++)n=e[r],Qn[n]=Qn[n]||[],Qn[n].unshift(t)},prefilter:function(e,t){t?Gn.unshift(e):Gn.push(e)}});function nr(e,t,n){var r,i,o,a,s,l,u=this,c={},p=e.style,f=e.nodeType&&nn(e),d=x._data(e,"fxshow");n.queue||(s=x._queueHooks(e,"fx"),null==s.unqueued&&(s.unqueued=0,l=s.empty.fire,s.empty.fire=function(){s.unqueued||l()}),s.unqueued++,u.always(function(){u.always(function(){s.unqueued--,x.queue(e,"fx").length||s.empty.fire()})})),1===e.nodeType&&("height"in t||"width"in t)&&(n.overflow=[p.overflow,p.overflowX,p.overflowY],"inline"===x.css(e,"display")&&"none"===x.css(e,"float")&&(x.support.inlineBlockNeedsLayout&&"inline"!==ln(e.nodeName)?p.zoom=1:p.display="inline-block")),n.overflow&&(p.overflow="hidden",x.support.shrinkWrapBlocks||u.always(function(){p.overflow=n.overflow[0],p.overflowX=n.overflow[1],p.overflowY=n.overflow[2]}));for(r in t)if(i=t[r],Vn.exec(i)){if(delete t[r],o=o||"toggle"===i,i===(f?"hide":"show"))continue;c[r]=d&&d[r]||x.style(e,r)}if(!x.isEmptyObject(c)){d?"hidden"in d&&(f=d.hidden):d=x._data(e,"fxshow",{}),o&&(d.hidden=!f),f?x(e).show():u.done(function(){x(e).hide()}),u.done(function(){var t;x._removeData(e,"fxshow");for(t in c)x.style(e,t,c[t])});for(r in c)a=Zn(f?d[r]:0,r,u),r in d||(d[r]=a.start,f&&(a.end=a.start,a.start="width"===r||"height"===r?1:0))}}function rr(e,t,n,r,i){return new rr.prototype.init(e,t,n,r,i)}x.Tween=rr,rr.prototype={constructor:rr,init:function(e,t,n,r,i,o){this.elem=e,this.prop=n,this.easing=i||"swing",this.options=t,this.start=this.now=this.cur(),this.end=r,this.unit=o||(x.cssNumber[n]?"":"px")},cur:function(){var e=rr.propHooks[this.prop];return e&&e.get?e.get(this):rr.propHooks._default.get(this)},run:function(e){var t,n=rr.propHooks[this.prop];return this.pos=t=this.options.duration?x.easing[this.easing](e,this.options.duration*e,0,1,this.options.duration):e,this.now=(this.end-this.start)*t+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),n&&n.set?n.set(this):rr.propHooks._default.set(this),this}},rr.prototype.init.prototype=rr.prototype,rr.propHooks={_default:{get:function(e){var t;return null==e.elem[e.prop]||e.elem.style&&null!=e.elem.style[e.prop]?(t=x.css(e.elem,e.prop,""),t&&"auto"!==t?t:0):e.elem[e.prop]},set:function(e){x.fx.step[e.prop]?x.fx.step[e.prop](e):e.elem.style&&(null!=e.elem.style[x.cssProps[e.prop]]||x.cssHooks[e.prop])?x.style(e.elem,e.prop,e.now+e.unit):e.elem[e.prop]=e.now}}},rr.propHooks.scrollTop=rr.propHooks.scrollLeft={set:function(e){e.elem.nodeType&&e.elem.parentNode&&(e.elem[e.prop]=e.now)}},x.each(["toggle","show","hide"],function(e,t){var n=x.fn[t];x.fn[t]=function(e,r,i){return null==e||"boolean"==typeof e?n.apply(this,arguments):this.animate(ir(t,!0),e,r,i)}}),x.fn.extend({fadeTo:function(e,t,n,r){return this.filter(nn).css("opacity",0).show().end().animate({opacity:t},e,n,r)},animate:function(e,t,n,r){var i=x.isEmptyObject(e),o=x.speed(t,n,r),a=function(){var t=er(this,x.extend({},e),o);(i||x._data(this,"finish"))&&t.stop(!0)};return a.finish=a,i||o.queue===!1?this.each(a):this.queue(o.queue,a)},stop:function(e,n,r){var i=function(e){var t=e.stop;delete e.stop,t(r)};return"string"!=typeof e&&(r=n,n=e,e=t),n&&e!==!1&&this.queue(e||"fx",[]),this.each(function(){var t=!0,n=null!=e&&e+"queueHooks",o=x.timers,a=x._data(this);if(n)a[n]&&a[n].stop&&i(a[n]);else for(n in a)a[n]&&a[n].stop&&Jn.test(n)&&i(a[n]);for(n=o.length;n--;)o[n].elem!==this||null!=e&&o[n].queue!==e||(o[n].anim.stop(r),t=!1,o.splice(n,1));(t||!r)&&x.dequeue(this,e)})},finish:function(e){return e!==!1&&(e=e||"fx"),this.each(function(){var t,n=x._data(this),r=n[e+"queue"],i=n[e+"queueHooks"],o=x.timers,a=r?r.length:0;for(n.finish=!0,x.queue(this,e,[]),i&&i.stop&&i.stop.call(this,!0),t=o.length;t--;)o[t].elem===this&&o[t].queue===e&&(o[t].anim.stop(!0),o.splice(t,1));for(t=0;a>t;t++)r[t]&&r[t].finish&&r[t].finish.call(this);delete n.finish})}});function ir(e,t){var n,r={height:e},i=0;for(t=t?1:0;4>i;i+=2-t)n=Zt[i],r["margin"+n]=r["padding"+n]=e;return t&&(r.opacity=r.width=e),r}x.each({slideDown:ir("show"),slideUp:ir("hide"),slideToggle:ir("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(e,t){x.fn[e]=function(e,n,r){return this.animate(t,e,n,r)}}),x.speed=function(e,t,n){var r=e&&"object"==typeof e?x.extend({},e):{complete:n||!n&&t||x.isFunction(e)&&e,duration:e,easing:n&&t||t&&!x.isFunction(t)&&t};return r.duration=x.fx.off?0:"number"==typeof r.duration?r.duration:r.duration in x.fx.speeds?x.fx.speeds[r.duration]:x.fx.speeds._default,(null==r.queue||r.queue===!0)&&(r.queue="fx"),r.old=r.complete,r.complete=function(){x.isFunction(r.old)&&r.old.call(this),r.queue&&x.dequeue(this,r.queue)},r},x.easing={linear:function(e){return e},swing:function(e){return.5-Math.cos(e*Math.PI)/2}},x.timers=[],x.fx=rr.prototype.init,x.fx.tick=function(){var e,n=x.timers,r=0;for(Xn=x.now();n.length>r;r++)e=n[r],e()||n[r]!==e||n.splice(r--,1);n.length||x.fx.stop(),Xn=t},x.fx.timer=function(e){e()&&x.timers.push(e)&&x.fx.start()},x.fx.interval=13,x.fx.start=function(){Un||(Un=setInterval(x.fx.tick,x.fx.interval))},x.fx.stop=function(){clearInterval(Un),Un=null},x.fx.speeds={slow:600,fast:200,_default:400},x.fx.step={},x.expr&&x.expr.filters&&(x.expr.filters.animated=function(e){return x.grep(x.timers,function(t){return e===t.elem}).length}),x.fn.offset=function(e){if(arguments.length)return e===t?this:this.each(function(t){x.offset.setOffset(this,e,t)});var n,r,o={top:0,left:0},a=this[0],s=a&&a.ownerDocument;if(s)return n=s.documentElement,x.contains(n,a)?(typeof a.getBoundingClientRect!==i&&(o=a.getBoundingClientRect()),r=or(s),{top:o.top+(r.pageYOffset||n.scrollTop)-(n.clientTop||0),left:o.left+(r.pageXOffset||n.scrollLeft)-(n.clientLeft||0)}):o},x.offset={setOffset:function(e,t,n){var r=x.css(e,"position");"static"===r&&(e.style.position="relative");var i=x(e),o=i.offset(),a=x.css(e,"top"),s=x.css(e,"left"),l=("absolute"===r||"fixed"===r)&&x.inArray("auto",[a,s])>-1,u={},c={},p,f;l?(c=i.position(),p=c.top,f=c.left):(p=parseFloat(a)||0,f=parseFloat(s)||0),x.isFunction(t)&&(t=t.call(e,n,o)),null!=t.top&&(u.top=t.top-o.top+p),null!=t.left&&(u.left=t.left-o.left+f),"using"in t?t.using.call(e,u):i.css(u)}},x.fn.extend({position:function(){if(this[0]){var e,t,n={top:0,left:0},r=this[0];return"fixed"===x.css(r,"position")?t=r.getBoundingClientRect():(e=this.offsetParent(),t=this.offset(),x.nodeName(e[0],"html")||(n=e.offset()),n.top+=x.css(e[0],"borderTopWidth",!0),n.left+=x.css(e[0],"borderLeftWidth",!0)),{top:t.top-n.top-x.css(r,"marginTop",!0),left:t.left-n.left-x.css(r,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var e=this.offsetParent||s;while(e&&!x.nodeName(e,"html")&&"static"===x.css(e,"position"))e=e.offsetParent;return e||s})}}),x.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(e,n){var r=/Y/.test(n);x.fn[e]=function(i){return x.access(this,function(e,i,o){var a=or(e);return o===t?a?n in a?a[n]:a.document.documentElement[i]:e[i]:(a?a.scrollTo(r?x(a).scrollLeft():o,r?o:x(a).scrollTop()):e[i]=o,t)},e,i,arguments.length,null)}});function or(e){return x.isWindow(e)?e:9===e.nodeType?e.defaultView||e.parentWindow:!1}x.each({Height:"height",Width:"width"},function(e,n){x.each({padding:"inner"+e,content:n,"":"outer"+e},function(r,i){x.fn[i]=function(i,o){var a=arguments.length&&(r||"boolean"!=typeof i),s=r||(i===!0||o===!0?"margin":"border");return x.access(this,function(n,r,i){var o;return x.isWindow(n)?n.document.documentElement["client"+e]:9===n.nodeType?(o=n.documentElement,Math.max(n.body["scroll"+e],o["scroll"+e],n.body["offset"+e],o["offset"+e],o["client"+e])):i===t?x.css(n,r,s):x.style(n,r,i,s)},n,a?i:t,a,null)}})}),x.fn.size=function(){return this.length},x.fn.andSelf=x.fn.addBack,"object"==typeof module&&module&&"object"==typeof module.exports?module.exports=x:(e.jQuery=e.$=x,"function"==typeof define&&define.amd&&define("jquery",[],function(){return x}))})(window);
//@prepros-prepend ../lib/jquery-1.10.2.min.js
//@prepros-append ../lib/jquery.mobile.custom.min.js
//@prepros-append ../lib/modernizr.js
//@prepros-append ../lib/jquery.fancybox.min.js
//@prepros-append ../lib/jquery-lazy.js
//@prepros-append global.js
//@prepros-append form.js
//@prepros-append postalcodeLookup.js
/*! jQuery Mobile v1.3.2 | Copyright 2010, 2013 jQuery Foundation, Inc. | jquery.org/license */

(function(e,t,n){typeof define=="function"&&define.amd?define(["jquery"],function(r){return n(r,e,t),r.mobile}):n(e.jQuery,e,t)})(this,document,function(e,t,n,r){(function(e,t,n,r){function x(e){while(e&&typeof e.originalEvent!="undefined")e=e.originalEvent;return e}function T(t,n){var i=t.type,s,o,a,l,c,h,p,d,v;t=e.Event(t),t.type=n,s=t.originalEvent,o=e.event.props,i.search(/^(mouse|click)/)>-1&&(o=f);if(s)for(p=o.length,l;p;)l=o[--p],t[l]=s[l];i.search(/mouse(down|up)|click/)>-1&&!t.which&&(t.which=1);if(i.search(/^touch/)!==-1){a=x(s),i=a.touches,c=a.changedTouches,h=i&&i.length?i[0]:c&&c.length?c[0]:r;if(h)for(d=0,v=u.length;d<v;d++)l=u[d],t[l]=h[l]}return t}function N(t){var n={},r,s;while(t){r=e.data(t,i);for(s in r)r[s]&&(n[s]=n.hasVirtualBinding=!0);t=t.parentNode}return n}function C(t,n){var r;while(t){r=e.data(t,i);if(r&&(!n||r[n]))return t;t=t.parentNode}return null}function k(){g=!1}function L(){g=!0}function A(){E=0,v.length=0,m=!1,L()}function O(){k()}function M(){_(),c=setTimeout(function(){c=0,A()},e.vmouse.resetTimerDuration)}function _(){c&&(clearTimeout(c),c=0)}function D(t,n,r){var i;if(r&&r[t]||!r&&C(n.target,t))i=T(n,t),e(n.target).trigger(i);return i}function P(t){var n=e.data(t.target,s);if(!m&&(!E||E!==n)){var r=D("v"+t.type,t);r&&(r.isDefaultPrevented()&&t.preventDefault(),r.isPropagationStopped()&&t.stopPropagation(),r.isImmediatePropagationStopped()&&t.stopImmediatePropagation())}}function H(t){var n=x(t).touches,r,i;if(n&&n.length===1){r=t.target,i=N(r);if(i.hasVirtualBinding){E=w++,e.data(r,s,E),_(),O(),d=!1;var o=x(t).touches[0];h=o.pageX,p=o.pageY,D("vmouseover",t,i),D("vmousedown",t,i)}}}function B(e){if(g)return;d||D("vmousecancel",e,N(e.target)),d=!0,M()}function j(t){if(g)return;var n=x(t).touches[0],r=d,i=e.vmouse.moveDistanceThreshold,s=N(t.target);d=d||Math.abs(n.pageX-h)>i||Math.abs(n.pageY-p)>i,d&&!r&&D("vmousecancel",t,s),D("vmousemove",t,s),M()}function F(e){if(g)return;L();var t=N(e.target),n;D("vmouseup",e,t);if(!d){var r=D("vclick",e,t);r&&r.isDefaultPrevented()&&(n=x(e).changedTouches[0],v.push({touchID:E,x:n.clientX,y:n.clientY}),m=!0)}D("vmouseout",e,t),d=!1,M()}function I(t){var n=e.data(t,i),r;if(n)for(r in n)if(n[r])return!0;return!1}function q(){}function R(t){var n=t.substr(1);return{setup:function(r,s){I(this)||e.data(this,i,{});var o=e.data(this,i);o[t]=!0,l[t]=(l[t]||0)+1,l[t]===1&&b.bind(n,P),e(this).bind(n,q),y&&(l.touchstart=(l.touchstart||0)+1,l.touchstart===1&&b.bind("touchstart",H).bind("touchend",F).bind("touchmove",j).bind("scroll",B))},teardown:function(r,s){--l[t],l[t]||b.unbind(n,P),y&&(--l.touchstart,l.touchstart||b.unbind("touchstart",H).unbind("touchmove",j).unbind("touchend",F).unbind("scroll",B));var o=e(this),u=e.data(this,i);u&&(u[t]=!1),o.unbind(n,q),I(this)||o.removeData(i)}}}var i="virtualMouseBindings",s="virtualTouchID",o="vmouseover vmousedown vmousemove vmouseup vclick vmouseout vmousecancel".split(" "),u="clientX clientY pageX pageY screenX screenY".split(" "),a=e.event.mouseHooks?e.event.mouseHooks.props:[],f=e.event.props.concat(a),l={},c=0,h=0,p=0,d=!1,v=[],m=!1,g=!1,y="addEventListener"in n,b=e(n),w=1,E=0,S;e.vmouse={moveDistanceThreshold:10,clickDistanceThreshold:10,resetTimerDuration:1500};for(var U=0;U<o.length;U++)e.event.special[o[U]]=R(o[U]);y&&n.addEventListener("click",function(t){var n=v.length,r=t.target,i,o,u,a,f,l;if(n){i=t.clientX,o=t.clientY,S=e.vmouse.clickDistanceThreshold,u=r;while(u){for(a=0;a<n;a++){f=v[a],l=0;if(u===r&&Math.abs(f.x-i)<S&&Math.abs(f.y-o)<S||e.data(u,s)===f.touchID){t.preventDefault(),t.stopPropagation();return}}u=u.parentNode}}},!0)})(e,t,n),function(e){e.mobile={}}(e),function(e,t){var r={touch:"ontouchend"in n};e.mobile.support=e.mobile.support||{},e.extend(e.support,r),e.extend(e.mobile.support,r)}(e),function(e,t,r){function l(t,n,r){var i=r.type;r.type=n,e.event.dispatch.call(t,r),r.type=i}var i=e(n);e.each("touchstart touchmove touchend tap taphold swipe swipeleft swiperight scrollstart scrollstop".split(" "),function(t,n){e.fn[n]=function(e){return e?this.bind(n,e):this.trigger(n)},e.attrFn&&(e.attrFn[n]=!0)});var s=e.mobile.support.touch,o="touchmove scroll",u=s?"touchstart":"mousedown",a=s?"touchend":"mouseup",f=s?"touchmove":"mousemove";e.event.special.scrollstart={enabled:!0,setup:function(){function s(e,n){r=n,l(t,r?"scrollstart":"scrollstop",e)}var t=this,n=e(t),r,i;n.bind(o,function(t){if(!e.event.special.scrollstart.enabled)return;r||s(t,!0),clearTimeout(i),i=setTimeout(function(){s(t,!1)},50)})}},e.event.special.tap={tapholdThreshold:750,setup:function(){var t=this,n=e(t);n.bind("vmousedown",function(r){function a(){clearTimeout(u)}function f(){a(),n.unbind("vclick",c).unbind("vmouseup",a),i.unbind("vmousecancel",f)}function c(e){f(),s===e.target&&l(t,"tap",e)}if(r.which&&r.which!==1)return!1;var s=r.target,o=r.originalEvent,u;n.bind("vmouseup",a).bind("vclick",c),i.bind("vmousecancel",f),u=setTimeout(function(){l(t,"taphold",e.Event("taphold",{target:s}))},e.event.special.tap.tapholdThreshold)})}},e.event.special.swipe={scrollSupressionThreshold:30,durationThreshold:1e3,horizontalDistanceThreshold:30,verticalDistanceThreshold:75,start:function(t){var n=t.originalEvent.touches?t.originalEvent.touches[0]:t;return{time:(new Date).getTime(),coords:[n.pageX,n.pageY],origin:e(t.target)}},stop:function(e){var t=e.originalEvent.touches?e.originalEvent.touches[0]:e;return{time:(new Date).getTime(),coords:[t.pageX,t.pageY]}},handleSwipe:function(t,n){n.time-t.time<e.event.special.swipe.durationThreshold&&Math.abs(t.coords[0]-n.coords[0])>e.event.special.swipe.horizontalDistanceThreshold&&Math.abs(t.coords[1]-n.coords[1])<e.event.special.swipe.verticalDistanceThreshold&&t.origin.trigger("swipe").trigger(t.coords[0]>n.coords[0]?"swipeleft":"swiperight")},setup:function(){var t=this,n=e(t);n.bind(u,function(t){function o(t){if(!i)return;s=e.event.special.swipe.stop(t),Math.abs(i.coords[0]-s.coords[0])>e.event.special.swipe.scrollSupressionThreshold&&t.preventDefault()}var i=e.event.special.swipe.start(t),s;n.bind(f,o).one(a,function(){n.unbind(f,o),i&&s&&e.event.special.swipe.handleSwipe(i,s),i=s=r})})}},e.each({scrollstop:"scrollstart",taphold:"tap",swipeleft:"swipe",swiperight:"swipe"},function(t,n){e.event.special[t]={setup:function(){e(this).bind(n,e.noop)}}})}(e,this)});
/*! modernizr 3.3.1 (Custom Build) | MIT *
 * https://modernizr.com/download/?-applicationcache-audio-backgroundsize-borderimage-borderradius-boxshadow-canvas-canvastext-cssanimations-cssgradients-cssreflections-csstransforms-csstransforms3d-csstransitions-flexbox-flexboxlegacy-fontface-generatedcontent-hashchange-history-hsla-indexeddb-input-inputtypes-localstorage-multiplebgs-objectfit-opacity-postmessage-rgba-sessionstorage-textshadow-video-websockets-websqldatabase-webworkers-domprefixes-hasevent-mq-prefixes-setclasses-shiv-testallprops-testprop-teststyles !*/
!function(e,t,n){function r(e,t){return typeof e===t}function a(){var e,t,n,a,o,i,s;for(var c in b)if(b.hasOwnProperty(c)){if(e=[],t=b[c],t.name&&(e.push(t.name.toLowerCase()),t.options&&t.options.aliases&&t.options.aliases.length))for(n=0;n<t.options.aliases.length;n++)e.push(t.options.aliases[n].toLowerCase());for(a=r(t.fn,"function")?t.fn():t.fn,o=0;o<e.length;o++)i=e[o],s=i.split("."),1===s.length?Modernizr[s[0]]=a:(!Modernizr[s[0]]||Modernizr[s[0]]instanceof Boolean||(Modernizr[s[0]]=new Boolean(Modernizr[s[0]])),Modernizr[s[0]][s[1]]=a),y.push((a?"":"no-")+s.join("-"))}}function o(e){var t=S.className,n=Modernizr._config.classPrefix||"";if(E&&(t=t.baseVal),Modernizr._config.enableJSClass){var r=new RegExp("(^|\\s)"+n+"no-js(\\s|$)");t=t.replace(r,"$1"+n+"js$2")}Modernizr._config.enableClasses&&(t+=" "+n+e.join(" "+n),E?S.className.baseVal=t:S.className=t)}function i(){return"function"!=typeof t.createElement?t.createElement(arguments[0]):E?t.createElementNS.call(t,"http://www.w3.org/2000/svg",arguments[0]):t.createElement.apply(t,arguments)}function s(e,t){return!!~(""+e).indexOf(t)}function c(){var e=t.body;return e||(e=i(E?"svg":"body"),e.fake=!0),e}function d(e,n,r,a){var o,s,d,l,u="modernizr",f=i("div"),p=c();if(parseInt(r,10))for(;r--;)d=i("div"),d.id=a?a[r]:u+(r+1),f.appendChild(d);return o=i("style"),o.type="text/css",o.id="s"+u,(p.fake?p:f).appendChild(o),p.appendChild(f),o.styleSheet?o.styleSheet.cssText=e:o.appendChild(t.createTextNode(e)),f.id=u,p.fake&&(p.style.background="",p.style.overflow="hidden",l=S.style.overflow,S.style.overflow="hidden",S.appendChild(p)),s=n(f,e),p.fake?(p.parentNode.removeChild(p),S.style.overflow=l,S.offsetHeight):f.parentNode.removeChild(f),!!s}function l(e){return e.replace(/([a-z])-([a-z])/g,function(e,t,n){return t+n.toUpperCase()}).replace(/^-/,"")}function u(e,t){return function(){return e.apply(t,arguments)}}function f(e,t,n){var a;for(var o in e)if(e[o]in t)return n===!1?e[o]:(a=t[e[o]],r(a,"function")?u(a,n||t):a);return!1}function p(e){return e.replace(/([A-Z])/g,function(e,t){return"-"+t.toLowerCase()}).replace(/^ms-/,"-ms-")}function m(t,r){var a=t.length;if("CSS"in e&&"supports"in e.CSS){for(;a--;)if(e.CSS.supports(p(t[a]),r))return!0;return!1}if("CSSSupportsRule"in e){for(var o=[];a--;)o.push("("+p(t[a])+":"+r+")");return o=o.join(" or "),d("@supports ("+o+") { #modernizr { position: absolute; } }",function(e){return"absolute"==getComputedStyle(e,null).position})}return n}function h(e,t,a,o){function c(){u&&(delete B.style,delete B.modElem)}if(o=r(o,"undefined")?!1:o,!r(a,"undefined")){var d=m(e,a);if(!r(d,"undefined"))return d}for(var u,f,p,h,g,v=["modernizr","tspan","samp"];!B.style&&v.length;)u=!0,B.modElem=i(v.shift()),B.style=B.modElem.style;for(p=e.length,f=0;p>f;f++)if(h=e[f],g=B.style[h],s(h,"-")&&(h=l(h)),B.style[h]!==n){if(o||r(a,"undefined"))return c(),"pfx"==t?h:!0;try{B.style[h]=a}catch(y){}if(B.style[h]!=g)return c(),"pfx"==t?h:!0}return c(),!1}function g(e,t,n,a,o){var i=e.charAt(0).toUpperCase()+e.slice(1),s=(e+" "+D.join(i+" ")+i).split(" ");return r(t,"string")||r(t,"undefined")?h(s,t,a,o):(s=(e+" "+P.join(i+" ")+i).split(" "),f(s,t,n))}function v(e,t,r){return g(e,n,n,t,r)}var y=[],b=[],x={_version:"3.3.1",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,t){var n=this;setTimeout(function(){t(n[e])},0)},addTest:function(e,t,n){b.push({name:e,fn:t,options:n})},addAsyncTest:function(e){b.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=x,Modernizr=new Modernizr,Modernizr.addTest("applicationcache","applicationCache"in e),Modernizr.addTest("history",function(){var t=navigator.userAgent;return-1===t.indexOf("Android 2.")&&-1===t.indexOf("Android 4.0")||-1===t.indexOf("Mobile Safari")||-1!==t.indexOf("Chrome")||-1!==t.indexOf("Windows Phone")?e.history&&"pushState"in e.history:!1}),Modernizr.addTest("postmessage","postMessage"in e);var T=!1;try{T="WebSocket"in e&&2===e.WebSocket.CLOSING}catch(w){}Modernizr.addTest("websockets",T),Modernizr.addTest("localstorage",function(){var e="modernizr";try{return localStorage.setItem(e,e),localStorage.removeItem(e),!0}catch(t){return!1}}),Modernizr.addTest("sessionstorage",function(){var e="modernizr";try{return sessionStorage.setItem(e,e),sessionStorage.removeItem(e),!0}catch(t){return!1}}),Modernizr.addTest("websqldatabase","openDatabase"in e),Modernizr.addTest("webworkers","Worker"in e);var C=x._config.usePrefixes?" -webkit- -moz- -o- -ms- ".split(" "):["",""];x._prefixes=C;var S=t.documentElement,E="svg"===S.nodeName.toLowerCase();E||!function(e,t){function n(e,t){var n=e.createElement("p"),r=e.getElementsByTagName("head")[0]||e.documentElement;return n.innerHTML="x<style>"+t+"</style>",r.insertBefore(n.lastChild,r.firstChild)}function r(){var e=b.elements;return"string"==typeof e?e.split(" "):e}function a(e,t){var n=b.elements;"string"!=typeof n&&(n=n.join(" ")),"string"!=typeof e&&(e=e.join(" ")),b.elements=n+" "+e,d(t)}function o(e){var t=y[e[g]];return t||(t={},v++,e[g]=v,y[v]=t),t}function i(e,n,r){if(n||(n=t),u)return n.createElement(e);r||(r=o(n));var a;return a=r.cache[e]?r.cache[e].cloneNode():h.test(e)?(r.cache[e]=r.createElem(e)).cloneNode():r.createElem(e),!a.canHaveChildren||m.test(e)||a.tagUrn?a:r.frag.appendChild(a)}function s(e,n){if(e||(e=t),u)return e.createDocumentFragment();n=n||o(e);for(var a=n.frag.cloneNode(),i=0,s=r(),c=s.length;c>i;i++)a.createElement(s[i]);return a}function c(e,t){t.cache||(t.cache={},t.createElem=e.createElement,t.createFrag=e.createDocumentFragment,t.frag=t.createFrag()),e.createElement=function(n){return b.shivMethods?i(n,e,t):t.createElem(n)},e.createDocumentFragment=Function("h,f","return function(){var n=f.cloneNode(),c=n.createElement;h.shivMethods&&("+r().join().replace(/[\w\-:]+/g,function(e){return t.createElem(e),t.frag.createElement(e),'c("'+e+'")'})+");return n}")(b,t.frag)}function d(e){e||(e=t);var r=o(e);return!b.shivCSS||l||r.hasCSS||(r.hasCSS=!!n(e,"article,aside,dialog,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}mark{background:#FF0;color:#000}template{display:none}")),u||c(e,r),e}var l,u,f="3.7.3",p=e.html5||{},m=/^<|^(?:button|map|select|textarea|object|iframe|option|optgroup)$/i,h=/^(?:a|b|code|div|fieldset|h1|h2|h3|h4|h5|h6|i|label|li|ol|p|q|span|strong|style|table|tbody|td|th|tr|ul)$/i,g="_html5shiv",v=0,y={};!function(){try{var e=t.createElement("a");e.innerHTML="<xyz></xyz>",l="hidden"in e,u=1==e.childNodes.length||function(){t.createElement("a");var e=t.createDocumentFragment();return"undefined"==typeof e.cloneNode||"undefined"==typeof e.createDocumentFragment||"undefined"==typeof e.createElement}()}catch(n){l=!0,u=!0}}();var b={elements:p.elements||"abbr article aside audio bdi canvas data datalist details dialog figcaption figure footer header hgroup main mark meter nav output picture progress section summary template time video",version:f,shivCSS:p.shivCSS!==!1,supportsUnknownElements:u,shivMethods:p.shivMethods!==!1,type:"default",shivDocument:d,createElement:i,createDocumentFragment:s,addElements:a};e.html5=b,d(t),"object"==typeof module&&module.exports&&(module.exports=b)}("undefined"!=typeof e?e:this,t);var k="Moz O ms Webkit",P=x._config.usePrefixes?k.toLowerCase().split(" "):[];x._domPrefixes=P;var _=function(){function e(e,t){var a;return e?(t&&"string"!=typeof t||(t=i(t||"div")),e="on"+e,a=e in t,!a&&r&&(t.setAttribute||(t=i("div")),t.setAttribute(e,""),a="function"==typeof t[e],t[e]!==n&&(t[e]=n),t.removeAttribute(e)),a):!1}var r=!("onblur"in t.documentElement);return e}();x.hasEvent=_,Modernizr.addTest("hashchange",function(){return _("hashchange",e)===!1?!1:t.documentMode===n||t.documentMode>7}),Modernizr.addTest("audio",function(){var e=i("audio"),t=!1;try{(t=!!e.canPlayType)&&(t=new Boolean(t),t.ogg=e.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/,""),t.mp3=e.canPlayType('audio/mpeg; codecs="mp3"').replace(/^no$/,""),t.opus=e.canPlayType('audio/ogg; codecs="opus"')||e.canPlayType('audio/webm; codecs="opus"').replace(/^no$/,""),t.wav=e.canPlayType('audio/wav; codecs="1"').replace(/^no$/,""),t.m4a=(e.canPlayType("audio/x-m4a;")||e.canPlayType("audio/aac;")).replace(/^no$/,""))}catch(n){}return t}),Modernizr.addTest("canvas",function(){var e=i("canvas");return!(!e.getContext||!e.getContext("2d"))}),Modernizr.addTest("canvastext",function(){return Modernizr.canvas===!1?!1:"function"==typeof i("canvas").getContext("2d").fillText}),Modernizr.addTest("video",function(){var e=i("video"),t=!1;try{(t=!!e.canPlayType)&&(t=new Boolean(t),t.ogg=e.canPlayType('video/ogg; codecs="theora"').replace(/^no$/,""),t.h264=e.canPlayType('video/mp4; codecs="avc1.42E01E"').replace(/^no$/,""),t.webm=e.canPlayType('video/webm; codecs="vp8, vorbis"').replace(/^no$/,""),t.vp9=e.canPlayType('video/webm; codecs="vp9"').replace(/^no$/,""),t.hls=e.canPlayType('application/x-mpegURL; codecs="avc1.42E01E"').replace(/^no$/,""))}catch(n){}return t}),Modernizr.addTest("cssgradients",function(){for(var e,t="background-image:",n="gradient(linear,left top,right bottom,from(#9f9),to(white));",r="",a=0,o=C.length-1;o>a;a++)e=0===a?"to ":"",r+=t+C[a]+"linear-gradient("+e+"left top, #9f9, white);";Modernizr._config.usePrefixes&&(r+=t+"-webkit-"+n);var s=i("a"),c=s.style;return c.cssText=r,(""+c.backgroundImage).indexOf("gradient")>-1}),Modernizr.addTest("multiplebgs",function(){var e=i("a").style;return e.cssText="background:url(https://),url(https://),red url(https://)",/(url\s*\(.*?){3}/.test(e.background)}),Modernizr.addTest("opacity",function(){var e=i("a").style;return e.cssText=C.join("opacity:.55;"),/^0.55$/.test(e.opacity)}),Modernizr.addTest("rgba",function(){var e=i("a").style;return e.cssText="background-color:rgba(150,255,150,.5)",(""+e.backgroundColor).indexOf("rgba")>-1});var z=i("input"),$="autocomplete autofocus list placeholder max min multiple pattern required step".split(" "),A={};Modernizr.input=function(t){for(var n=0,r=t.length;r>n;n++)A[t[n]]=!!(t[n]in z);return A.list&&(A.list=!(!i("datalist")||!e.HTMLDataListElement)),A}($);var N="search tel url email datetime date month week time datetime-local number range color".split(" "),j={};Modernizr.inputtypes=function(e){for(var r,a,o,i=e.length,s="1)",c=0;i>c;c++)z.setAttribute("type",r=e[c]),o="text"!==z.type&&"style"in z,o&&(z.value=s,z.style.cssText="position:absolute;visibility:hidden;",/^range$/.test(r)&&z.style.WebkitAppearance!==n?(S.appendChild(z),a=t.defaultView,o=a.getComputedStyle&&"textfield"!==a.getComputedStyle(z,null).WebkitAppearance&&0!==z.offsetHeight,S.removeChild(z)):/^(search|tel)$/.test(r)||(o=/^(url|email)$/.test(r)?z.checkValidity&&z.checkValidity()===!1:z.value!=s)),j[e[c]]=!!o;return j}(N),Modernizr.addTest("hsla",function(){var e=i("a").style;return e.cssText="background-color:hsla(120,40%,100%,.5)",s(e.backgroundColor,"rgba")||s(e.backgroundColor,"hsla")});var M="CSS"in e&&"supports"in e.CSS,O="supportsCSS"in e;Modernizr.addTest("supports",M||O);var F=function(){var t=e.matchMedia||e.msMatchMedia;return t?function(e){var n=t(e);return n&&n.matches||!1}:function(t){var n=!1;return d("@media "+t+" { #modernizr { position: absolute; } }",function(t){n="absolute"==(e.getComputedStyle?e.getComputedStyle(t,null):t.currentStyle).position}),n}}();x.mq=F;var R=x.testStyles=d,L=function(){var e=navigator.userAgent,t=e.match(/applewebkit\/([0-9]+)/gi)&&parseFloat(RegExp.$1),n=e.match(/w(eb)?osbrowser/gi),r=e.match(/windows phone/gi)&&e.match(/iemobile\/([0-9])+/gi)&&parseFloat(RegExp.$1)>=9,a=533>t&&e.match(/android/gi);return n||a||r}();L?Modernizr.addTest("fontface",!1):R('@font-face {font-family:"font";src:url("https://")}',function(e,n){var r=t.getElementById("smodernizr"),a=r.sheet||r.styleSheet,o=a?a.cssRules&&a.cssRules[0]?a.cssRules[0].cssText:a.cssText||"":"",i=/src/i.test(o)&&0===o.indexOf(n.split(" ")[0]);Modernizr.addTest("fontface",i)}),R('#modernizr{font:0/0 a}#modernizr:after{content:":)";visibility:hidden;font:7px/1 a}',function(e){Modernizr.addTest("generatedcontent",e.offsetHeight>=7)});var D=x._config.usePrefixes?k.split(" "):[];x._cssomPrefixes=D;var I=function(t){var r,a=C.length,o=e.CSSRule;if("undefined"==typeof o)return n;if(!t)return!1;if(t=t.replace(/^@/,""),r=t.replace(/-/g,"_").toUpperCase()+"_RULE",r in o)return"@"+t;for(var i=0;a>i;i++){var s=C[i],c=s.toUpperCase()+"_"+r;if(c in o)return"@-"+s.toLowerCase()+"-"+t}return!1};x.atRule=I;var q={elem:i("modernizr")};Modernizr._q.push(function(){delete q.elem});var B={style:q.elem.style};Modernizr._q.unshift(function(){delete B.style});var H=x.testProp=function(e,t,r){return h([e],n,t,r)};Modernizr.addTest("textshadow",H("textShadow","1px 1px")),x.testAllProps=g,x.testAllProps=v,Modernizr.addTest("cssanimations",v("animationName","a",!0)),Modernizr.addTest("backgroundsize",v("backgroundSize","100%",!0)),Modernizr.addTest("borderimage",v("borderImage","url() 1",!0)),Modernizr.addTest("borderradius",v("borderRadius","0px",!0)),Modernizr.addTest("boxshadow",v("boxShadow","1px 1px",!0)),Modernizr.addTest("flexbox",v("flexBasis","1px",!0)),Modernizr.addTest("flexboxlegacy",v("boxDirection","reverse",!0)),Modernizr.addTest("cssreflections",v("boxReflect","above",!0)),Modernizr.addTest("csstransforms",function(){return-1===navigator.userAgent.indexOf("Android 2.")&&v("transform","scale(1)",!0)}),Modernizr.addTest("csstransforms3d",function(){var e=!!v("perspective","1px",!0),t=Modernizr._config.usePrefixes;if(e&&(!t||"webkitPerspective"in S.style)){var n,r="#modernizr{width:0;height:0}";Modernizr.supports?n="@supports (perspective: 1px)":(n="@media (transform-3d)",t&&(n+=",(-webkit-transform-3d)")),n+="{#modernizr{width:7px;height:18px;margin:0;padding:0;border:0}}",R(r+n,function(t){e=7===t.offsetWidth&&18===t.offsetHeight})}return e}),Modernizr.addTest("csstransitions",v("transition","all",!0));var U,W=x.prefixed=function(e,t,n){return 0===e.indexOf("@")?I(e):(-1!=e.indexOf("-")&&(e=l(e)),t?g(e,t,n):g(e,"pfx"))};try{U=W("indexedDB",e)}catch(w){}Modernizr.addTest("indexeddb",!!U),U&&Modernizr.addTest("indexeddb.deletedatabase","deleteDatabase"in U),Modernizr.addTest("objectfit",!!W("objectFit"),{aliases:["object-fit"]}),a(),o(y),delete x.addTest,delete x.addAsyncTest;for(var V=0;V<Modernizr._q.length;V++)Modernizr._q[V]();e.Modernizr=Modernizr}(window,document);
// ==================================================
// fancyBox v3.5.7
//
// Licensed GPLv3 for open source use
// or fancyBox Commercial License for commercial use
//
// http://fancyapps.com/fancybox/
// Copyright 2019 fancyApps
//
// ==================================================
!function(t,e,n,o){"use strict";function i(t,e){var o,i,a,s=[],r=0;t&&t.isDefaultPrevented()||(t.preventDefault(),e=e||{},t&&t.data&&(e=h(t.data.options,e)),o=e.$target||n(t.currentTarget).trigger("blur"),(a=n.fancybox.getInstance())&&a.$trigger&&a.$trigger.is(o)||(e.selector?s=n(e.selector):(i=o.attr("data-fancybox")||"",i?(s=t.data?t.data.items:[],s=s.length?s.filter('[data-fancybox="'+i+'"]'):n('[data-fancybox="'+i+'"]')):s=[o]),r=n(s).index(o),r<0&&(r=0),a=n.fancybox.open(s,e,r),a.$trigger=o))}if(t.console=t.console||{info:function(t){}},n){if(n.fn.fancybox)return void console.info("fancyBox already initialized");var a={closeExisting:!1,loop:!1,gutter:50,keyboard:!0,preventCaptionOverlap:!0,arrows:!0,infobar:!0,smallBtn:"auto",toolbar:"auto",buttons:["zoom","slideShow","thumbs","close"],idleTime:3,protect:!1,modal:!1,image:{preload:!1},ajax:{settings:{data:{fancybox:!0}}},iframe:{tpl:'<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" allowfullscreen="allowfullscreen" allow="autoplay; fullscreen" src=""></iframe>',preload:!0,css:{},attr:{scrolling:"auto"}},video:{tpl:'<video class="fancybox-video" controls controlsList="nodownload" poster="{{poster}}"><source src="{{src}}" type="{{format}}" />Sorry, your browser doesn\'t support embedded videos, <a href="{{src}}">download</a> and watch with your favorite video player!</video>',format:"",autoStart:!0},defaultType:"image",animationEffect:"zoom",animationDuration:366,zoomOpacity:"auto",transitionEffect:"fade",transitionDuration:366,slideClass:"",baseClass:"",baseTpl:'<div class="fancybox-container" role="dialog" tabindex="-1"><div class="fancybox-bg"></div><div class="fancybox-inner"><div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div><div class="fancybox-toolbar">{{buttons}}</div><div class="fancybox-navigation">{{arrows}}</div><div class="fancybox-stage"></div><div class="fancybox-caption"><div class="fancybox-caption__body"></div></div></div></div>',spinnerTpl:'<div class="fancybox-loading"></div>',errorTpl:'<div class="fancybox-error"><p>{{ERROR}}</p></div>',btnTpl:{download:'<a download data-fancybox-download class="fancybox-button fancybox-button--download" title="{{DOWNLOAD}}" href="javascript:;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.62 17.09V19H5.38v-1.91zm-2.97-6.96L17 11.45l-5 4.87-5-4.87 1.36-1.32 2.68 2.64V5h1.92v7.77z"/></svg></a>',zoom:'<button data-fancybox-zoom class="fancybox-button fancybox-button--zoom" title="{{ZOOM}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.7 17.3l-3-3a5.9 5.9 0 0 0-.6-7.6 5.9 5.9 0 0 0-8.4 0 5.9 5.9 0 0 0 0 8.4 5.9 5.9 0 0 0 7.7.7l3 3a1 1 0 0 0 1.3 0c.4-.5.4-1 0-1.5zM8.1 13.8a4 4 0 0 1 0-5.7 4 4 0 0 1 5.7 0 4 4 0 0 1 0 5.7 4 4 0 0 1-5.7 0z"/></svg></button>',close:'<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"/></svg></button>',arrowLeft:'<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.28 15.7l-1.34 1.37L5 12l4.94-5.07 1.34 1.38-2.68 2.72H19v1.94H8.6z"/></svg></div></button>',arrowRight:'<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.4 12.97l-2.68 2.72 1.34 1.38L19 12l-4.94-5.07-1.34 1.38 2.68 2.72H5v1.94z"/></svg></div></button>',smallBtn:'<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"/></svg></button>'},parentEl:"body",hideScrollbar:!0,autoFocus:!0,backFocus:!0,trapFocus:!0,fullScreen:{autoStart:!1},touch:{vertical:!0,momentum:!0},hash:null,media:{},slideShow:{autoStart:!1,speed:3e3},thumbs:{autoStart:!1,hideOnClose:!0,parentEl:".fancybox-container",axis:"y"},wheel:"auto",onInit:n.noop,beforeLoad:n.noop,afterLoad:n.noop,beforeShow:n.noop,afterShow:n.noop,beforeClose:n.noop,afterClose:n.noop,onActivate:n.noop,onDeactivate:n.noop,clickContent:function(t,e){return"image"===t.type&&"zoom"},clickSlide:"close",clickOutside:"close",dblclickContent:!1,dblclickSlide:!1,dblclickOutside:!1,mobile:{preventCaptionOverlap:!1,idleTime:!1,clickContent:function(t,e){return"image"===t.type&&"toggleControls"},clickSlide:function(t,e){return"image"===t.type?"toggleControls":"close"},dblclickContent:function(t,e){return"image"===t.type&&"zoom"},dblclickSlide:function(t,e){return"image"===t.type&&"zoom"}},lang:"en",i18n:{en:{CLOSE:"Close",NEXT:"Next",PREV:"Previous",ERROR:"The requested content cannot be loaded. <br/> Please try again later.",PLAY_START:"Start slideshow",PLAY_STOP:"Pause slideshow",FULL_SCREEN:"Full screen",THUMBS:"Thumbnails",DOWNLOAD:"Download",SHARE:"Share",ZOOM:"Zoom"},de:{CLOSE:"Schlie&szlig;en",NEXT:"Weiter",PREV:"Zur&uuml;ck",ERROR:"Die angeforderten Daten konnten nicht geladen werden. <br/> Bitte versuchen Sie es sp&auml;ter nochmal.",PLAY_START:"Diaschau starten",PLAY_STOP:"Diaschau beenden",FULL_SCREEN:"Vollbild",THUMBS:"Vorschaubilder",DOWNLOAD:"Herunterladen",SHARE:"Teilen",ZOOM:"Vergr&ouml;&szlig;ern"}}},s=n(t),r=n(e),c=0,l=function(t){return t&&t.hasOwnProperty&&t instanceof n},d=function(){return t.requestAnimationFrame||t.webkitRequestAnimationFrame||t.mozRequestAnimationFrame||t.oRequestAnimationFrame||function(e){return t.setTimeout(e,1e3/60)}}(),u=function(){return t.cancelAnimationFrame||t.webkitCancelAnimationFrame||t.mozCancelAnimationFrame||t.oCancelAnimationFrame||function(e){t.clearTimeout(e)}}(),f=function(){var t,n=e.createElement("fakeelement"),o={transition:"transitionend",OTransition:"oTransitionEnd",MozTransition:"transitionend",WebkitTransition:"webkitTransitionEnd"};for(t in o)if(void 0!==n.style[t])return o[t];return"transitionend"}(),p=function(t){return t&&t.length&&t[0].offsetHeight},h=function(t,e){var o=n.extend(!0,{},t,e);return n.each(e,function(t,e){n.isArray(e)&&(o[t]=e)}),o},g=function(t){var o,i;return!(!t||t.ownerDocument!==e)&&(n(".fancybox-container").css("pointer-events","none"),o={x:t.getBoundingClientRect().left+t.offsetWidth/2,y:t.getBoundingClientRect().top+t.offsetHeight/2},i=e.elementFromPoint(o.x,o.y)===t,n(".fancybox-container").css("pointer-events",""),i)},b=function(t,e,o){var i=this;i.opts=h({index:o},n.fancybox.defaults),n.isPlainObject(e)&&(i.opts=h(i.opts,e)),n.fancybox.isMobile&&(i.opts=h(i.opts,i.opts.mobile)),i.id=i.opts.id||++c,i.currIndex=parseInt(i.opts.index,10)||0,i.prevIndex=null,i.prevPos=null,i.currPos=0,i.firstRun=!0,i.group=[],i.slides={},i.addContent(t),i.group.length&&i.init()};n.extend(b.prototype,{init:function(){var o,i,a=this,s=a.group[a.currIndex],r=s.opts;r.closeExisting&&n.fancybox.close(!0),n("body").addClass("fancybox-active"),!n.fancybox.getInstance()&&!1!==r.hideScrollbar&&!n.fancybox.isMobile&&e.body.scrollHeight>t.innerHeight&&(n("head").append('<style id="fancybox-style-noscroll" type="text/css">.compensate-for-scrollbar{margin-right:'+(t.innerWidth-e.documentElement.clientWidth)+"px;}</style>"),n("body").addClass("compensate-for-scrollbar")),i="",n.each(r.buttons,function(t,e){i+=r.btnTpl[e]||""}),o=n(a.translate(a,r.baseTpl.replace("{{buttons}}",i).replace("{{arrows}}",r.btnTpl.arrowLeft+r.btnTpl.arrowRight))).attr("id","fancybox-container-"+a.id).addClass(r.baseClass).data("FancyBox",a).appendTo(r.parentEl),a.$refs={container:o},["bg","inner","infobar","toolbar","stage","caption","navigation"].forEach(function(t){a.$refs[t]=o.find(".fancybox-"+t)}),a.trigger("onInit"),a.activate(),a.jumpTo(a.currIndex)},translate:function(t,e){var n=t.opts.i18n[t.opts.lang]||t.opts.i18n.en;return e.replace(/\{\{(\w+)\}\}/g,function(t,e){return void 0===n[e]?t:n[e]})},addContent:function(t){var e,o=this,i=n.makeArray(t);n.each(i,function(t,e){var i,a,s,r,c,l={},d={};n.isPlainObject(e)?(l=e,d=e.opts||e):"object"===n.type(e)&&n(e).length?(i=n(e),d=i.data()||{},d=n.extend(!0,{},d,d.options),d.$orig=i,l.src=o.opts.src||d.src||i.attr("href"),l.type||l.src||(l.type="inline",l.src=e)):l={type:"html",src:e+""},l.opts=n.extend(!0,{},o.opts,d),n.isArray(d.buttons)&&(l.opts.buttons=d.buttons),n.fancybox.isMobile&&l.opts.mobile&&(l.opts=h(l.opts,l.opts.mobile)),a=l.type||l.opts.type,r=l.src||"",!a&&r&&((s=r.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i))?(a="video",l.opts.video.format||(l.opts.video.format="video/"+("ogv"===s[1]?"ogg":s[1]))):r.match(/(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i)?a="image":r.match(/\.(pdf)((\?|#).*)?$/i)?(a="iframe",l=n.extend(!0,l,{contentType:"pdf",opts:{iframe:{preload:!1}}})):"#"===r.charAt(0)&&(a="inline")),a?l.type=a:o.trigger("objectNeedsType",l),l.contentType||(l.contentType=n.inArray(l.type,["html","inline","ajax"])>-1?"html":l.type),l.index=o.group.length,"auto"==l.opts.smallBtn&&(l.opts.smallBtn=n.inArray(l.type,["html","inline","ajax"])>-1),"auto"===l.opts.toolbar&&(l.opts.toolbar=!l.opts.smallBtn),l.$thumb=l.opts.$thumb||null,l.opts.$trigger&&l.index===o.opts.index&&(l.$thumb=l.opts.$trigger.find("img:first"),l.$thumb.length&&(l.opts.$orig=l.opts.$trigger)),l.$thumb&&l.$thumb.length||!l.opts.$orig||(l.$thumb=l.opts.$orig.find("img:first")),l.$thumb&&!l.$thumb.length&&(l.$thumb=null),l.thumb=l.opts.thumb||(l.$thumb?l.$thumb[0].src:null),"function"===n.type(l.opts.caption)&&(l.opts.caption=l.opts.caption.apply(e,[o,l])),"function"===n.type(o.opts.caption)&&(l.opts.caption=o.opts.caption.apply(e,[o,l])),l.opts.caption instanceof n||(l.opts.caption=void 0===l.opts.caption?"":l.opts.caption+""),"ajax"===l.type&&(c=r.split(/\s+/,2),c.length>1&&(l.src=c.shift(),l.opts.filter=c.shift())),l.opts.modal&&(l.opts=n.extend(!0,l.opts,{trapFocus:!0,infobar:0,toolbar:0,smallBtn:0,keyboard:0,slideShow:0,fullScreen:0,thumbs:0,touch:0,clickContent:!1,clickSlide:!1,clickOutside:!1,dblclickContent:!1,dblclickSlide:!1,dblclickOutside:!1})),o.group.push(l)}),Object.keys(o.slides).length&&(o.updateControls(),(e=o.Thumbs)&&e.isActive&&(e.create(),e.focus()))},addEvents:function(){var e=this;e.removeEvents(),e.$refs.container.on("click.fb-close","[data-fancybox-close]",function(t){t.stopPropagation(),t.preventDefault(),e.close(t)}).on("touchstart.fb-prev click.fb-prev","[data-fancybox-prev]",function(t){t.stopPropagation(),t.preventDefault(),e.previous()}).on("touchstart.fb-next click.fb-next","[data-fancybox-next]",function(t){t.stopPropagation(),t.preventDefault(),e.next()}).on("click.fb","[data-fancybox-zoom]",function(t){e[e.isScaledDown()?"scaleToActual":"scaleToFit"]()}),s.on("orientationchange.fb resize.fb",function(t){t&&t.originalEvent&&"resize"===t.originalEvent.type?(e.requestId&&u(e.requestId),e.requestId=d(function(){e.update(t)})):(e.current&&"iframe"===e.current.type&&e.$refs.stage.hide(),setTimeout(function(){e.$refs.stage.show(),e.update(t)},n.fancybox.isMobile?600:250))}),r.on("keydown.fb",function(t){var o=n.fancybox?n.fancybox.getInstance():null,i=o.current,a=t.keyCode||t.which;if(9==a)return void(i.opts.trapFocus&&e.focus(t));if(!(!i.opts.keyboard||t.ctrlKey||t.altKey||t.shiftKey||n(t.target).is("input,textarea,video,audio,select")))return 8===a||27===a?(t.preventDefault(),void e.close(t)):37===a||38===a?(t.preventDefault(),void e.previous()):39===a||40===a?(t.preventDefault(),void e.next()):void e.trigger("afterKeydown",t,a)}),e.group[e.currIndex].opts.idleTime&&(e.idleSecondsCounter=0,r.on("mousemove.fb-idle mouseleave.fb-idle mousedown.fb-idle touchstart.fb-idle touchmove.fb-idle scroll.fb-idle keydown.fb-idle",function(t){e.idleSecondsCounter=0,e.isIdle&&e.showControls(),e.isIdle=!1}),e.idleInterval=t.setInterval(function(){++e.idleSecondsCounter>=e.group[e.currIndex].opts.idleTime&&!e.isDragging&&(e.isIdle=!0,e.idleSecondsCounter=0,e.hideControls())},1e3))},removeEvents:function(){var e=this;s.off("orientationchange.fb resize.fb"),r.off("keydown.fb .fb-idle"),this.$refs.container.off(".fb-close .fb-prev .fb-next"),e.idleInterval&&(t.clearInterval(e.idleInterval),e.idleInterval=null)},previous:function(t){return this.jumpTo(this.currPos-1,t)},next:function(t){return this.jumpTo(this.currPos+1,t)},jumpTo:function(t,e){var o,i,a,s,r,c,l,d,u,f=this,h=f.group.length;if(!(f.isDragging||f.isClosing||f.isAnimating&&f.firstRun)){if(t=parseInt(t,10),!(a=f.current?f.current.opts.loop:f.opts.loop)&&(t<0||t>=h))return!1;if(o=f.firstRun=!Object.keys(f.slides).length,r=f.current,f.prevIndex=f.currIndex,f.prevPos=f.currPos,s=f.createSlide(t),h>1&&((a||s.index<h-1)&&f.createSlide(t+1),(a||s.index>0)&&f.createSlide(t-1)),f.current=s,f.currIndex=s.index,f.currPos=s.pos,f.trigger("beforeShow",o),f.updateControls(),s.forcedDuration=void 0,n.isNumeric(e)?s.forcedDuration=e:e=s.opts[o?"animationDuration":"transitionDuration"],e=parseInt(e,10),i=f.isMoved(s),s.$slide.addClass("fancybox-slide--current"),o)return s.opts.animationEffect&&e&&f.$refs.container.css("transition-duration",e+"ms"),f.$refs.container.addClass("fancybox-is-open").trigger("focus"),f.loadSlide(s),void f.preload("image");c=n.fancybox.getTranslate(r.$slide),l=n.fancybox.getTranslate(f.$refs.stage),n.each(f.slides,function(t,e){n.fancybox.stop(e.$slide,!0)}),r.pos!==s.pos&&(r.isComplete=!1),r.$slide.removeClass("fancybox-slide--complete fancybox-slide--current"),i?(u=c.left-(r.pos*c.width+r.pos*r.opts.gutter),n.each(f.slides,function(t,o){o.$slide.removeClass("fancybox-animated").removeClass(function(t,e){return(e.match(/(^|\s)fancybox-fx-\S+/g)||[]).join(" ")});var i=o.pos*c.width+o.pos*o.opts.gutter;n.fancybox.setTranslate(o.$slide,{top:0,left:i-l.left+u}),o.pos!==s.pos&&o.$slide.addClass("fancybox-slide--"+(o.pos>s.pos?"next":"previous")),p(o.$slide),n.fancybox.animate(o.$slide,{top:0,left:(o.pos-s.pos)*c.width+(o.pos-s.pos)*o.opts.gutter},e,function(){o.$slide.css({transform:"",opacity:""}).removeClass("fancybox-slide--next fancybox-slide--previous"),o.pos===f.currPos&&f.complete()})})):e&&s.opts.transitionEffect&&(d="fancybox-animated fancybox-fx-"+s.opts.transitionEffect,r.$slide.addClass("fancybox-slide--"+(r.pos>s.pos?"next":"previous")),n.fancybox.animate(r.$slide,d,e,function(){r.$slide.removeClass(d).removeClass("fancybox-slide--next fancybox-slide--previous")},!1)),s.isLoaded?f.revealContent(s):f.loadSlide(s),f.preload("image")}},createSlide:function(t){var e,o,i=this;return o=t%i.group.length,o=o<0?i.group.length+o:o,!i.slides[t]&&i.group[o]&&(e=n('<div class="fancybox-slide"></div>').appendTo(i.$refs.stage),i.slides[t]=n.extend(!0,{},i.group[o],{pos:t,$slide:e,isLoaded:!1}),i.updateSlide(i.slides[t])),i.slides[t]},scaleToActual:function(t,e,o){var i,a,s,r,c,l=this,d=l.current,u=d.$content,f=n.fancybox.getTranslate(d.$slide).width,p=n.fancybox.getTranslate(d.$slide).height,h=d.width,g=d.height;l.isAnimating||l.isMoved()||!u||"image"!=d.type||!d.isLoaded||d.hasError||(l.isAnimating=!0,n.fancybox.stop(u),t=void 0===t?.5*f:t,e=void 0===e?.5*p:e,i=n.fancybox.getTranslate(u),i.top-=n.fancybox.getTranslate(d.$slide).top,i.left-=n.fancybox.getTranslate(d.$slide).left,r=h/i.width,c=g/i.height,a=.5*f-.5*h,s=.5*p-.5*g,h>f&&(a=i.left*r-(t*r-t),a>0&&(a=0),a<f-h&&(a=f-h)),g>p&&(s=i.top*c-(e*c-e),s>0&&(s=0),s<p-g&&(s=p-g)),l.updateCursor(h,g),n.fancybox.animate(u,{top:s,left:a,scaleX:r,scaleY:c},o||366,function(){l.isAnimating=!1}),l.SlideShow&&l.SlideShow.isActive&&l.SlideShow.stop())},scaleToFit:function(t){var e,o=this,i=o.current,a=i.$content;o.isAnimating||o.isMoved()||!a||"image"!=i.type||!i.isLoaded||i.hasError||(o.isAnimating=!0,n.fancybox.stop(a),e=o.getFitPos(i),o.updateCursor(e.width,e.height),n.fancybox.animate(a,{top:e.top,left:e.left,scaleX:e.width/a.width(),scaleY:e.height/a.height()},t||366,function(){o.isAnimating=!1}))},getFitPos:function(t){var e,o,i,a,s=this,r=t.$content,c=t.$slide,l=t.width||t.opts.width,d=t.height||t.opts.height,u={};return!!(t.isLoaded&&r&&r.length)&&(e=n.fancybox.getTranslate(s.$refs.stage).width,o=n.fancybox.getTranslate(s.$refs.stage).height,e-=parseFloat(c.css("paddingLeft"))+parseFloat(c.css("paddingRight"))+parseFloat(r.css("marginLeft"))+parseFloat(r.css("marginRight")),o-=parseFloat(c.css("paddingTop"))+parseFloat(c.css("paddingBottom"))+parseFloat(r.css("marginTop"))+parseFloat(r.css("marginBottom")),l&&d||(l=e,d=o),i=Math.min(1,e/l,o/d),l*=i,d*=i,l>e-.5&&(l=e),d>o-.5&&(d=o),"image"===t.type?(u.top=Math.floor(.5*(o-d))+parseFloat(c.css("paddingTop")),u.left=Math.floor(.5*(e-l))+parseFloat(c.css("paddingLeft"))):"video"===t.contentType&&(a=t.opts.width&&t.opts.height?l/d:t.opts.ratio||16/9,d>l/a?d=l/a:l>d*a&&(l=d*a)),u.width=l,u.height=d,u)},update:function(t){var e=this;n.each(e.slides,function(n,o){e.updateSlide(o,t)})},updateSlide:function(t,e){var o=this,i=t&&t.$content,a=t.width||t.opts.width,s=t.height||t.opts.height,r=t.$slide;o.adjustCaption(t),i&&(a||s||"video"===t.contentType)&&!t.hasError&&(n.fancybox.stop(i),n.fancybox.setTranslate(i,o.getFitPos(t)),t.pos===o.currPos&&(o.isAnimating=!1,o.updateCursor())),o.adjustLayout(t),r.length&&(r.trigger("refresh"),t.pos===o.currPos&&o.$refs.toolbar.add(o.$refs.navigation.find(".fancybox-button--arrow_right")).toggleClass("compensate-for-scrollbar",r.get(0).scrollHeight>r.get(0).clientHeight)),o.trigger("onUpdate",t,e)},centerSlide:function(t){var e=this,o=e.current,i=o.$slide;!e.isClosing&&o&&(i.siblings().css({transform:"",opacity:""}),i.parent().children().removeClass("fancybox-slide--previous fancybox-slide--next"),n.fancybox.animate(i,{top:0,left:0,opacity:1},void 0===t?0:t,function(){i.css({transform:"",opacity:""}),o.isComplete||e.complete()},!1))},isMoved:function(t){var e,o,i=t||this.current;return!!i&&(o=n.fancybox.getTranslate(this.$refs.stage),e=n.fancybox.getTranslate(i.$slide),!i.$slide.hasClass("fancybox-animated")&&(Math.abs(e.top-o.top)>.5||Math.abs(e.left-o.left)>.5))},updateCursor:function(t,e){var o,i,a=this,s=a.current,r=a.$refs.container;s&&!a.isClosing&&a.Guestures&&(r.removeClass("fancybox-is-zoomable fancybox-can-zoomIn fancybox-can-zoomOut fancybox-can-swipe fancybox-can-pan"),o=a.canPan(t,e),i=!!o||a.isZoomable(),r.toggleClass("fancybox-is-zoomable",i),n("[data-fancybox-zoom]").prop("disabled",!i),o?r.addClass("fancybox-can-pan"):i&&("zoom"===s.opts.clickContent||n.isFunction(s.opts.clickContent)&&"zoom"==s.opts.clickContent(s))?r.addClass("fancybox-can-zoomIn"):s.opts.touch&&(s.opts.touch.vertical||a.group.length>1)&&"video"!==s.contentType&&r.addClass("fancybox-can-swipe"))},isZoomable:function(){var t,e=this,n=e.current;if(n&&!e.isClosing&&"image"===n.type&&!n.hasError){if(!n.isLoaded)return!0;if((t=e.getFitPos(n))&&(n.width>t.width||n.height>t.height))return!0}return!1},isScaledDown:function(t,e){var o=this,i=!1,a=o.current,s=a.$content;return void 0!==t&&void 0!==e?i=t<a.width&&e<a.height:s&&(i=n.fancybox.getTranslate(s),i=i.width<a.width&&i.height<a.height),i},canPan:function(t,e){var o=this,i=o.current,a=null,s=!1;return"image"===i.type&&(i.isComplete||t&&e)&&!i.hasError&&(s=o.getFitPos(i),void 0!==t&&void 0!==e?a={width:t,height:e}:i.isComplete&&(a=n.fancybox.getTranslate(i.$content)),a&&s&&(s=Math.abs(a.width-s.width)>1.5||Math.abs(a.height-s.height)>1.5)),s},loadSlide:function(t){var e,o,i,a=this;if(!t.isLoading&&!t.isLoaded){if(t.isLoading=!0,!1===a.trigger("beforeLoad",t))return t.isLoading=!1,!1;switch(e=t.type,o=t.$slide,o.off("refresh").trigger("onReset").addClass(t.opts.slideClass),e){case"image":a.setImage(t);break;case"iframe":a.setIframe(t);break;case"html":a.setContent(t,t.src||t.content);break;case"video":a.setContent(t,t.opts.video.tpl.replace(/\{\{src\}\}/gi,t.src).replace("{{format}}",t.opts.videoFormat||t.opts.video.format||"").replace("{{poster}}",t.thumb||""));break;case"inline":n(t.src).length?a.setContent(t,n(t.src)):a.setError(t);break;case"ajax":a.showLoading(t),i=n.ajax(n.extend({},t.opts.ajax.settings,{url:t.src,success:function(e,n){"success"===n&&a.setContent(t,e)},error:function(e,n){e&&"abort"!==n&&a.setError(t)}})),o.one("onReset",function(){i.abort()});break;default:a.setError(t)}return!0}},setImage:function(t){var o,i=this;setTimeout(function(){var e=t.$image;i.isClosing||!t.isLoading||e&&e.length&&e[0].complete||t.hasError||i.showLoading(t)},50),i.checkSrcset(t),t.$content=n('<div class="fancybox-content"></div>').addClass("fancybox-is-hidden").appendTo(t.$slide.addClass("fancybox-slide--image")),!1!==t.opts.preload&&t.opts.width&&t.opts.height&&t.thumb&&(t.width=t.opts.width,t.height=t.opts.height,o=e.createElement("img"),o.onerror=function(){n(this).remove(),t.$ghost=null},o.onload=function(){i.afterLoad(t)},t.$ghost=n(o).addClass("fancybox-image").appendTo(t.$content).attr("src",t.thumb)),i.setBigImage(t)},checkSrcset:function(e){var n,o,i,a,s=e.opts.srcset||e.opts.image.srcset;if(s){i=t.devicePixelRatio||1,a=t.innerWidth*i,o=s.split(",").map(function(t){var e={};return t.trim().split(/\s+/).forEach(function(t,n){var o=parseInt(t.substring(0,t.length-1),10);if(0===n)return e.url=t;o&&(e.value=o,e.postfix=t[t.length-1])}),e}),o.sort(function(t,e){return t.value-e.value});for(var r=0;r<o.length;r++){var c=o[r];if("w"===c.postfix&&c.value>=a||"x"===c.postfix&&c.value>=i){n=c;break}}!n&&o.length&&(n=o[o.length-1]),n&&(e.src=n.url,e.width&&e.height&&"w"==n.postfix&&(e.height=e.width/e.height*n.value,e.width=n.value),e.opts.srcset=s)}},setBigImage:function(t){var o=this,i=e.createElement("img"),a=n(i);t.$image=a.one("error",function(){o.setError(t)}).one("load",function(){var e;t.$ghost||(o.resolveImageSlideSize(t,this.naturalWidth,this.naturalHeight),o.afterLoad(t)),o.isClosing||(t.opts.srcset&&(e=t.opts.sizes,e&&"auto"!==e||(e=(t.width/t.height>1&&s.width()/s.height()>1?"100":Math.round(t.width/t.height*100))+"vw"),a.attr("sizes",e).attr("srcset",t.opts.srcset)),t.$ghost&&setTimeout(function(){t.$ghost&&!o.isClosing&&t.$ghost.hide()},Math.min(300,Math.max(1e3,t.height/1600))),o.hideLoading(t))}).addClass("fancybox-image").attr("src",t.src).appendTo(t.$content),(i.complete||"complete"==i.readyState)&&a.naturalWidth&&a.naturalHeight?a.trigger("load"):i.error&&a.trigger("error")},resolveImageSlideSize:function(t,e,n){var o=parseInt(t.opts.width,10),i=parseInt(t.opts.height,10);t.width=e,t.height=n,o>0&&(t.width=o,t.height=Math.floor(o*n/e)),i>0&&(t.width=Math.floor(i*e/n),t.height=i)},setIframe:function(t){var e,o=this,i=t.opts.iframe,a=t.$slide;t.$content=n('<div class="fancybox-content'+(i.preload?" fancybox-is-hidden":"")+'"></div>').css(i.css).appendTo(a),a.addClass("fancybox-slide--"+t.contentType),t.$iframe=e=n(i.tpl.replace(/\{rnd\}/g,(new Date).getTime())).attr(i.attr).appendTo(t.$content),i.preload?(o.showLoading(t),e.on("load.fb error.fb",function(e){this.isReady=1,t.$slide.trigger("refresh"),o.afterLoad(t)}),a.on("refresh.fb",function(){var n,o,s=t.$content,r=i.css.width,c=i.css.height;if(1===e[0].isReady){try{n=e.contents(),o=n.find("body")}catch(t){}o&&o.length&&o.children().length&&(a.css("overflow","visible"),s.css({width:"100%","max-width":"100%",height:"9999px"}),void 0===r&&(r=Math.ceil(Math.max(o[0].clientWidth,o.outerWidth(!0)))),s.css("width",r||"").css("max-width",""),void 0===c&&(c=Math.ceil(Math.max(o[0].clientHeight,o.outerHeight(!0)))),s.css("height",c||""),a.css("overflow","auto")),s.removeClass("fancybox-is-hidden")}})):o.afterLoad(t),e.attr("src",t.src),a.one("onReset",function(){try{n(this).find("iframe").hide().unbind().attr("src","//about:blank")}catch(t){}n(this).off("refresh.fb").empty(),t.isLoaded=!1,t.isRevealed=!1})},setContent:function(t,e){var o=this;o.isClosing||(o.hideLoading(t),t.$content&&n.fancybox.stop(t.$content),t.$slide.empty(),l(e)&&e.parent().length?((e.hasClass("fancybox-content")||e.parent().hasClass("fancybox-content"))&&e.parents(".fancybox-slide").trigger("onReset"),t.$placeholder=n("<div>").hide().insertAfter(e),e.css("display","inline-block")):t.hasError||("string"===n.type(e)&&(e=n("<div>").append(n.trim(e)).contents()),t.opts.filter&&(e=n("<div>").html(e).find(t.opts.filter))),t.$slide.one("onReset",function(){n(this).find("video,audio").trigger("pause"),t.$placeholder&&(t.$placeholder.after(e.removeClass("fancybox-content").hide()).remove(),t.$placeholder=null),t.$smallBtn&&(t.$smallBtn.remove(),t.$smallBtn=null),t.hasError||(n(this).empty(),t.isLoaded=!1,t.isRevealed=!1)}),n(e).appendTo(t.$slide),n(e).is("video,audio")&&(n(e).addClass("fancybox-video"),n(e).wrap("<div></div>"),t.contentType="video",t.opts.width=t.opts.width||n(e).attr("width"),t.opts.height=t.opts.height||n(e).attr("height")),t.$content=t.$slide.children().filter("div,form,main,video,audio,article,.fancybox-content").first(),t.$content.siblings().hide(),t.$content.length||(t.$content=t.$slide.wrapInner("<div></div>").children().first()),t.$content.addClass("fancybox-content"),t.$slide.addClass("fancybox-slide--"+t.contentType),o.afterLoad(t))},setError:function(t){t.hasError=!0,t.$slide.trigger("onReset").removeClass("fancybox-slide--"+t.contentType).addClass("fancybox-slide--error"),t.contentType="html",this.setContent(t,this.translate(t,t.opts.errorTpl)),t.pos===this.currPos&&(this.isAnimating=!1)},showLoading:function(t){var e=this;(t=t||e.current)&&!t.$spinner&&(t.$spinner=n(e.translate(e,e.opts.spinnerTpl)).appendTo(t.$slide).hide().fadeIn("fast"))},hideLoading:function(t){var e=this;(t=t||e.current)&&t.$spinner&&(t.$spinner.stop().remove(),delete t.$spinner)},afterLoad:function(t){var e=this;e.isClosing||(t.isLoading=!1,t.isLoaded=!0,e.trigger("afterLoad",t),e.hideLoading(t),!t.opts.smallBtn||t.$smallBtn&&t.$smallBtn.length||(t.$smallBtn=n(e.translate(t,t.opts.btnTpl.smallBtn)).appendTo(t.$content)),t.opts.protect&&t.$content&&!t.hasError&&(t.$content.on("contextmenu.fb",function(t){return 2==t.button&&t.preventDefault(),!0}),"image"===t.type&&n('<div class="fancybox-spaceball"></div>').appendTo(t.$content)),e.adjustCaption(t),e.adjustLayout(t),t.pos===e.currPos&&e.updateCursor(),e.revealContent(t))},adjustCaption:function(t){var e,n=this,o=t||n.current,i=o.opts.caption,a=o.opts.preventCaptionOverlap,s=n.$refs.caption,r=!1;s.toggleClass("fancybox-caption--separate",a),a&&i&&i.length&&(o.pos!==n.currPos?(e=s.clone().appendTo(s.parent()),e.children().eq(0).empty().html(i),r=e.outerHeight(!0),e.empty().remove()):n.$caption&&(r=n.$caption.outerHeight(!0)),o.$slide.css("padding-bottom",r||""))},adjustLayout:function(t){var e,n,o,i,a=this,s=t||a.current;s.isLoaded&&!0!==s.opts.disableLayoutFix&&(s.$content.css("margin-bottom",""),s.$content.outerHeight()>s.$slide.height()+.5&&(o=s.$slide[0].style["padding-bottom"],i=s.$slide.css("padding-bottom"),parseFloat(i)>0&&(e=s.$slide[0].scrollHeight,s.$slide.css("padding-bottom",0),Math.abs(e-s.$slide[0].scrollHeight)<1&&(n=i),s.$slide.css("padding-bottom",o))),s.$content.css("margin-bottom",n))},revealContent:function(t){var e,o,i,a,s=this,r=t.$slide,c=!1,l=!1,d=s.isMoved(t),u=t.isRevealed;return t.isRevealed=!0,e=t.opts[s.firstRun?"animationEffect":"transitionEffect"],i=t.opts[s.firstRun?"animationDuration":"transitionDuration"],i=parseInt(void 0===t.forcedDuration?i:t.forcedDuration,10),!d&&t.pos===s.currPos&&i||(e=!1),"zoom"===e&&(t.pos===s.currPos&&i&&"image"===t.type&&!t.hasError&&(l=s.getThumbPos(t))?c=s.getFitPos(t):e="fade"),"zoom"===e?(s.isAnimating=!0,c.scaleX=c.width/l.width,c.scaleY=c.height/l.height,a=t.opts.zoomOpacity,"auto"==a&&(a=Math.abs(t.width/t.height-l.width/l.height)>.1),a&&(l.opacity=.1,c.opacity=1),n.fancybox.setTranslate(t.$content.removeClass("fancybox-is-hidden"),l),p(t.$content),void n.fancybox.animate(t.$content,c,i,function(){s.isAnimating=!1,s.complete()})):(s.updateSlide(t),e?(n.fancybox.stop(r),o="fancybox-slide--"+(t.pos>=s.prevPos?"next":"previous")+" fancybox-animated fancybox-fx-"+e,r.addClass(o).removeClass("fancybox-slide--current"),t.$content.removeClass("fancybox-is-hidden"),p(r),"image"!==t.type&&t.$content.hide().show(0),void n.fancybox.animate(r,"fancybox-slide--current",i,function(){r.removeClass(o).css({transform:"",opacity:""}),t.pos===s.currPos&&s.complete()},!0)):(t.$content.removeClass("fancybox-is-hidden"),u||!d||"image"!==t.type||t.hasError||t.$content.hide().fadeIn("fast"),void(t.pos===s.currPos&&s.complete())))},getThumbPos:function(t){var e,o,i,a,s,r=!1,c=t.$thumb;return!(!c||!g(c[0]))&&(e=n.fancybox.getTranslate(c),o=parseFloat(c.css("border-top-width")||0),i=parseFloat(c.css("border-right-width")||0),a=parseFloat(c.css("border-bottom-width")||0),s=parseFloat(c.css("border-left-width")||0),r={top:e.top+o,left:e.left+s,width:e.width-i-s,height:e.height-o-a,scaleX:1,scaleY:1},e.width>0&&e.height>0&&r)},complete:function(){var t,e=this,o=e.current,i={};!e.isMoved()&&o.isLoaded&&(o.isComplete||(o.isComplete=!0,o.$slide.siblings().trigger("onReset"),e.preload("inline"),p(o.$slide),o.$slide.addClass("fancybox-slide--complete"),n.each(e.slides,function(t,o){o.pos>=e.currPos-1&&o.pos<=e.currPos+1?i[o.pos]=o:o&&(n.fancybox.stop(o.$slide),o.$slide.off().remove())}),e.slides=i),e.isAnimating=!1,e.updateCursor(),e.trigger("afterShow"),o.opts.video.autoStart&&o.$slide.find("video,audio").filter(":visible:first").trigger("play").one("ended",function(){Document.exitFullscreen?Document.exitFullscreen():this.webkitExitFullscreen&&this.webkitExitFullscreen(),e.next()}),o.opts.autoFocus&&"html"===o.contentType&&(t=o.$content.find("input[autofocus]:enabled:visible:first"),t.length?t.trigger("focus"):e.focus(null,!0)),o.$slide.scrollTop(0).scrollLeft(0))},preload:function(t){var e,n,o=this;o.group.length<2||(n=o.slides[o.currPos+1],e=o.slides[o.currPos-1],e&&e.type===t&&o.loadSlide(e),n&&n.type===t&&o.loadSlide(n))},focus:function(t,o){var i,a,s=this,r=["a[href]","area[href]",'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',"select:not([disabled]):not([aria-hidden])","textarea:not([disabled]):not([aria-hidden])","button:not([disabled]):not([aria-hidden])","iframe","object","embed","video","audio","[contenteditable]",'[tabindex]:not([tabindex^="-"])'].join(",");s.isClosing||(i=!t&&s.current&&s.current.isComplete?s.current.$slide.find("*:visible"+(o?":not(.fancybox-close-small)":"")):s.$refs.container.find("*:visible"),i=i.filter(r).filter(function(){return"hidden"!==n(this).css("visibility")&&!n(this).hasClass("disabled")}),i.length?(a=i.index(e.activeElement),t&&t.shiftKey?(a<0||0==a)&&(t.preventDefault(),i.eq(i.length-1).trigger("focus")):(a<0||a==i.length-1)&&(t&&t.preventDefault(),i.eq(0).trigger("focus"))):s.$refs.container.trigger("focus"))},activate:function(){var t=this;n(".fancybox-container").each(function(){var e=n(this).data("FancyBox");e&&e.id!==t.id&&!e.isClosing&&(e.trigger("onDeactivate"),e.removeEvents(),e.isVisible=!1)}),t.isVisible=!0,(t.current||t.isIdle)&&(t.update(),t.updateControls()),t.trigger("onActivate"),t.addEvents()},close:function(t,e){var o,i,a,s,r,c,l,u=this,f=u.current,h=function(){u.cleanUp(t)};return!u.isClosing&&(u.isClosing=!0,!1===u.trigger("beforeClose",t)?(u.isClosing=!1,d(function(){u.update()}),!1):(u.removeEvents(),a=f.$content,o=f.opts.animationEffect,i=n.isNumeric(e)?e:o?f.opts.animationDuration:0,f.$slide.removeClass("fancybox-slide--complete fancybox-slide--next fancybox-slide--previous fancybox-animated"),!0!==t?n.fancybox.stop(f.$slide):o=!1,f.$slide.siblings().trigger("onReset").remove(),i&&u.$refs.container.removeClass("fancybox-is-open").addClass("fancybox-is-closing").css("transition-duration",i+"ms"),u.hideLoading(f),u.hideControls(!0),u.updateCursor(),"zoom"!==o||a&&i&&"image"===f.type&&!u.isMoved()&&!f.hasError&&(l=u.getThumbPos(f))||(o="fade"),"zoom"===o?(n.fancybox.stop(a),s=n.fancybox.getTranslate(a),c={top:s.top,left:s.left,scaleX:s.width/l.width,scaleY:s.height/l.height,width:l.width,height:l.height},r=f.opts.zoomOpacity,
"auto"==r&&(r=Math.abs(f.width/f.height-l.width/l.height)>.1),r&&(l.opacity=0),n.fancybox.setTranslate(a,c),p(a),n.fancybox.animate(a,l,i,h),!0):(o&&i?n.fancybox.animate(f.$slide.addClass("fancybox-slide--previous").removeClass("fancybox-slide--current"),"fancybox-animated fancybox-fx-"+o,i,h):!0===t?setTimeout(h,i):h(),!0)))},cleanUp:function(e){var o,i,a,s=this,r=s.current.opts.$orig;s.current.$slide.trigger("onReset"),s.$refs.container.empty().remove(),s.trigger("afterClose",e),s.current.opts.backFocus&&(r&&r.length&&r.is(":visible")||(r=s.$trigger),r&&r.length&&(i=t.scrollX,a=t.scrollY,r.trigger("focus"),n("html, body").scrollTop(a).scrollLeft(i))),s.current=null,o=n.fancybox.getInstance(),o?o.activate():(n("body").removeClass("fancybox-active compensate-for-scrollbar"),n("#fancybox-style-noscroll").remove())},trigger:function(t,e){var o,i=Array.prototype.slice.call(arguments,1),a=this,s=e&&e.opts?e:a.current;if(s?i.unshift(s):s=a,i.unshift(a),n.isFunction(s.opts[t])&&(o=s.opts[t].apply(s,i)),!1===o)return o;"afterClose"!==t&&a.$refs?a.$refs.container.trigger(t+".fb",i):r.trigger(t+".fb",i)},updateControls:function(){var t=this,o=t.current,i=o.index,a=t.$refs.container,s=t.$refs.caption,r=o.opts.caption;o.$slide.trigger("refresh"),r&&r.length?(t.$caption=s,s.children().eq(0).html(r)):t.$caption=null,t.hasHiddenControls||t.isIdle||t.showControls(),a.find("[data-fancybox-count]").html(t.group.length),a.find("[data-fancybox-index]").html(i+1),a.find("[data-fancybox-prev]").prop("disabled",!o.opts.loop&&i<=0),a.find("[data-fancybox-next]").prop("disabled",!o.opts.loop&&i>=t.group.length-1),"image"===o.type?a.find("[data-fancybox-zoom]").show().end().find("[data-fancybox-download]").attr("href",o.opts.image.src||o.src).show():o.opts.toolbar&&a.find("[data-fancybox-download],[data-fancybox-zoom]").hide(),n(e.activeElement).is(":hidden,[disabled]")&&t.$refs.container.trigger("focus")},hideControls:function(t){var e=this,n=["infobar","toolbar","nav"];!t&&e.current.opts.preventCaptionOverlap||n.push("caption"),this.$refs.container.removeClass(n.map(function(t){return"fancybox-show-"+t}).join(" ")),this.hasHiddenControls=!0},showControls:function(){var t=this,e=t.current?t.current.opts:t.opts,n=t.$refs.container;t.hasHiddenControls=!1,t.idleSecondsCounter=0,n.toggleClass("fancybox-show-toolbar",!(!e.toolbar||!e.buttons)).toggleClass("fancybox-show-infobar",!!(e.infobar&&t.group.length>1)).toggleClass("fancybox-show-caption",!!t.$caption).toggleClass("fancybox-show-nav",!!(e.arrows&&t.group.length>1)).toggleClass("fancybox-is-modal",!!e.modal)},toggleControls:function(){this.hasHiddenControls?this.showControls():this.hideControls()}}),n.fancybox={version:"3.5.7",defaults:a,getInstance:function(t){var e=n('.fancybox-container:not(".fancybox-is-closing"):last').data("FancyBox"),o=Array.prototype.slice.call(arguments,1);return e instanceof b&&("string"===n.type(t)?e[t].apply(e,o):"function"===n.type(t)&&t.apply(e,o),e)},open:function(t,e,n){return new b(t,e,n)},close:function(t){var e=this.getInstance();e&&(e.close(),!0===t&&this.close(t))},destroy:function(){this.close(!0),r.add("body").off("click.fb-start","**")},isMobile:/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),use3d:function(){var n=e.createElement("div");return t.getComputedStyle&&t.getComputedStyle(n)&&t.getComputedStyle(n).getPropertyValue("transform")&&!(e.documentMode&&e.documentMode<11)}(),getTranslate:function(t){var e;return!(!t||!t.length)&&(e=t[0].getBoundingClientRect(),{top:e.top||0,left:e.left||0,width:e.width,height:e.height,opacity:parseFloat(t.css("opacity"))})},setTranslate:function(t,e){var n="",o={};if(t&&e)return void 0===e.left&&void 0===e.top||(n=(void 0===e.left?t.position().left:e.left)+"px, "+(void 0===e.top?t.position().top:e.top)+"px",n=this.use3d?"translate3d("+n+", 0px)":"translate("+n+")"),void 0!==e.scaleX&&void 0!==e.scaleY?n+=" scale("+e.scaleX+", "+e.scaleY+")":void 0!==e.scaleX&&(n+=" scaleX("+e.scaleX+")"),n.length&&(o.transform=n),void 0!==e.opacity&&(o.opacity=e.opacity),void 0!==e.width&&(o.width=e.width),void 0!==e.height&&(o.height=e.height),t.css(o)},animate:function(t,e,o,i,a){var s,r=this;n.isFunction(o)&&(i=o,o=null),r.stop(t),s=r.getTranslate(t),t.on(f,function(c){(!c||!c.originalEvent||t.is(c.originalEvent.target)&&"z-index"!=c.originalEvent.propertyName)&&(r.stop(t),n.isNumeric(o)&&t.css("transition-duration",""),n.isPlainObject(e)?void 0!==e.scaleX&&void 0!==e.scaleY&&r.setTranslate(t,{top:e.top,left:e.left,width:s.width*e.scaleX,height:s.height*e.scaleY,scaleX:1,scaleY:1}):!0!==a&&t.removeClass(e),n.isFunction(i)&&i(c))}),n.isNumeric(o)&&t.css("transition-duration",o+"ms"),n.isPlainObject(e)?(void 0!==e.scaleX&&void 0!==e.scaleY&&(delete e.width,delete e.height,t.parent().hasClass("fancybox-slide--image")&&t.parent().addClass("fancybox-is-scaling")),n.fancybox.setTranslate(t,e)):t.addClass(e),t.data("timer",setTimeout(function(){t.trigger(f)},o+33))},stop:function(t,e){t&&t.length&&(clearTimeout(t.data("timer")),e&&t.trigger(f),t.off(f).css("transition-duration",""),t.parent().removeClass("fancybox-is-scaling"))}},n.fn.fancybox=function(t){var e;return t=t||{},e=t.selector||!1,e?n("body").off("click.fb-start",e).on("click.fb-start",e,{options:t},i):this.off("click.fb-start").on("click.fb-start",{items:this,options:t},i),this},r.on("click.fb-start","[data-fancybox]",i),r.on("click.fb-start","[data-fancybox-trigger]",function(t){n('[data-fancybox="'+n(this).attr("data-fancybox-trigger")+'"]').eq(n(this).attr("data-fancybox-index")||0).trigger("click.fb-start",{$trigger:n(this)})}),function(){var t=null;r.on("mousedown mouseup focus blur",".fancybox-button",function(e){switch(e.type){case"mousedown":t=n(this);break;case"mouseup":t=null;break;case"focusin":n(".fancybox-button").removeClass("fancybox-focus"),n(this).is(t)||n(this).is("[disabled]")||n(this).addClass("fancybox-focus");break;case"focusout":n(".fancybox-button").removeClass("fancybox-focus")}})}()}}(window,document,jQuery),function(t){"use strict";var e={youtube:{matcher:/(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(watch\?(.*&)?v=|v\/|u\/|embed\/?)?(videoseries\?list=(.*)|[\w-]{11}|\?listType=(.*)&list=(.*))(.*)/i,params:{autoplay:1,autohide:1,fs:1,rel:0,hd:1,wmode:"transparent",enablejsapi:1,html5:1},paramPlace:8,type:"iframe",url:"https://www.youtube-nocookie.com/embed/$4",thumb:"https://img.youtube.com/vi/$4/hqdefault.jpg"},vimeo:{matcher:/^.+vimeo.com\/(.*\/)?([\d]+)(.*)?/,params:{autoplay:1,hd:1,show_title:1,show_byline:1,show_portrait:0,fullscreen:1},paramPlace:3,type:"iframe",url:"//player.vimeo.com/video/$2"},instagram:{matcher:/(instagr\.am|instagram\.com)\/p\/([a-zA-Z0-9_\-]+)\/?/i,type:"image",url:"//$1/p/$2/media/?size=l"},gmap_place:{matcher:/(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(((maps\/(place\/(.*)\/)?\@(.*),(\d+.?\d+?)z))|(\?ll=))(.*)?/i,type:"iframe",url:function(t){return"//maps.google."+t[2]+"/?ll="+(t[9]?t[9]+"&z="+Math.floor(t[10])+(t[12]?t[12].replace(/^\//,"&"):""):t[12]+"").replace(/\?/,"&")+"&output="+(t[12]&&t[12].indexOf("layer=c")>0?"svembed":"embed")}},gmap_search:{matcher:/(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(maps\/search\/)(.*)/i,type:"iframe",url:function(t){return"//maps.google."+t[2]+"/maps?q="+t[5].replace("query=","q=").replace("api=1","")+"&output=embed"}}},n=function(e,n,o){if(e)return o=o||"","object"===t.type(o)&&(o=t.param(o,!0)),t.each(n,function(t,n){e=e.replace("$"+t,n||"")}),o.length&&(e+=(e.indexOf("?")>0?"&":"?")+o),e};t(document).on("objectNeedsType.fb",function(o,i,a){var s,r,c,l,d,u,f,p=a.src||"",h=!1;s=t.extend(!0,{},e,a.opts.media),t.each(s,function(e,o){if(c=p.match(o.matcher)){if(h=o.type,f=e,u={},o.paramPlace&&c[o.paramPlace]){d=c[o.paramPlace],"?"==d[0]&&(d=d.substring(1)),d=d.split("&");for(var i=0;i<d.length;++i){var s=d[i].split("=",2);2==s.length&&(u[s[0]]=decodeURIComponent(s[1].replace(/\+/g," ")))}}return l=t.extend(!0,{},o.params,a.opts[e],u),p="function"===t.type(o.url)?o.url.call(this,c,l,a):n(o.url,c,l),r="function"===t.type(o.thumb)?o.thumb.call(this,c,l,a):n(o.thumb,c),"youtube"===e?p=p.replace(/&t=((\d+)m)?(\d+)s/,function(t,e,n,o){return"&start="+((n?60*parseInt(n,10):0)+parseInt(o,10))}):"vimeo"===e&&(p=p.replace("&%23","#")),!1}}),h?(a.opts.thumb||a.opts.$thumb&&a.opts.$thumb.length||(a.opts.thumb=r),"iframe"===h&&(a.opts=t.extend(!0,a.opts,{iframe:{preload:!1,attr:{scrolling:"no"}}})),t.extend(a,{type:h,src:p,origSrc:a.src,contentSource:f,contentType:"image"===h?"image":"gmap_place"==f||"gmap_search"==f?"map":"video"})):p&&(a.type=a.opts.defaultType)});var o={youtube:{src:"https://www.youtube.com/iframe_api",class:"YT",loading:!1,loaded:!1},vimeo:{src:"https://player.vimeo.com/api/player.js",class:"Vimeo",loading:!1,loaded:!1},load:function(t){var e,n=this;if(this[t].loaded)return void setTimeout(function(){n.done(t)});this[t].loading||(this[t].loading=!0,e=document.createElement("script"),e.type="text/javascript",e.src=this[t].src,"youtube"===t?window.onYouTubeIframeAPIReady=function(){n[t].loaded=!0,n.done(t)}:e.onload=function(){n[t].loaded=!0,n.done(t)},document.body.appendChild(e))},done:function(e){var n,o,i;"youtube"===e&&delete window.onYouTubeIframeAPIReady,(n=t.fancybox.getInstance())&&(o=n.current.$content.find("iframe"),"youtube"===e&&void 0!==YT&&YT?i=new YT.Player(o.attr("id"),{events:{onStateChange:function(t){0==t.data&&n.next()}}}):"vimeo"===e&&void 0!==Vimeo&&Vimeo&&(i=new Vimeo.Player(o),i.on("ended",function(){n.next()})))}};t(document).on({"afterShow.fb":function(t,e,n){e.group.length>1&&("youtube"===n.contentSource||"vimeo"===n.contentSource)&&o.load(n.contentSource)}})}(jQuery),function(t,e,n){"use strict";var o=function(){return t.requestAnimationFrame||t.webkitRequestAnimationFrame||t.mozRequestAnimationFrame||t.oRequestAnimationFrame||function(e){return t.setTimeout(e,1e3/60)}}(),i=function(){return t.cancelAnimationFrame||t.webkitCancelAnimationFrame||t.mozCancelAnimationFrame||t.oCancelAnimationFrame||function(e){t.clearTimeout(e)}}(),a=function(e){var n=[];e=e.originalEvent||e||t.e,e=e.touches&&e.touches.length?e.touches:e.changedTouches&&e.changedTouches.length?e.changedTouches:[e];for(var o in e)e[o].pageX?n.push({x:e[o].pageX,y:e[o].pageY}):e[o].clientX&&n.push({x:e[o].clientX,y:e[o].clientY});return n},s=function(t,e,n){return e&&t?"x"===n?t.x-e.x:"y"===n?t.y-e.y:Math.sqrt(Math.pow(t.x-e.x,2)+Math.pow(t.y-e.y,2)):0},r=function(t){if(t.is('a,area,button,[role="button"],input,label,select,summary,textarea,video,audio,iframe')||n.isFunction(t.get(0).onclick)||t.data("selectable"))return!0;for(var e=0,o=t[0].attributes,i=o.length;e<i;e++)if("data-fancybox-"===o[e].nodeName.substr(0,14))return!0;return!1},c=function(e){var n=t.getComputedStyle(e)["overflow-y"],o=t.getComputedStyle(e)["overflow-x"],i=("scroll"===n||"auto"===n)&&e.scrollHeight>e.clientHeight,a=("scroll"===o||"auto"===o)&&e.scrollWidth>e.clientWidth;return i||a},l=function(t){for(var e=!1;;){if(e=c(t.get(0)))break;if(t=t.parent(),!t.length||t.hasClass("fancybox-stage")||t.is("body"))break}return e},d=function(t){var e=this;e.instance=t,e.$bg=t.$refs.bg,e.$stage=t.$refs.stage,e.$container=t.$refs.container,e.destroy(),e.$container.on("touchstart.fb.touch mousedown.fb.touch",n.proxy(e,"ontouchstart"))};d.prototype.destroy=function(){var t=this;t.$container.off(".fb.touch"),n(e).off(".fb.touch"),t.requestId&&(i(t.requestId),t.requestId=null),t.tapped&&(clearTimeout(t.tapped),t.tapped=null)},d.prototype.ontouchstart=function(o){var i=this,c=n(o.target),d=i.instance,u=d.current,f=u.$slide,p=u.$content,h="touchstart"==o.type;if(h&&i.$container.off("mousedown.fb.touch"),(!o.originalEvent||2!=o.originalEvent.button)&&f.length&&c.length&&!r(c)&&!r(c.parent())&&(c.is("img")||!(o.originalEvent.clientX>c[0].clientWidth+c.offset().left))){if(!u||d.isAnimating||u.$slide.hasClass("fancybox-animated"))return o.stopPropagation(),void o.preventDefault();i.realPoints=i.startPoints=a(o),i.startPoints.length&&(u.touch&&o.stopPropagation(),i.startEvent=o,i.canTap=!0,i.$target=c,i.$content=p,i.opts=u.opts.touch,i.isPanning=!1,i.isSwiping=!1,i.isZooming=!1,i.isScrolling=!1,i.canPan=d.canPan(),i.startTime=(new Date).getTime(),i.distanceX=i.distanceY=i.distance=0,i.canvasWidth=Math.round(f[0].clientWidth),i.canvasHeight=Math.round(f[0].clientHeight),i.contentLastPos=null,i.contentStartPos=n.fancybox.getTranslate(i.$content)||{top:0,left:0},i.sliderStartPos=n.fancybox.getTranslate(f),i.stagePos=n.fancybox.getTranslate(d.$refs.stage),i.sliderStartPos.top-=i.stagePos.top,i.sliderStartPos.left-=i.stagePos.left,i.contentStartPos.top-=i.stagePos.top,i.contentStartPos.left-=i.stagePos.left,n(e).off(".fb.touch").on(h?"touchend.fb.touch touchcancel.fb.touch":"mouseup.fb.touch mouseleave.fb.touch",n.proxy(i,"ontouchend")).on(h?"touchmove.fb.touch":"mousemove.fb.touch",n.proxy(i,"ontouchmove")),n.fancybox.isMobile&&e.addEventListener("scroll",i.onscroll,!0),((i.opts||i.canPan)&&(c.is(i.$stage)||i.$stage.find(c).length)||(c.is(".fancybox-image")&&o.preventDefault(),n.fancybox.isMobile&&c.parents(".fancybox-caption").length))&&(i.isScrollable=l(c)||l(c.parent()),n.fancybox.isMobile&&i.isScrollable||o.preventDefault(),(1===i.startPoints.length||u.hasError)&&(i.canPan?(n.fancybox.stop(i.$content),i.isPanning=!0):i.isSwiping=!0,i.$container.addClass("fancybox-is-grabbing")),2===i.startPoints.length&&"image"===u.type&&(u.isLoaded||u.$ghost)&&(i.canTap=!1,i.isSwiping=!1,i.isPanning=!1,i.isZooming=!0,n.fancybox.stop(i.$content),i.centerPointStartX=.5*(i.startPoints[0].x+i.startPoints[1].x)-n(t).scrollLeft(),i.centerPointStartY=.5*(i.startPoints[0].y+i.startPoints[1].y)-n(t).scrollTop(),i.percentageOfImageAtPinchPointX=(i.centerPointStartX-i.contentStartPos.left)/i.contentStartPos.width,i.percentageOfImageAtPinchPointY=(i.centerPointStartY-i.contentStartPos.top)/i.contentStartPos.height,i.startDistanceBetweenFingers=s(i.startPoints[0],i.startPoints[1]))))}},d.prototype.onscroll=function(t){var n=this;n.isScrolling=!0,e.removeEventListener("scroll",n.onscroll,!0)},d.prototype.ontouchmove=function(t){var e=this;return void 0!==t.originalEvent.buttons&&0===t.originalEvent.buttons?void e.ontouchend(t):e.isScrolling?void(e.canTap=!1):(e.newPoints=a(t),void((e.opts||e.canPan)&&e.newPoints.length&&e.newPoints.length&&(e.isSwiping&&!0===e.isSwiping||t.preventDefault(),e.distanceX=s(e.newPoints[0],e.startPoints[0],"x"),e.distanceY=s(e.newPoints[0],e.startPoints[0],"y"),e.distance=s(e.newPoints[0],e.startPoints[0]),e.distance>0&&(e.isSwiping?e.onSwipe(t):e.isPanning?e.onPan():e.isZooming&&e.onZoom()))))},d.prototype.onSwipe=function(e){var a,s=this,r=s.instance,c=s.isSwiping,l=s.sliderStartPos.left||0;if(!0!==c)"x"==c&&(s.distanceX>0&&(s.instance.group.length<2||0===s.instance.current.index&&!s.instance.current.opts.loop)?l+=Math.pow(s.distanceX,.8):s.distanceX<0&&(s.instance.group.length<2||s.instance.current.index===s.instance.group.length-1&&!s.instance.current.opts.loop)?l-=Math.pow(-s.distanceX,.8):l+=s.distanceX),s.sliderLastPos={top:"x"==c?0:s.sliderStartPos.top+s.distanceY,left:l},s.requestId&&(i(s.requestId),s.requestId=null),s.requestId=o(function(){s.sliderLastPos&&(n.each(s.instance.slides,function(t,e){var o=e.pos-s.instance.currPos;n.fancybox.setTranslate(e.$slide,{top:s.sliderLastPos.top,left:s.sliderLastPos.left+o*s.canvasWidth+o*e.opts.gutter})}),s.$container.addClass("fancybox-is-sliding"))});else if(Math.abs(s.distance)>10){if(s.canTap=!1,r.group.length<2&&s.opts.vertical?s.isSwiping="y":r.isDragging||!1===s.opts.vertical||"auto"===s.opts.vertical&&n(t).width()>800?s.isSwiping="x":(a=Math.abs(180*Math.atan2(s.distanceY,s.distanceX)/Math.PI),s.isSwiping=a>45&&a<135?"y":"x"),"y"===s.isSwiping&&n.fancybox.isMobile&&s.isScrollable)return void(s.isScrolling=!0);r.isDragging=s.isSwiping,s.startPoints=s.newPoints,n.each(r.slides,function(t,e){var o,i;n.fancybox.stop(e.$slide),o=n.fancybox.getTranslate(e.$slide),i=n.fancybox.getTranslate(r.$refs.stage),e.$slide.css({transform:"",opacity:"","transition-duration":""}).removeClass("fancybox-animated").removeClass(function(t,e){return(e.match(/(^|\s)fancybox-fx-\S+/g)||[]).join(" ")}),e.pos===r.current.pos&&(s.sliderStartPos.top=o.top-i.top,s.sliderStartPos.left=o.left-i.left),n.fancybox.setTranslate(e.$slide,{top:o.top-i.top,left:o.left-i.left})}),r.SlideShow&&r.SlideShow.isActive&&r.SlideShow.stop()}},d.prototype.onPan=function(){var t=this;if(s(t.newPoints[0],t.realPoints[0])<(n.fancybox.isMobile?10:5))return void(t.startPoints=t.newPoints);t.canTap=!1,t.contentLastPos=t.limitMovement(),t.requestId&&i(t.requestId),t.requestId=o(function(){n.fancybox.setTranslate(t.$content,t.contentLastPos)})},d.prototype.limitMovement=function(){var t,e,n,o,i,a,s=this,r=s.canvasWidth,c=s.canvasHeight,l=s.distanceX,d=s.distanceY,u=s.contentStartPos,f=u.left,p=u.top,h=u.width,g=u.height;return i=h>r?f+l:f,a=p+d,t=Math.max(0,.5*r-.5*h),e=Math.max(0,.5*c-.5*g),n=Math.min(r-h,.5*r-.5*h),o=Math.min(c-g,.5*c-.5*g),l>0&&i>t&&(i=t-1+Math.pow(-t+f+l,.8)||0),l<0&&i<n&&(i=n+1-Math.pow(n-f-l,.8)||0),d>0&&a>e&&(a=e-1+Math.pow(-e+p+d,.8)||0),d<0&&a<o&&(a=o+1-Math.pow(o-p-d,.8)||0),{top:a,left:i}},d.prototype.limitPosition=function(t,e,n,o){var i=this,a=i.canvasWidth,s=i.canvasHeight;return n>a?(t=t>0?0:t,t=t<a-n?a-n:t):t=Math.max(0,a/2-n/2),o>s?(e=e>0?0:e,e=e<s-o?s-o:e):e=Math.max(0,s/2-o/2),{top:e,left:t}},d.prototype.onZoom=function(){var e=this,a=e.contentStartPos,r=a.width,c=a.height,l=a.left,d=a.top,u=s(e.newPoints[0],e.newPoints[1]),f=u/e.startDistanceBetweenFingers,p=Math.floor(r*f),h=Math.floor(c*f),g=(r-p)*e.percentageOfImageAtPinchPointX,b=(c-h)*e.percentageOfImageAtPinchPointY,m=(e.newPoints[0].x+e.newPoints[1].x)/2-n(t).scrollLeft(),v=(e.newPoints[0].y+e.newPoints[1].y)/2-n(t).scrollTop(),y=m-e.centerPointStartX,x=v-e.centerPointStartY,w=l+(g+y),$=d+(b+x),S={top:$,left:w,scaleX:f,scaleY:f};e.canTap=!1,e.newWidth=p,e.newHeight=h,e.contentLastPos=S,e.requestId&&i(e.requestId),e.requestId=o(function(){n.fancybox.setTranslate(e.$content,e.contentLastPos)})},d.prototype.ontouchend=function(t){var o=this,s=o.isSwiping,r=o.isPanning,c=o.isZooming,l=o.isScrolling;if(o.endPoints=a(t),o.dMs=Math.max((new Date).getTime()-o.startTime,1),o.$container.removeClass("fancybox-is-grabbing"),n(e).off(".fb.touch"),e.removeEventListener("scroll",o.onscroll,!0),o.requestId&&(i(o.requestId),o.requestId=null),o.isSwiping=!1,o.isPanning=!1,o.isZooming=!1,o.isScrolling=!1,o.instance.isDragging=!1,o.canTap)return o.onTap(t);o.speed=100,o.velocityX=o.distanceX/o.dMs*.5,o.velocityY=o.distanceY/o.dMs*.5,r?o.endPanning():c?o.endZooming():o.endSwiping(s,l)},d.prototype.endSwiping=function(t,e){var o=this,i=!1,a=o.instance.group.length,s=Math.abs(o.distanceX),r="x"==t&&a>1&&(o.dMs>130&&s>10||s>50);o.sliderLastPos=null,"y"==t&&!e&&Math.abs(o.distanceY)>50?(n.fancybox.animate(o.instance.current.$slide,{top:o.sliderStartPos.top+o.distanceY+150*o.velocityY,opacity:0},200),i=o.instance.close(!0,250)):r&&o.distanceX>0?i=o.instance.previous(300):r&&o.distanceX<0&&(i=o.instance.next(300)),!1!==i||"x"!=t&&"y"!=t||o.instance.centerSlide(200),o.$container.removeClass("fancybox-is-sliding")},d.prototype.endPanning=function(){var t,e,o,i=this;i.contentLastPos&&(!1===i.opts.momentum||i.dMs>350?(t=i.contentLastPos.left,e=i.contentLastPos.top):(t=i.contentLastPos.left+500*i.velocityX,e=i.contentLastPos.top+500*i.velocityY),o=i.limitPosition(t,e,i.contentStartPos.width,i.contentStartPos.height),o.width=i.contentStartPos.width,o.height=i.contentStartPos.height,n.fancybox.animate(i.$content,o,366))},d.prototype.endZooming=function(){var t,e,o,i,a=this,s=a.instance.current,r=a.newWidth,c=a.newHeight;a.contentLastPos&&(t=a.contentLastPos.left,e=a.contentLastPos.top,i={top:e,left:t,width:r,height:c,scaleX:1,scaleY:1},n.fancybox.setTranslate(a.$content,i),r<a.canvasWidth&&c<a.canvasHeight?a.instance.scaleToFit(150):r>s.width||c>s.height?a.instance.scaleToActual(a.centerPointStartX,a.centerPointStartY,150):(o=a.limitPosition(t,e,r,c),n.fancybox.animate(a.$content,o,150)))},d.prototype.onTap=function(e){var o,i=this,s=n(e.target),r=i.instance,c=r.current,l=e&&a(e)||i.startPoints,d=l[0]?l[0].x-n(t).scrollLeft()-i.stagePos.left:0,u=l[0]?l[0].y-n(t).scrollTop()-i.stagePos.top:0,f=function(t){var o=c.opts[t];if(n.isFunction(o)&&(o=o.apply(r,[c,e])),o)switch(o){case"close":r.close(i.startEvent);break;case"toggleControls":r.toggleControls();break;case"next":r.next();break;case"nextOrClose":r.group.length>1?r.next():r.close(i.startEvent);break;case"zoom":"image"==c.type&&(c.isLoaded||c.$ghost)&&(r.canPan()?r.scaleToFit():r.isScaledDown()?r.scaleToActual(d,u):r.group.length<2&&r.close(i.startEvent))}};if((!e.originalEvent||2!=e.originalEvent.button)&&(s.is("img")||!(d>s[0].clientWidth+s.offset().left))){if(s.is(".fancybox-bg,.fancybox-inner,.fancybox-outer,.fancybox-container"))o="Outside";else if(s.is(".fancybox-slide"))o="Slide";else{if(!r.current.$content||!r.current.$content.find(s).addBack().filter(s).length)return;o="Content"}if(i.tapped){if(clearTimeout(i.tapped),i.tapped=null,Math.abs(d-i.tapX)>50||Math.abs(u-i.tapY)>50)return this;f("dblclick"+o)}else i.tapX=d,i.tapY=u,c.opts["dblclick"+o]&&c.opts["dblclick"+o]!==c.opts["click"+o]?i.tapped=setTimeout(function(){i.tapped=null,r.isAnimating||f("click"+o)},500):f("click"+o);return this}},n(e).on("onActivate.fb",function(t,e){e&&!e.Guestures&&(e.Guestures=new d(e))}).on("beforeClose.fb",function(t,e){e&&e.Guestures&&e.Guestures.destroy()})}(window,document,jQuery),function(t,e){"use strict";e.extend(!0,e.fancybox.defaults,{btnTpl:{slideShow:'<button data-fancybox-play class="fancybox-button fancybox-button--play" title="{{PLAY_START}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M6.5 5.4v13.2l11-6.6z"/></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M8.33 5.75h2.2v12.5h-2.2V5.75zm5.15 0h2.2v12.5h-2.2V5.75z"/></svg></button>'},slideShow:{autoStart:!1,speed:3e3,progress:!0}});var n=function(t){this.instance=t,this.init()};e.extend(n.prototype,{timer:null,isActive:!1,$button:null,init:function(){var t=this,n=t.instance,o=n.group[n.currIndex].opts.slideShow;t.$button=n.$refs.toolbar.find("[data-fancybox-play]").on("click",function(){t.toggle()}),n.group.length<2||!o?t.$button.hide():o.progress&&(t.$progress=e('<div class="fancybox-progress"></div>').appendTo(n.$refs.inner))},set:function(t){var n=this,o=n.instance,i=o.current;i&&(!0===t||i.opts.loop||o.currIndex<o.group.length-1)?n.isActive&&"video"!==i.contentType&&(n.$progress&&e.fancybox.animate(n.$progress.show(),{scaleX:1},i.opts.slideShow.speed),n.timer=setTimeout(function(){o.current.opts.loop||o.current.index!=o.group.length-1?o.next():o.jumpTo(0)},i.opts.slideShow.speed)):(n.stop(),o.idleSecondsCounter=0,o.showControls())},clear:function(){var t=this;clearTimeout(t.timer),t.timer=null,t.$progress&&t.$progress.removeAttr("style").hide()},start:function(){var t=this,e=t.instance.current;e&&(t.$button.attr("title",(e.opts.i18n[e.opts.lang]||e.opts.i18n.en).PLAY_STOP).removeClass("fancybox-button--play").addClass("fancybox-button--pause"),t.isActive=!0,e.isComplete&&t.set(!0),t.instance.trigger("onSlideShowChange",!0))},stop:function(){var t=this,e=t.instance.current;t.clear(),t.$button.attr("title",(e.opts.i18n[e.opts.lang]||e.opts.i18n.en).PLAY_START).removeClass("fancybox-button--pause").addClass("fancybox-button--play"),t.isActive=!1,t.instance.trigger("onSlideShowChange",!1),t.$progress&&t.$progress.removeAttr("style").hide()},toggle:function(){var t=this;t.isActive?t.stop():t.start()}}),e(t).on({"onInit.fb":function(t,e){e&&!e.SlideShow&&(e.SlideShow=new n(e))},"beforeShow.fb":function(t,e,n,o){var i=e&&e.SlideShow;o?i&&n.opts.slideShow.autoStart&&i.start():i&&i.isActive&&i.clear()},"afterShow.fb":function(t,e,n){var o=e&&e.SlideShow;o&&o.isActive&&o.set()},"afterKeydown.fb":function(n,o,i,a,s){var r=o&&o.SlideShow;!r||!i.opts.slideShow||80!==s&&32!==s||e(t.activeElement).is("button,a,input")||(a.preventDefault(),r.toggle())},"beforeClose.fb onDeactivate.fb":function(t,e){var n=e&&e.SlideShow;n&&n.stop()}}),e(t).on("visibilitychange",function(){var n=e.fancybox.getInstance(),o=n&&n.SlideShow;o&&o.isActive&&(t.hidden?o.clear():o.set())})}(document,jQuery),function(t,e){"use strict";var n=function(){for(var e=[["requestFullscreen","exitFullscreen","fullscreenElement","fullscreenEnabled","fullscreenchange","fullscreenerror"],["webkitRequestFullscreen","webkitExitFullscreen","webkitFullscreenElement","webkitFullscreenEnabled","webkitfullscreenchange","webkitfullscreenerror"],["webkitRequestFullScreen","webkitCancelFullScreen","webkitCurrentFullScreenElement","webkitCancelFullScreen","webkitfullscreenchange","webkitfullscreenerror"],["mozRequestFullScreen","mozCancelFullScreen","mozFullScreenElement","mozFullScreenEnabled","mozfullscreenchange","mozfullscreenerror"],["msRequestFullscreen","msExitFullscreen","msFullscreenElement","msFullscreenEnabled","MSFullscreenChange","MSFullscreenError"]],n={},o=0;o<e.length;o++){var i=e[o];if(i&&i[1]in t){for(var a=0;a<i.length;a++)n[e[0][a]]=i[a];return n}}return!1}();if(n){var o={request:function(e){e=e||t.documentElement,e[n.requestFullscreen](e.ALLOW_KEYBOARD_INPUT)},exit:function(){t[n.exitFullscreen]()},toggle:function(e){e=e||t.documentElement,this.isFullscreen()?this.exit():this.request(e)},isFullscreen:function(){return Boolean(t[n.fullscreenElement])},enabled:function(){return Boolean(t[n.fullscreenEnabled])}};e.extend(!0,e.fancybox.defaults,{btnTpl:{fullScreen:'<button data-fancybox-fullscreen class="fancybox-button fancybox-button--fsenter" title="{{FULL_SCREEN}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 16h3v3h2v-5H5zm3-8H5v2h5V5H8zm6 11h2v-3h3v-2h-5zm2-11V5h-2v5h5V8z"/></svg></button>'},fullScreen:{autoStart:!1}}),e(t).on(n.fullscreenchange,function(){var t=o.isFullscreen(),n=e.fancybox.getInstance();n&&(n.current&&"image"===n.current.type&&n.isAnimating&&(n.isAnimating=!1,n.update(!0,!0,0),n.isComplete||n.complete()),n.trigger("onFullscreenChange",t),n.$refs.container.toggleClass("fancybox-is-fullscreen",t),n.$refs.toolbar.find("[data-fancybox-fullscreen]").toggleClass("fancybox-button--fsenter",!t).toggleClass("fancybox-button--fsexit",t))})}e(t).on({"onInit.fb":function(t,e){var i;if(!n)return void e.$refs.toolbar.find("[data-fancybox-fullscreen]").remove();e&&e.group[e.currIndex].opts.fullScreen?(i=e.$refs.container,i.on("click.fb-fullscreen","[data-fancybox-fullscreen]",function(t){t.stopPropagation(),t.preventDefault(),o.toggle()}),e.opts.fullScreen&&!0===e.opts.fullScreen.autoStart&&o.request(),e.FullScreen=o):e&&e.$refs.toolbar.find("[data-fancybox-fullscreen]").hide()},"afterKeydown.fb":function(t,e,n,o,i){e&&e.FullScreen&&70===i&&(o.preventDefault(),e.FullScreen.toggle())},"beforeClose.fb":function(t,e){e&&e.FullScreen&&e.$refs.container.hasClass("fancybox-is-fullscreen")&&o.exit()}})}(document,jQuery),function(t,e){"use strict";var n="fancybox-thumbs";e.fancybox.defaults=e.extend(!0,{btnTpl:{thumbs:'<button data-fancybox-thumbs class="fancybox-button fancybox-button--thumbs" title="{{THUMBS}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M14.59 14.59h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76H5.65v-3.76zm8.94-4.47h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76H5.65v-3.76zm8.94-4.47h3.76v3.76h-3.76V5.65zm-4.47 0h3.76v3.76h-3.76V5.65zm-4.47 0h3.76v3.76H5.65V5.65z"/></svg></button>'},thumbs:{autoStart:!1,hideOnClose:!0,parentEl:".fancybox-container",axis:"y"}},e.fancybox.defaults);var o=function(t){this.init(t)};e.extend(o.prototype,{$button:null,$grid:null,$list:null,isVisible:!1,isActive:!1,init:function(t){var e=this,n=t.group,o=0;e.instance=t,e.opts=n[t.currIndex].opts.thumbs,t.Thumbs=e,e.$button=t.$refs.toolbar.find("[data-fancybox-thumbs]");for(var i=0,a=n.length;i<a&&(n[i].thumb&&o++,!(o>1));i++);o>1&&e.opts?(e.$button.removeAttr("style").on("click",function(){e.toggle()}),e.isActive=!0):e.$button.hide()},create:function(){var t,o=this,i=o.instance,a=o.opts.parentEl,s=[];o.$grid||(o.$grid=e('<div class="'+n+" "+n+"-"+o.opts.axis+'"></div>').appendTo(i.$refs.container.find(a).addBack().filter(a)),o.$grid.on("click","a",function(){i.jumpTo(e(this).attr("data-index"))})),o.$list||(o.$list=e('<div class="'+n+'__list">').appendTo(o.$grid)),e.each(i.group,function(e,n){t=n.thumb,t||"image"!==n.type||(t=n.src),s.push('<a href="javascript:;" tabindex="0" data-index="'+e+'"'+(t&&t.length?' style="background-image:url('+t+')"':'class="fancybox-thumbs-missing"')+"></a>")}),o.$list[0].innerHTML=s.join(""),"x"===o.opts.axis&&o.$list.width(parseInt(o.$grid.css("padding-right"),10)+i.group.length*o.$list.children().eq(0).outerWidth(!0))},focus:function(t){var e,n,o=this,i=o.$list,a=o.$grid;o.instance.current&&(e=i.children().removeClass("fancybox-thumbs-active").filter('[data-index="'+o.instance.current.index+'"]').addClass("fancybox-thumbs-active"),n=e.position(),"y"===o.opts.axis&&(n.top<0||n.top>i.height()-e.outerHeight())?i.stop().animate({scrollTop:i.scrollTop()+n.top},t):"x"===o.opts.axis&&(n.left<a.scrollLeft()||n.left>a.scrollLeft()+(a.width()-e.outerWidth()))&&i.parent().stop().animate({scrollLeft:n.left},t))},update:function(){var t=this;t.instance.$refs.container.toggleClass("fancybox-show-thumbs",this.isVisible),t.isVisible?(t.$grid||t.create(),t.instance.trigger("onThumbsShow"),t.focus(0)):t.$grid&&t.instance.trigger("onThumbsHide"),t.instance.update()},hide:function(){this.isVisible=!1,this.update()},show:function(){this.isVisible=!0,this.update()},toggle:function(){this.isVisible=!this.isVisible,this.update()}}),e(t).on({"onInit.fb":function(t,e){var n;e&&!e.Thumbs&&(n=new o(e),n.isActive&&!0===n.opts.autoStart&&n.show())},"beforeShow.fb":function(t,e,n,o){var i=e&&e.Thumbs;i&&i.isVisible&&i.focus(o?0:250)},"afterKeydown.fb":function(t,e,n,o,i){var a=e&&e.Thumbs;a&&a.isActive&&71===i&&(o.preventDefault(),a.toggle())},"beforeClose.fb":function(t,e){var n=e&&e.Thumbs;n&&n.isVisible&&!1!==n.opts.hideOnClose&&n.$grid.hide()}})}(document,jQuery),function(t,e){"use strict";function n(t){var e={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;","/":"&#x2F;","`":"&#x60;","=":"&#x3D;"};return String(t).replace(/[&<>"'`=\/]/g,function(t){return e[t]})}e.extend(!0,e.fancybox.defaults,{btnTpl:{share:'<button data-fancybox-share class="fancybox-button fancybox-button--share" title="{{SHARE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M2.55 19c1.4-8.4 9.1-9.8 11.9-9.8V5l7 7-7 6.3v-3.5c-2.8 0-10.5 2.1-11.9 4.2z"/></svg></button>'},share:{url:function(t,e){return!t.currentHash&&"inline"!==e.type&&"html"!==e.type&&(e.origSrc||e.src)||window.location},
tpl:'<div class="fancybox-share"><h1>{{SHARE}}</h1><p><a class="fancybox-share__button fancybox-share__button--fb" href="https://www.facebook.com/sharer/sharer.php?u={{url}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m287 456v-299c0-21 6-35 35-35h38v-63c-7-1-29-3-55-3-54 0-91 33-91 94v306m143-254h-205v72h196" /></svg><span>Facebook</span></a><a class="fancybox-share__button fancybox-share__button--tw" href="https://twitter.com/intent/tweet?url={{url}}&text={{descr}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m456 133c-14 7-31 11-47 13 17-10 30-27 37-46-15 10-34 16-52 20-61-62-157-7-141 75-68-3-129-35-169-85-22 37-11 86 26 109-13 0-26-4-37-9 0 39 28 72 65 80-12 3-25 4-37 2 10 33 41 57 77 57-42 30-77 38-122 34 170 111 378-32 359-208 16-11 30-25 41-42z" /></svg><span>Twitter</span></a><a class="fancybox-share__button fancybox-share__button--pt" href="https://www.pinterest.com/pin/create/button/?url={{url}}&description={{descr}}&media={{media}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m265 56c-109 0-164 78-164 144 0 39 15 74 47 87 5 2 10 0 12-5l4-19c2-6 1-8-3-13-9-11-15-25-15-45 0-58 43-110 113-110 62 0 96 38 96 88 0 67-30 122-73 122-24 0-42-19-36-44 6-29 20-60 20-81 0-19-10-35-31-35-25 0-44 26-44 60 0 21 7 36 7 36l-30 125c-8 37-1 83 0 87 0 3 4 4 5 2 2-3 32-39 42-75l16-64c8 16 31 29 56 29 74 0 124-67 124-157 0-69-58-132-146-132z" fill="#fff"/></svg><span>Pinterest</span></a></p><p><input class="fancybox-share__input" type="text" value="{{url_raw}}" onclick="select()" /></p></div>'}}),e(t).on("click","[data-fancybox-share]",function(){var t,o,i=e.fancybox.getInstance(),a=i.current||null;a&&("function"===e.type(a.opts.share.url)&&(t=a.opts.share.url.apply(a,[i,a])),o=a.opts.share.tpl.replace(/\{\{media\}\}/g,"image"===a.type?encodeURIComponent(a.src):"").replace(/\{\{url\}\}/g,encodeURIComponent(t)).replace(/\{\{url_raw\}\}/g,n(t)).replace(/\{\{descr\}\}/g,i.$caption?encodeURIComponent(i.$caption.text()):""),e.fancybox.open({src:i.translate(i,o),type:"html",opts:{touch:!1,animationEffect:!1,afterLoad:function(t,e){i.$refs.container.one("beforeClose.fb",function(){t.close(null,0)}),e.$content.find(".fancybox-share__button").click(function(){return window.open(this.href,"Share","width=550, height=450"),!1})},mobile:{autoFocus:!1}}}))})}(document,jQuery),function(t,e,n){"use strict";function o(){var e=t.location.hash.substr(1),n=e.split("-"),o=n.length>1&&/^\+?\d+$/.test(n[n.length-1])?parseInt(n.pop(-1),10)||1:1,i=n.join("-");return{hash:e,index:o<1?1:o,gallery:i}}function i(t){""!==t.gallery&&n("[data-fancybox='"+n.escapeSelector(t.gallery)+"']").eq(t.index-1).focus().trigger("click.fb-start")}function a(t){var e,n;return!!t&&(e=t.current?t.current.opts:t.opts,""!==(n=e.hash||(e.$orig?e.$orig.data("fancybox")||e.$orig.data("fancybox-trigger"):""))&&n)}n.escapeSelector||(n.escapeSelector=function(t){return(t+"").replace(/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g,function(t,e){return e?"\0"===t?"�":t.slice(0,-1)+"\\"+t.charCodeAt(t.length-1).toString(16)+" ":"\\"+t})}),n(function(){!1!==n.fancybox.defaults.hash&&(n(e).on({"onInit.fb":function(t,e){var n,i;!1!==e.group[e.currIndex].opts.hash&&(n=o(),(i=a(e))&&n.gallery&&i==n.gallery&&(e.currIndex=n.index-1))},"beforeShow.fb":function(n,o,i,s){var r;i&&!1!==i.opts.hash&&(r=a(o))&&(o.currentHash=r+(o.group.length>1?"-"+(i.index+1):""),t.location.hash!=="#"+o.currentHash&&(s&&!o.origHash&&(o.origHash=t.location.hash),o.hashTimer&&clearTimeout(o.hashTimer),o.hashTimer=setTimeout(function(){"replaceState"in t.history?(t.history[s?"pushState":"replaceState"]({},e.title,t.location.pathname+t.location.search+"#"+o.currentHash),s&&(o.hasCreatedHistory=!0)):t.location.hash=o.currentHash,o.hashTimer=null},300)))},"beforeClose.fb":function(n,o,i){i&&!1!==i.opts.hash&&(clearTimeout(o.hashTimer),o.currentHash&&o.hasCreatedHistory?t.history.back():o.currentHash&&("replaceState"in t.history?t.history.replaceState({},e.title,t.location.pathname+t.location.search+(o.origHash||"")):t.location.hash=o.origHash),o.currentHash=null)}}),n(t).on("hashchange.fb",function(){var t=o(),e=null;n.each(n(".fancybox-container").get().reverse(),function(t,o){var i=n(o).data("FancyBox");if(i&&i.currentHash)return e=i,!1}),e?e.currentHash===t.gallery+"-"+t.index||1===t.index&&e.currentHash==t.gallery||(e.currentHash=null,e.close()):""!==t.gallery&&i(t)}),setTimeout(function(){n.fancybox.getInstance()||i(o())},50))})}(window,document,jQuery),function(t,e){"use strict";var n=(new Date).getTime();e(t).on({"onInit.fb":function(t,e,o){e.$refs.stage.on("mousewheel DOMMouseScroll wheel MozMousePixelScroll",function(t){var o=e.current,i=(new Date).getTime();e.group.length<2||!1===o.opts.wheel||"auto"===o.opts.wheel&&"image"!==o.type||(t.preventDefault(),t.stopPropagation(),o.$slide.hasClass("fancybox-animated")||(t=t.originalEvent||t,i-n<250||(n=i,e[(-t.deltaY||-t.deltaX||t.wheelDelta||-t.detail)<0?"next":"previous"]())))})}})}(document,jQuery);
/*! lazysizes - v4.1.8 */
!function (a, b) { var c = b(a, a.document); a.lazySizes = c, "object" == typeof module && module.exports && (module.exports = c) }(window, function (a, b) { "use strict"; if (b.getElementsByClassName) { var c, d, e = b.documentElement, f = a.Date, g = a.HTMLPictureElement, h = "addEventListener", i = "getAttribute", j = a[h], k = a.setTimeout, l = a.requestAnimationFrame || k, m = a.requestIdleCallback, n = /^picture$/i, o = ["load", "error", "lazyincluded", "_lazyloaded"], p = {}, q = Array.prototype.forEach, r = function (a, b) { return p[b] || (p[b] = new RegExp("(\\s|^)" + b + "(\\s|$)")), p[b].test(a[i]("class") || "") && p[b] }, s = function (a, b) { r(a, b) || a.setAttribute("class", (a[i]("class") || "").trim() + " " + b) }, t = function (a, b) { var c; (c = r(a, b)) && a.setAttribute("class", (a[i]("class") || "").replace(c, " ")) }, u = function (a, b, c) { var d = c ? h : "removeEventListener"; c && u(a, b), o.forEach(function (c) { a[d](c, b) }) }, v = function (a, d, e, f, g) { var h = b.createEvent("Event"); return e || (e = {}), e.instance = c, h.initEvent(d, !f, !g), h.detail = e, a.dispatchEvent(h), h }, w = function (b, c) { var e; !g && (e = a.picturefill || d.pf) ? (c && c.src && !b[i]("srcset") && b.setAttribute("srcset", c.src), e({ reevaluate: !0, elements: [b] })) : c && c.src && (b.src = c.src) }, x = function (a, b) { return (getComputedStyle(a, null) || {})[b] }, y = function (a, b, c) { for (c = c || a.offsetWidth; c < d.minSize && b && !a._lazysizesWidth;)c = b.offsetWidth, b = b.parentNode; return c }, z = function () { var a, c, d = [], e = [], f = d, g = function () { var b = f; for (f = d.length ? e : d, a = !0, c = !1; b.length;)b.shift()(); a = !1 }, h = function (d, e) { a && !e ? d.apply(this, arguments) : (f.push(d), c || (c = !0, (b.hidden ? k : l)(g))) }; return h._lsFlush = g, h }(), A = function (a, b) { return b ? function () { z(a) } : function () { var b = this, c = arguments; z(function () { a.apply(b, c) }) } }, B = function (a) { var b, c = 0, e = d.throttleDelay, g = d.ricTimeout, h = function () { b = !1, c = f.now(), a() }, i = m && g > 49 ? function () { m(h, { timeout: g }), g !== d.ricTimeout && (g = d.ricTimeout) } : A(function () { k(h) }, !0); return function (a) { var d; (a = !0 === a) && (g = 33), b || (b = !0, d = e - (f.now() - c), d < 0 && (d = 0), a || d < 9 ? i() : k(i, d)) } }, C = function (a) { var b, c, d = 99, e = function () { b = null, a() }, g = function () { var a = f.now() - c; a < d ? k(g, d - a) : (m || e)(e) }; return function () { c = f.now(), b || (b = k(g, d)) } }; !function () { var b, c = { lazyClass: "lazyload", loadedClass: "lazyloaded", loadingClass: "lazyloading", preloadClass: "lazypreload", errorClass: "lazyerror", autosizesClass: "lazyautosizes", srcAttr: "data-src", srcsetAttr: "data-srcset", sizesAttr: "data-sizes", minSize: 40, customMedia: {}, init: !0, expFactor: 1.5, hFac: .8, loadMode: 2, loadHidden: !0, ricTimeout: 0, throttleDelay: 125 }; d = a.lazySizesConfig || a.lazysizesConfig || {}; for (b in c) b in d || (d[b] = c[b]); a.lazySizesConfig = d, k(function () { d.init && F() }) }(); var D = function () { var g, l, m, o, p, y, D, F, G, H, I, J, K = /^img$/i, L = /^iframe$/i, M = "onscroll" in a && !/(gle|ing)bot/.test(navigator.userAgent), N = 0, O = 0, P = 0, Q = -1, R = function (a) { P-- , (!a || P < 0 || !a.target) && (P = 0) }, S = function (a) { return null == J && (J = "hidden" == x(b.body, "visibility")), J || "hidden" != x(a.parentNode, "visibility") && "hidden" != x(a, "visibility") }, T = function (a, c) { var d, f = a, g = S(a); for (F -= c, I += c, G -= c, H += c; g && (f = f.offsetParent) && f != b.body && f != e;)(g = (x(f, "opacity") || 1) > 0) && "visible" != x(f, "overflow") && (d = f.getBoundingClientRect(), g = H > d.left && G < d.right && I > d.top - 1 && F < d.bottom + 1); return g }, U = function () { var a, f, h, j, k, m, n, p, q, r, s, t, u = c.elements; if ((o = d.loadMode) && P < 8 && (a = u.length)) { for (f = 0, Q++; f < a; f++)if (u[f] && !u[f]._lazyRace) if (!M || c.prematureUnveil && c.prematureUnveil(u[f])) aa(u[f]); else if ((p = u[f][i]("data-expand")) && (m = 1 * p) || (m = O), r || (r = !d.expand || d.expand < 1 ? e.clientHeight > 500 && e.clientWidth > 500 ? 500 : 370 : d.expand, c._defEx = r, s = r * d.expFactor, t = d.hFac, J = null, O < s && P < 1 && Q > 2 && o > 2 && !b.hidden ? (O = s, Q = 0) : O = o > 1 && Q > 1 && P < 6 ? r : N), q !== m && (y = innerWidth + m * t, D = innerHeight + m, n = -1 * m, q = m), h = u[f].getBoundingClientRect(), (I = h.bottom) >= n && (F = h.top) <= D && (H = h.right) >= n * t && (G = h.left) <= y && (I || H || G || F) && (d.loadHidden || S(u[f])) && (l && P < 3 && !p && (o < 3 || Q < 4) || T(u[f], m))) { if (aa(u[f]), k = !0, P > 9) break } else !k && l && !j && P < 4 && Q < 4 && o > 2 && (g[0] || d.preloadAfterLoad) && (g[0] || !p && (I || H || G || F || "auto" != u[f][i](d.sizesAttr))) && (j = g[0] || u[f]); j && !k && aa(j) } }, V = B(U), W = function (a) { var b = a.target; if (b._lazyCache) return void delete b._lazyCache; R(a), s(b, d.loadedClass), t(b, d.loadingClass), u(b, Y), v(b, "lazyloaded") }, X = A(W), Y = function (a) { X({ target: a.target }) }, Z = function (a, b) { try { a.contentWindow.location.replace(b) } catch (c) { a.src = b } }, $ = function (a) { var b, c = a[i](d.srcsetAttr); (b = d.customMedia[a[i]("data-media") || a[i]("media")]) && a.setAttribute("media", b), c && a.setAttribute("srcset", c) }, _ = A(function (a, b, c, e, f) { var g, h, j, l, o, p; (o = v(a, "lazybeforeunveil", b)).defaultPrevented || (e && (c ? s(a, d.autosizesClass) : a.setAttribute("sizes", e)), h = a[i](d.srcsetAttr), g = a[i](d.srcAttr), f && (j = a.parentNode, l = j && n.test(j.nodeName || "")), p = b.firesLoad || "src" in a && (h || g || l), o = { target: a }, s(a, d.loadingClass), p && (clearTimeout(m), m = k(R, 2500), u(a, Y, !0)), l && q.call(j.getElementsByTagName("source"), $), h ? a.setAttribute("srcset", h) : g && !l && (L.test(a.nodeName) ? Z(a, g) : a.src = g), f && (h || l) && w(a, { src: g })), a._lazyRace && delete a._lazyRace, t(a, d.lazyClass), z(function () { var b = a.complete && a.naturalWidth > 1; p && !b || (b && s(a, "ls-is-cached"), W(o), a._lazyCache = !0, k(function () { "_lazyCache" in a && delete a._lazyCache }, 9)), "lazy" == a.loading && P-- }, !0) }), aa = function (a) { if (!a._lazyRace) { var b, c = K.test(a.nodeName), e = c && (a[i](d.sizesAttr) || a[i]("sizes")), f = "auto" == e; (!f && l || !c || !a[i]("src") && !a.srcset || a.complete || r(a, d.errorClass) || !r(a, d.lazyClass)) && (b = v(a, "lazyunveilread").detail, f && E.updateElem(a, !0, a.offsetWidth), a._lazyRace = !0, P++ , _(a, b, f, e, c)) } }, ba = C(function () { d.loadMode = 3, V() }), ca = function () { 3 == d.loadMode && (d.loadMode = 2), ba() }, da = function () { if (!l) { if (f.now() - p < 999) return void k(da, 999); l = !0, d.loadMode = 3, V(), j("scroll", ca, !0) } }; return { _: function () { p = f.now(), c.elements = b.getElementsByClassName(d.lazyClass), g = b.getElementsByClassName(d.lazyClass + " " + d.preloadClass), j("scroll", V, !0), j("resize", V, !0), a.MutationObserver ? new MutationObserver(V).observe(e, { childList: !0, subtree: !0, attributes: !0 }) : (e[h]("DOMNodeInserted", V, !0), e[h]("DOMAttrModified", V, !0), setInterval(V, 999)), j("hashchange", V, !0), ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function (a) { b[h](a, V, !0) }), /d$|^c/.test(b.readyState) ? da() : (j("load", da), b[h]("DOMContentLoaded", V), k(da, 2e4)), c.elements.length ? (U(), z._lsFlush()) : V() }, checkElems: V, unveil: aa, _aLSL: ca } }(), E = function () { var a, c = A(function (a, b, c, d) { var e, f, g; if (a._lazysizesWidth = d, d += "px", a.setAttribute("sizes", d), n.test(b.nodeName || "")) for (e = b.getElementsByTagName("source"), f = 0, g = e.length; f < g; f++)e[f].setAttribute("sizes", d); c.detail.dataAttr || w(a, c.detail) }), e = function (a, b, d) { var e, f = a.parentNode; f && (d = y(a, f, d), e = v(a, "lazybeforesizes", { width: d, dataAttr: !!b }), e.defaultPrevented || (d = e.detail.width) && d !== a._lazysizesWidth && c(a, f, e, d)) }, f = function () { var b, c = a.length; if (c) for (b = 0; b < c; b++)e(a[b]) }, g = C(f); return { _: function () { a = b.getElementsByClassName(d.autosizesClass), j("resize", g) }, checkElems: g, updateElem: e } }(), F = function () { F.i || (F.i = !0, E._(), D._()) }; return c = { cfg: d, autoSizer: E, loader: D, init: F, uP: w, aC: s, rC: t, hC: r, fire: v, gW: y, rAF: z } } });
var bPopupActive = false;
var bSuggestClicked = false;
var bToggleClearSearchFieldClicked = false;
var bMenuLoaded = false;

var typingTimer;
var doneTypingInterval = 300;

function el(elementId) {
	return document.getElementById(elementId);
}

Object.defineProperty(window,'el',{
	value : function(elementId) {
				return document.getElementById(elementId);
			},
	writable: false
});

(function($) {
	$.fn.onClassChange = function(cb) {
		return $(this).each((_, el) => {
		  new MutationObserver(mutations => {
			mutations.forEach(mutation => cb && cb(mutation.target, mutation.target.className));
		  }).observe(el, {
			attributes: true,
			attributeFilter: ['class']
		  });
		});
	  }
})(jQuery);

function createQrCode()
{
	// create qr code
	uAjax = "/index.cfm/ajax/createqrcode";
	var sParams = '&url=' + window.location.href;
	var oCall = callAjax("createqrcode", sParams, "POST");

	// process result
	oCall.success(function (oData)
	{
		if (typeof oData.qrCodeUrl !== "undefined" && oData.qrCodeUrl !== "" && typeof QRCode !== "undefined")
		{
			new QRCode(document.getElementById("createQrCodeResult"), {
				text: oData.qrCodeUrl,
				width: 1000,
				height: 1000
			});

			setTimeout(function()
			{
				var aUrl = window.location.href.split("/");
				var sFileName = aUrl[aUrl.length - 1].replace(/[\W_]+/g,"-");
				var sSrc = $("#createQrCodeResult img").attr("src");
				var oAnchor = document.createElement("a");
				oAnchor.href = sSrc;
				oAnchor.download = "qrcode-" + sFileName + ".png";
				oAnchor.click();

				$(el("createQrCodeForPage")).prop("disabled",false);
			}, 1500);
		}
		else
		{
			$(el("createQrCodeForPage")).prop("disabled",false);
		}
	});
}

function handleTriggerJsHeaderSearch(oEl)
{
	oEl.parents('.jsHeaderSearchWrapper').addClass('jsHeaderSearchActive');
	oEl.parents('.jsHeaderSearchWrapper').find('.jsHeaderSearchSubmitWrapper').show();
	oEl.siblings('.dismissJsHeaderSearch').show();
	$('html, body').animate({ scrollTop: 0 }, 0);
	$('html, body').css({'overflow':'hidden', 'position': 'relative', 'height':'100%'});
}

function handleDismissJsHeaderSearch(oEl)
{
	oEl.parents('.jsHeaderSearchWrapper').removeClass('jsHeaderSearchActive');
	oEl.parents('.jsHeaderSearchWrapper').find('.jsHeaderSearchSubmitWrapper').hide();
	oEl.hide();
	$('html, body').css({'overflow':'visible', 'position': 'static', 'height':'auto'});
	$(el('suggest')).remove();
}

// jquery methods
(function($) {
	$.fn.ajaxLoader = function(sAction) {
		// create and show the loader
		if (sAction === 'show') {
			//check if loader is not already existing
			var isLoaderExisting = $('#ajaxLoaderImgId').length;
			//if not existing, create the loader
			if(isLoaderExisting === 0){
				var oLoader = $('<img src="/styles/images/icon/ajax-loader.gif" class="hide ajaxLoader" id="ajaxLoaderImgId" />');
				this.after(oLoader);
				oLoader.fadeIn(200);
			}
		}

		// hide and destroy the loader
		if (sAction === 'hide') {
			this.next('.ajaxLoader').fadeOut(200, function() {
				$(this).remove();
			});
		}

		return this;
	}
}(jQuery));

var loadMobileNavigation = function () {
	// Get navigation from cache
	uAjax = "/index.cfm/ajax/mobilenavigation";
	var oCall = callAjax("mobilenavigation", "", "get");
	// process result
	oCall.success(function (oData) {
		bMenuLoaded = true;
		if (oData.html !== "") {
			$(".nav-collapse.fsMenu").html(oData.html);
		}
	});
};

var doneTyping = function (input, e) {
	var iKeyCode = e.keyCode;
	var sKeyword = input.val();

	if (sKeyword !== '') {
		suggestKeyHandler(input, iKeyCode, sKeyword);
	}
	else {
		$(el('suggest')).remove();
	}
}

var popupSendPicturePack = function(sSkuIds,oButton){
	$('#sendConfirmPicturePackModal').modal('show')
	$('#sendConfirmPicturePackModal #btnSend').data('skuIds',sSkuIds);
}

var initLazyResponsiveLoad = function () {
	// IE fallback
	var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
		setTimeout(function(){
			$(".ci-image").css("opacity",100);
		}, 1000);
	}
}

function addProductToBasket(oBtn, iQty)
{
	oBtn.attr('disabled','disabled');
	var sProductId = oBtn.closest('li').data('product');
	var sParams = '&productid=' + sProductId + '&bMobile=' + ($(window).width() < 768);

	if (oBtn.closest('li').hasClass('thumb')) {
		var selectedSizeSkuId = oBtn.closest('.thumb').find('.selectedSkuId').attr('data-skuId');
		if (typeof selectedSizeSkuId !== 'undefined') {
			sParams += '&selectedSizeSkuId=' + selectedSizeSkuId;
		} else if(typeof oBtn.attr('data-firstSkuId') !== "undefined" && oBtn.attr('data-firstSkuId') !== -1) {
			sParams += '&selectedSizeSkuId=' + oBtn.attr('data-firstSkuId');
		}
	}

	if (typeof iQty !== 'undefined') sParams += '&qty=' + iQty;
	uAjax = "/index.cfm/product/ajax/addproduct";
	var oCall = callAjax("products", sParams, "post");

	// process result
	oCall.success(function(oData)
	{
		if(oData.errorType == '')
		{
			if(typeof oData.price !== 'undefined' && typeof oData.qty !== 'undefined' && typeof oData.skuId !== 'undefined')
			{
				$(document).trigger("fbqAddToCartThumb",[oData.skuId,oData.qty,oData.price]);
				$(document).trigger("addProductToBasket",[oData.skuId]);
				$(document).trigger("ga4AddProductToBasket",[oData.skuId,oData.qty,oData.price]);
			}

			if(typeof oData.addskupopup !== "undefined" && $('#addSkuPopup').length > 0)
			{
				// trigger modal with upsell products
				$('#addSkuPopup').html(oData.addskupopup);
				$('#addSkuPopup .modal').modal('show');
				centerPopups();

				// update basketdropdown but don't show
				$('#basketDropdown').html(oData.html);
			}
			else
			{
				$('#basketDropdown').html(oData.html).delay(300).queue(function(next){
					$(this).addClass("open");

					setTimeout(function(){
						if($('#basketDropdown').is(':visible')) {
							$('#basketDropdown').removeClass('open');
						}
					}, 3000);

					next();
				});
				if (!$('#basketSidebar').length >= 1) {
					$('html, body').animate({scrollTop: '0px'}, 300);
				}
			}

			if (window.history && window.history.pushState)
			{
				window.history.pushState({"addedProductToBasket": true}, "addedProductToBasket", location.href);
			}

			oBtn.removeAttr('disabled');
		}
		else {
			// check for href
			if(oBtn.attr('href') !== "undefined" && oBtn.attr('href') !== "")
			{
				window.location = oBtn.attr('href');
			}
			else
			{
				// could not add to basket, go to product detail
				window.location = '/product/detail/' + sProductId;
			}
		}
	});
}

function addToWishlist(sProductId)
{
	uAjax = "/index.cfm/customer/ajax/addtowishlist";

	var sParams = '&productId=' + sProductId;
	var oCall = callAjax("addToWishlist", sParams, "post");
	oCall.success(function(oData)
	{
		if (oData.errorType == '')
		{
			$(document).trigger( "addToWishlist", sProductId);

			if($('.wishlistContainer').length > 0)
			{
				$('.wishlistContainer').replaceWith(oData.html);

				ciResponsive.process();
			}
			if($('.wishlistQuantity').length > 0)
			{
				$('.wishlistQuantity').html('<span>'+oData.wishlistQuantity+'</span>');
				if(oData.wishlistQuantity == 0)
				{
					$('.wishlistQuantity').hide();
				}
				else
				{
					$('.wishlistQuantity').show();
					$('.wishlistQuantity span').css('animation','pulse 2s 3');
				}
			}
			var oThumb = $('.thumb[data-product="' + sProductId + '"]');
			oThumb.find('.fa-heart-o').addClass('fa-heart').removeClass('fa-heart-o');
			oThumb.find('.icon-heart-empty').addClass('icon-heart').removeClass('icon-heart-empty');
			oThumb.find('.btnAddWishlistWrapper .btn-add').addClass('btnRemoveWishlist').removeClass('btnAddWishlist');
		}
		else
		{
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function addToWishlistList(oBtn)
{
	oBtn.prop('disabled', true);

	var sWishlistId = $('#addProductWishlistPopup').find('#wishlistsDropdown option:selected').val();
	var sSkuId = $('#addProductWishlistPopup').find('.sProductSkuId').val();
	var bRememberWishlist = $('#addProductWishlistPopup .rememberWishlist').is(":checked");
	var oThumb = $('.thumb[data-product="' + $('#addProductWishlistPopup').find('.sProductId').val() + '"]');
	uAjax = "/index.cfm/wishlist/ajax/addSku";
	var sParams = '&skuid=' + sSkuId + '&id=' + sWishlistId + '&rememberwishlist=' + bRememberWishlist;

	var oCall = callAjax("addSku", sParams, "post");
	oCall.success(function(oData)
	{
		if (oData.errorType == '')
		{
			$('#addProductWishlistPopup .modal').modal('hide');
			$("#mainContainer header .wishlistWrapper").replaceWith(oData.headerLinksHtml);
			oThumb.find('.btnAddWishlistWrapper .btn-add').addClass('btnRemoveWishlist').removeClass('btnAddWishlist');
			oThumb.find('.fa-heart-o').addClass('fa-heart').removeClass('fa-heart-o');
			$("#mainContainer header").append(oData.productAddedDropdown);
			$("#mainContainer header .wishlistProductDropdown").css('animation','pulse 2s 3');
			$("#mainContainer header .wishlistProductDropdown").hide().fadeIn(500).delay(5000).fadeOut(500, function(){
				$(this).remove();
			});
			sWishlistProducts = sWishlistProducts + "," + selectedSizeSkuId;
		}
		else if (oData.errorType == 'product_not_allowed') {
			$('#addProductWishlistPopup').find('.wishlistProductAddError').show();
		} else {
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}

		oBtn.prop('disabled', false);
	});
}

function addToWishlistPopup(oEl, sProductId)
{
	var oThumb = $('.thumb[data-product="' + sProductId + '"]');
	var selectedSizeSkuId = oThumb.find('.selectedSkuId').attr('data-skuId');

	if (typeof selectedSizeSkuId === 'undefined') {
		selectedSizeSkuId = oEl.closest('.thumb').find('.selectedSkuId').attr('data-firstSkuId');
	}
	var sParams = '&skuid=' + selectedSizeSkuId;
	uAjax = "/index.cfm/wishlist/ajax/addToWishlistPopup";

	var oCall = callAjax("addToWishlistPopup", sParams, "post");
	oCall.success(function(oData)
	{
		if (oData.errorType == '' || (typeof oData.errorCode !== "undefined" && oData.errorCode == '401'))
		{
			var oWishlistModal = oData.html;
			$('#addProductWishlistPopup').html(oWishlistModal);
			var elProductId = $('<input>', {
				type: 'hidden',
				class: 'sProductId',
				name: 'sProductId',
				value: sProductId
			});
			$('#addProductWishlistPopup .addProductWishlistModal').append(elProductId);
			$('#addProductWishlistPopup .modal').modal('show');
			centerPopups();
		} else if (oData.errorType == 'product_added') {
			$("#mainContainer header .wishlistWrapper").replaceWith(oData.headerLinksHtml);
			oThumb.find('.btnAddWishlistWrapper .btn-add').addClass('btnRemoveWishlist').removeClass('btnAddWishlist');
			oThumb.find('.fa-heart-o').addClass('fa-heart').removeClass('fa-heart-o');
			$("#mainContainer header").append(oData.productAddedDropdown);
			$("#mainContainer header .wishlistProductDropdown").css('animation','pulse 2s 3');
			$("#mainContainer header .wishlistProductDropdown").hide().fadeIn(500).delay(5000).fadeOut(500, function(){
				$(this).remove();
			});
			sWishlistProducts = sWishlistProducts + "," + selectedSizeSkuId;
		}
		else if (oData.errorType == 'not_logged_in') {
			window.location = '/' + sCurrentLanguageCode + '/customer/login'
		}
		else if (oData.errorType == 'product_not_allowed') {
			var oWishlistModal = oData.html;
			$('#addProductWishlistPopup').html(oWishlistModal);
			$('#addProductWishlistPopup').find('.wishlistProductAddError').show();
			$('#addProductWishlistPopup .modal').modal('show');
			centerPopups();
		}
		else if(oData.errorType == 'no_skuid' || oData.errorType == 'cannotAdd') {
			// could not add to wishlist, go to product detail
			window.location = '/product/detail/' + sProductId;
		} else {
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
		oEl.prop('disabled',false);
	});
}


function changeContentPage(page) {
	var sParams = '&page=' + page;
	var oCall = callAjax("getpages", sParams, "post", "/index.cfm/content/ajax/getpages");
	// process feedback
	oCall.success(function(oData) {
		if (oData.errorType == '') {
			$(el('changeContentPage')).find('.modal-body').html(oData.html);
			$(el('changeContentPage')).modal();

			centerPopups();
		} else {
			// show error message
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function closeCookiePopup(button)
{
	setCookie('hideCookieBanner','true',30);
	button.closest('.cookies').slideToggle(400);
}

function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function isTouchDevice() {
	var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
	var mq = function(query) {
		return window.matchMedia(query).matches;
	}

	if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
		return true;
	}

	// include the 'heartz' as a way to have a non matching MQ to help terminate the join
	// https://git.io/vznFH
	var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
	return mq(query);
}

function setLinkedPage(block, page, button) {
	// show loader
	var oLoader = button;
	oLoader.ajaxLoader('show');
	$('.btnPick').hide();
	var sParams = '&block=' + block + '&page=' + page;
	var oCall = callAjax("setlinkedpage", sParams, "post", "/index.cfm/content/ajax/setlinkedpage");
	// process feedback
	oCall.success(function(oData) {
		if (typeof oData.id !== 'undefined' || oData.errorMessage === '') {
			location.reload();
		} else {
			// show error message
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
			$('.btnPick').show();
			oLoader.ajaxLoader('hide');
		}
	});
}

function processAjax(action, sParams, sMethod, sContainerId) {
	var oCall = callAjax(action, sParams, sMethod);
	oCall.success(function(oData) {
		if (oData.errorType == '' && oData.html != '') {
			refreshContent(sContainerId, oData.html);
		} else {
			showAlert(oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function refreshContent(sContainerId, oHtml) {
	$('.modal').modal('hide');
	bPopupActive = false;
	$('#' + sContainerId).html(oHtml);
	$('.scroll-pane').jScrollPane({
		mouseWheelSpeed: 40,
		verticalDragMinHeight: 30
	});
}

function callAjax(action, sParams, sMethod, url, bAsyncSpecified) {

	if (typeof url === 'undefined') {
		url = uAjax;
	}

	if(typeof bAsyncSpecified === 'undefined')
	{
		bAsyncSpecified = true;
	}

	// return ajax call reference
	if (typeof sParams === 'object') {
		// with json
		return $.ajax({
			url: url + "?action=" + action,
			data: JSON.stringify(sParams),
			dataType: 'json',
			contentType: "application/json; charset=utf-8",
			type: sMethod,
			async: bAsyncSpecified,
			cache: false
		});
	} else {
		// params are a query string
		return $.ajax({
			url: url,
			data: "action=" + action + sParams,
			dataType: 'json',
			type: sMethod,
			async: bAsyncSpecified,
			cache: false
		});
	}
}

function buildConfigurator(type,code,sku,order,orderLine,readonly)
{
	if(type != '' && code !== '' && sku !== '')
	{
		var sParams = '&type=' + type + '&code=' + code + '&skuId=' + sku + '&orderLineId=' + encodeURIComponent(orderLine) + '&orderId=' + order + '&readonly=' + readonly;
		return callAjax('buildConfigurator', sParams, 'POST', "/index.cfm/product/ajax/buildconfigurator");
	}
	else
	{
		showAlert('info', "tConfiguratorNotConfigured", false);
	}
}

function centerPopups() {
	var iWindowHalf = window.innerHeight / 2;
	var iWindowHalfWidth = window.innerWidth / 2;
	$('.modal').each(function() {
		var iPopupHalf = $(this).outerHeight() / 2;
		var iTop = iWindowHalf - iPopupHalf;
		$(this).css('top', iTop + 'px');
		var iPopupHalfWidth = $(this).outerWidth() / 2;
		var iLeft = iWindowHalfWidth - iPopupHalfWidth;
		$(this).css('left', iLeft + 'px');
	});
}

function initPaymentOptions()
{
	var oThumbsCanFinance = $(el('mainContainer')).find(".thumb .thumbFinanceOptions");

	if(oThumbsCanFinance.length > 0)
	{
		oThumbsCanFinance.each(function () {
			loadPaymentOptions($(this).data("amount"), $(this));
		});
	}
}

function loadPaymentOptions(iAmount, oThumb)
{
	uAjax = "/index.cfm/product/ajax/getpaymentoptions";

	var sParams = "&amount=" + iAmount;
	var oCall   = callAjax("getpaymentoptions", sParams, "post");
	oCall.success(function (oData)
	{
		if (oData.errorType == '')
		{
			oThumb.html(oData.html);
		}
		else {
			// show error message
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function setScanMode(oBtn)
{
	uAjax = "/index.cfm/ajax/setscanmode";

	var bEnable = oBtn.data('enable');
	var sParams = '&enable=' + bEnable;
	var oCall = callAjax("setScanMode", sParams, "post");
	oCall.success(function(oData)
	{
		if (oData.errorType === '')
		{
			location.reload();
		}
		else
		{
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function focusEan(oElement, bSelect) {
	$(window).unbind();
	var oScan = document.getElementById(oElement);
	if (!("autofocus" in document.createElement("input"))) {
		oScan.focus();
	}
	if (bSelect) {
		oScan.select();
	}
	$(window).keydown(function(evt) {
		if (bPopupActive == false) {
			oScan.focus();
		}
	});
}

function getValues(oFormEl, sContainer, sFormat) {
	sFormat = typeof sFormat !== 'undefined' ? sFormat : 'ajax';
	oFormEl = typeof sContainer !== 'undefined' ? oFormEl.find(sContainer) : oFormEl;


	var aElements = [];
	oFormEl.find('input,select,textarea').each(function(index, oEl) {
		if (($(oEl).is(':visible') || $(oEl).attr('type') == 'hidden' || $(oEl).data('toggle') == "toggle") && $(oEl).prop('disabled') !== true) {

			//trim vat values
			if($(oEl).attr('name') === "inputVatNumber" || $(oEl).attr('name') === "inputVat" || $(oEl).attr('name') === "inputInvoiceVat")
			{
				var sTrim = $(oEl).val().trim();
				var sCountryCode = sTrim.substr(0,2);
				var sVat = sTrim.substr(2).replace(/[^a-z0-9]/gi,'');
				$(oEl).val(sCountryCode+sVat)
			}

			switch ($(oEl).attr('type')) {
				case "radio":
					if ($(oEl).prop('checked') === true && typeof $(oEl).attr('name') !== 'undefined') {
						aElements.push([$(oEl).attr('name').replace('input', 'edt').split('_')[0], $(oEl).val()]);
					}
					break;
				case "checkbox":
					if ($(oEl).prop('checked') === true && typeof $(oEl).attr('name') !== 'undefined') {
						aElements.push([$(oEl).attr('name').replace('input', 'edt'), $(oEl).val()]);
					}
					else if(($(oEl).data('toggle') == "toggle" || $(oEl).data('checkboxType') == "boolean") && typeof $(oEl).attr("name") !== "undefined"){
						aElements.push([$(oEl).attr('name').replace('input', 'edt'), false])
					}
					break;
				default:
					if (typeof $(oEl).attr('name') === 'undefined') {
						if (typeof $(oEl).attr('id') !== 'undefined') {
							aElements.push([$(oEl).attr('id').replace('input', 'edt'), $(oEl).val()]);
						}
					} else {
						aElements.push([$(oEl).attr('name').replace('input', 'edt'), $(oEl).val()]);
					}
			}
		}
	});

	var sParams = '';
	switch (sFormat) {
		case 'ajax':
			for (var i = 0; i < aElements.length; i++) {
				sParams += '&' + aElements[i][0] + '=' + encodeURIComponent(aElements[i][1]);
			}
			break;
	}
	return sParams;
}

function getUrlParam(url, param) {
	var results = new RegExp('[\?&]' + param + '=([^&#]*)').exec(url);
	if (results == null) {
		return '';
	}
	else {
		return decodeURI(results[1]) || 0;
	}
}

function getValueLabels(oFormEl)
{
	var aElements = [];
	oFormEl.find('input,select,textarea').each(function(index, oEl) {
		if (($(oEl).is(':visible') || $(oEl).attr('type') == 'hidden') && $(oEl).prop('disabled') !== true)
		{
			if (typeof $(oEl).data('name') !== 'undefined' && typeof $(oEl).data('label') !== 'undefined')
			{
				var oValueLabel = {};
				oValueLabel       = {};
				oValueLabel.label = $(oEl).data('label');
				oValueLabel.name  = $(oEl).data('name').replace('input', 'edt');

				switch ($(oEl).attr('type'))
				{
					case "checkbox":
						oValueLabel.value = ($(oEl).prop('checked') === true)?true: false;
						break;
					case "radio":
						oValueLabel.value = ($(oEl).prop('checked') === true)?true: false;
						break;
					default:
						oValueLabel.value = $(oEl).val();
				}
				aElements.push(oValueLabel);
			}
		}
	});

	return aElements;
}

function initButtons()
{
	$(el('mainContainer')).find('button .editTranslation').each(function(index, oEl)
	{
		$(oEl).parents('button').wrap('<div class="editButtonTranslation"></div>');
		oClone = $(oEl).clone();
		oClone.insertBefore($(oEl).parents('button'));
		$(oEl).removeClass('editTranslation');
		$(oEl).find('i').remove();
	});
}

function resetFeedback(oElement) {
	oElement.find('.feedback').hide();
	oElement.find('.error').removeClass('error');
}

function setAction(oContainer, sAction, oExtraVariables) {
	var oAction = oContainer.find('.action')
	oAction.attr('id', sAction);

	// add extra variables to button
	if(typeof oExtraVariables !== 'undefined')
	{
		$.each(oExtraVariables, function(key, value)
		{
			oAction.attr(key, value);
		});
	}
}

function deleteFromWishlist(oBtn)
{
	oBtn.prop("disabled", true);

	var oThumb = oBtn.closest('.thumb');
	var sSkuId = oThumb.find('.selectedSkuId').attr('data-skuId');
	if (typeof sSkuId === 'undefined') {
		sSkuId = oThumb.find('.selectedSkuId').attr('data-firstSkuId');
	}

	var sParams = '&skuId=' + sSkuId + '&fromlisterorpdp=true';
	var oCall   = callAjax("deleteLine", sParams, "post", "/index.cfm/wishlist/ajax/deleteLine");
	oCall.success(function(oData)
	{
		if(oData.errorMessage === '')
		{
			var productArray = (String(sWishlistProducts) || "").split(",");
			var index = productArray.indexOf(sSkuId);
			if (index !== -1) {
				productArray.splice(index, 1);
			}

			sWishlistProducts = productArray.join(",");
			$("#mainContainer header .wishlistWrapper").replaceWith(oData.headerLinksHtml);
			oThumb.find('.btnAddWishlistWrapper .btn-add').addClass('btnAddWishlist').removeClass('btnRemoveWishlist');
			oThumb.find('.fa-heart').addClass('fa-heart-o').removeClass('fa-heart');
			ciResponsive.process();
		}
		else
		{
			showAlert('error', oData.errorMessage, false, 3000);
		}
		oBtn.prop('disabled',false);
	});
}

function setScrollHeight(iBottomHeight) {
	var iHeight = document.documentElement.clientHeight - iBottomHeight;
	$('.scroll-pane').css('height', iHeight + 'px');
	if ($('.scroll-pane').length > 0) {
		$('.scroll-pane').jScrollPane({
			mouseWheelSpeed: 40,
			verticalDragMinHeight: 30
		});
	}
}

function inlineAlert(sType, sMessage, bUnhandled, oEl, bScroll, sTimeout)
{
	$('.inlineAlert').remove();

	if (bUnhandled === true) {
		var sMessage = 'Error';
	}

	var oError = $(wrapElement(sMessage, 'div')).addClass('inlineAlert alert alert-' + sType);
	oError.insertBefore($(oEl));

	if(typeof bScroll === 'undefined' || (typeof bScroll !== 'undefined' && bScroll))
	{
		scrollToElement($('.inlineAlert'));
	}
	if (sTimeout !== undefined) {
		setTimeout(function() {
			oError.slideUp(300).remove()
		}, sTimeout);
	}
}

function isiOS() {
	return [
	'iPad Simulator',
	'iPhone Simulator',
	'iPod Simulator',
	'iPad',
	'iPhone',
	'iPod'
	].includes(mnavigator.platfor)
	// iPad on iOS 13 detection
	|| (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}

function showAlert(sType, sMessage, bUnhandled, sTimeout, oEl) {
	if (bUnhandled === true) {
		var sMessage = 'Error';
	}

	var oError = $(wrapElement(sMessage, 'div')).addClass('popupAlert fade alert alert-' + sType).prepend('<a href="#" class="close" data-dismiss="alert">&times;</a>');

	$('.alertContainer').append(oError);
	setTimeout(function() {
		oError.addClass('in')
	}, 100);
	if (sTimeout !== undefined) {
		setTimeout(function() {
			oError.slideUp(300).remove()
		}, sTimeout);
	}
}

function wrapElement(sElement, sTag) {
	return "<" + sTag + ">" + sElement + "</" + sTag + ">";
}

function clearErrors() {
	$('.popupAlert').alert('close');
}

function clearInlineErrors() {
	$('.inlineAlert ').remove();
}


function removeLineBasketDropdown(lineElement) {
	var lineId = lineElement.attr("line-id");
	var sParams = '&lineId=' + lineId;
	var oCall = callAjax("deleteLine", sParams, "post", "/index.cfm/transaction/ajax");
	oCall.success(function(oData) {
		if (oData.errorType == '')
		{
			getBasketDropdownHeader();
			$(document).trigger( "removeLine",[lineId]);
		} else {
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}


function getBasketDropdownHeader()
{
	var oSecondCall = callAjax("basketDropdown", '', "post", '/index.cfm/transaction/ajax/basketdropdown');
	oSecondCall.success(function(oDataDropdown) {
		if (oDataDropdown.errorType == '') {
			$('#basketDropdown').html(oDataDropdown.html);
		} else {
			showAlert('error', oDataDropdown.errorMessage, oDataDropdown.errorUnhandled);
		}
	});
}

function removeFromwishlist(sProductId)
{
	uAjax = "/index.cfm/customer/ajax/removefromwishlist";

	var sParams = '&productId=' + sProductId;
	var oCall = callAjax("removeFromwishlist", sParams, "post");
	oCall.success(function(oData)
	{
		if (oData.errorType == '')
		{
			if($('.wishlistContainer').length > 0)
			{
				$('.wishlistContainer').replaceWith(oData.html);

				ciResponsive.process();
			}
			else if (typeof $('.thumb[data-product="' + sProductId + '"]') !== 'undefined')
			{
				var oThumb = $('.thumb[data-product="' + sProductId + '"]');
				oThumb.find('.fa-heart').addClass('fa-heart-o').removeClass('fa-heart');
				oThumb.find('.btnAddWishlistWrapper .btn-add').addClass('btnAddWishlist').removeClass('btnRemoveWishlist');
			}
			if($('.wishlistQuantity').length > 0)
			{
				$('.wishlistQuantity').html('<span>'+oData.wishlistQuantity+'</span>');
				if(oData.wishlistQuantity == 0)
				{
					$('.wishlistQuantity').hide();
				}
				else
				{
					$('.wishlistQuantity').show();
				}
			}
		}
		else
		{
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function suggestSearch(oEl,keyword)
{
	if(keyword.length > 2)
	{
		var sParams = '&keyword=' + keyword;
		var oCall   = callAjax('suggest', sParams, 'post', "/index.cfm/product/ajax/suggest");

		oCall.success(function(oData)
		{
			if (oData.errorType === '' && oData.html !== '')
			{
				if(!$(el('suggest')).length)
				{
					var oSearchForm = oEl.parents('form');
					oSearchForm.append('<div id="suggest"></div>');
				}
				$(el('suggest')).html(oData.html);
			}
			else if (oData.errorType === 'noResult')
			{
				$(el('suggest')).remove();
			}
		});
	}
}

function suggestKeyHandler(oEl, iKeyCode, sKeyword)
{
	var oFirst    = $(el('suggest')).find('ul li:first');
	var oLast     = $(el('suggest')).find('ul li:last');
	var oSelected = $(el('suggest')).find('ul li.selected');

	switch (iKeyCode)
	{
		case 13:
			if(oSelected.length > 0)
			{
				// Submit search from term
				if(oSelected.hasClass('suggestTerm'))
				{
					var oForm        = $(el('suggest')).parents('form');
					var oSearchInput = $('header input[name="keyword"]');

					oSearchInput.val(oSelected.text().trim());
					oForm.submit();
				}

				// Go to product detail
				if(oSelected.hasClass('suggestLine'))
				{
					var sUrl = oSelected.find('.colourURL').attr('href');
					window.location.href = sUrl;
				}
			}
			break;
		case 38:
			if(oSelected.length > 0)
			{
				if(!oSelected.is('li:first-of-type'))
				{
					oSelected.removeClass('selected').prevAll('li:first').addClass('selected');
				}
				else
				{
					oSelected.removeClass('selected');
					oLast.addClass('selected');
				}
			}
			else
			{
				oLast.addClass('selected');
			}
			break;

		case 40:
			if(oSelected.length > 0)
			{
				if(!oSelected.is('li:last-of-type'))
				{
					oSelected.removeClass('selected').nextAll('li:first').addClass('selected');
				}
				else
				{
					oSelected.removeClass('selected');
					oFirst.addClass('selected');
				}
			}
			else
			{
				oFirst.addClass('selected');
			}
			break;

		default:
			suggestSearch(oEl,sKeyword);
	}
}

function subscribe(frmSubscribe) {
	clearErrors();
	var bValid = validateForm(frmSubscribe);
	if (bValid) {
		var sEmail = $('#inputEmailSubscribe').val();
		var sName = $('#inputFirstNameSubscribe').val();

		if ($(el('inputSurnameSubscribe')).val()) {
			sName += ' ' + $(el('inputSurnameSubscribe')).val();
		}

		uAjax = "/index.cfm/customer/ajax/subscribe";
		var sParams = '&sEmail=' + sEmail + '&sName=' + sName;
		var oCall = callAjax('subscribe', sParams, 'post');
		oCall.success(function(oData) {
			$('.footerSubscribe').addClass('newsletterSubmitted')

			if (oData.errorType != '')
			{
				$('.footerSubscribe').addClass('newsletterSubmittedError')
				$('.footerSubscribe .newsletterText').text('');
				$('.footerSubscribe .newsletterSubText').text(oData.errorMessage);
				$('.footerSubscribe .newsletterTextTitle').text('');
				$('.footerSubscribe .newsletterSubTextWithInfo').text(oData.errorMessage);
				$('.footerSubscribe .newsletterForm, .footerSubscribe #btnSubscribe').remove();
			}
			else
			{
				$(document).trigger("subscribe",[sEmail]);

				$('#frmSubscribe input[type="text"]').val('');
				$('.footerSubscribe .newsletterText').text('');
				$('.footerSubscribe .newsletterSubText').text(tNewsletterSubscribed);
				$('.footerSubscribe .newsletterForm, .footerSubscribe #btnSubscribe').remove();
				$('.footerSubscribe .newsletterTextTitle').text(tNewsletterSubscribedTitle.replace("{email}","<a href='mailto:" + sEmail + "'>" + sEmail + "</a>").replace("{firstName}",sName ? sName : '').replaceAll("{br}","<br>"));
				$('.footerSubscribe .newsletterSubTextWithInfo').html(tNewsletterSubscribedWithInfo.replace("{email}","<a href='mailto:" + sEmail + "'>" + sEmail + "</a>").replace("{firstName}",sName ? sName : '').replaceAll("{br}","<br>"));
			}
		});
	}
	else
	{
		showAlert('error', tSubscribeInvalidInput, true);
	}
}

function validateBasketDropdownProductLineQuantity(iQty,iMultiplier,iStock,sLineId)
{
	if(isNaN(iQty) !== true && iQty != ""){

		iQty = Math.abs(iQty);
		iQty = (iMultiplier > 1 ? iQty*iMultiplier : iQty);
		iQty = (iStock < iQty && iStock > 0 ? iStock : iQty);

		changeBasketDropdownProductLineQuantity(sLineId, iQty);
	}
}

function changeBasketDropdownProductLineQuantity(sLineId, iQty)
{

	clearErrors();

	var buttons = $('[BasketDropdownProductLineId=' + sLineId + ']').parent().find('.cartDropdownProductLineQuantityBtn');
	buttons.each(function(){
		$(this).prop('disabled', true);
	});

	$('.basketdropdownModal').modal('hide');

	// AJAX call
	uAjax       = "/index.cfm/ajax/changeBasketDropdownProductLineQuantity";
	var sParams = '&lineId=' + sLineId + '&lineQty=' + iQty;
	var oCall   = callAjax("changeBasketDropdownProductLineQuantity", sParams, "post");
	oCall.success(function(oData)
	{
		if(oData.errorType === '')
		{
			$('#basketDropdown').html(oData.html);
			$('.basketdropdownModal').modal('show');
		}
		else
		{
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
		$('.ajaxLoader').fadeOut(200);

		buttons.each(function(){
			$(this).prop('disabled', false);
		});
	});
}

function confirmModal(variable, callbackfunction) {
	$('#confirmModal').modal('toggle');
	$('#confirmModal #btnYes').one('click', function() {
		if(typeof callbackfunction.name !== 'undefined')
		{
			var callbackfunctionName = callbackfunction.name;
		}
		else
		{
			// IE fallback: .name not supported..
			var callbackfunctionName = callbackfunction.toString().match(/^function\s*([^\s(]+)/)[1];
		}
		$(document).trigger(callbackfunctionName,variable);
		callbackfunction(variable);
		$('#confirmModal').modal('toggle');
	});
}

function showFullScreenPopup(text, title, className) {
	if (className === undefined) {
		className = '';
	}
	var maxHeight = $(window).height() - 100;
	if (maxHeight > 1100) {
		maxHeight = 1100;
	}
	var maxWidth = $(window).width();
	if (maxWidth > 1100) {
		maxWidth = 1100;
	}
	var maxHeightContent = maxHeight - 100;
	$('<div class="modal hide fade ' + className + '" style="width: ' + maxWidth + 'px; height:' + maxHeight + 'px;margin-left:0px;"><div class="modal-dialog modal-lg"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">x</button><h3 id="modalTitle">' + title + '</h3></div>' +
		'<div class="modal-body" style="width: ' + maxWidth + 'px; height:' + maxHeightContent + 'px;">' + text + '</div></div></div>').modal().appendTo('#mainContainer');
	centerPopups();
}

function editTranslation(translation)
{
	if(typeof translation.data('popover') === 'undefined')
	{
		translation.popover({
		html: true,
		placement: 'bottom',
		title: "Edit translation",
		content: '<div class="edit"><textarea class="translationText"></textarea><button class="btn btn-primary btnEditTranslation" type="submit">Save</button><button class="btn btn-danger btnCancelEditTranslation pull-right" type="submit">Cancel</button></div>'
		}).popover('show');
	}
	$('.popover.fade.bottom.in').css('left', '0')
	var text = translation.text();
	translation.next().find('textarea').val(text);
	$('.popover.fade.bottom.in').draggable({
		handle: ".popover-title",
	});
}

function saveTranslation(button) {
	var orgElement = button.closest('.popover').prev();
	if (typeof orgElement.data("code") == 'undefined') {
		orgElement = button.closest('.popover').prev().find('.editTranslation');
	}
	var translationCode = orgElement.data("code");
	var translationText = button.prev().val();
	translationText = translationText.replace(/(?:\r\n|\r|\n)/g, '<br />');

	uAjax = "/" + sCurrentLanguageCode + "/ajax/updatetranslation";

	var sParams = '&sTranslationCode=' + translationCode + '&sTranslationText=' + encodeURI(translationText);
	var oCall = callAjax('updatetranslation', sParams, 'post');
	oCall.success(function(oData) {
		if (oData.errorType != '') {
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		} else {
			showAlert('warning', 'Translation updated', false, 3000);
			$('.popover').remove();
		}
	});
}

function selectSwatch(swatch)
{
	var ciSrc      = swatch.data('ci-src');
	var original   = swatch.data('original');
	var colourLink = swatch.data('url');
	var thumb      = swatch.closest('.thumbnail');

	if(typeof ciSrc === "undefined"){
		ciSrc = 'https://' + original.split('/https://')[1];
	}
	var thumbWidth = getBoundingClientRect(thumb.find('.productImage'),"width");
	var thumbHeight = getBoundingClientRect(thumb.find('.productImage'),"height");
	thumb.children('a').css('display','block').width(thumbWidth).height(thumbHeight);
	var newThumbImage = thumb.find('.productImage').clone().removeClass('ci-image').removeClass('ci-image-loaded').removeClass('lazyloaded').prop('src','/styles/images/content/spacer.png').attr('data-src',original).attr('ci-src',ciSrc).removeAttr('srcset').removeAttr('data-srcset').removeAttr('data-src');
	thumb.find('a').prop('href',colourLink);

	var replaceContainer = (thumb.find('.productImage').parent(".ci-image-wrapper").length > 0) ? thumb.find('.productImage').parent(".ci-image-wrapper") : thumb.find('.productImage');
	replaceContainer.replaceWith(newThumbImage);
	ciResponsive.process();

	// Set correct price
	var sPromoPrice = swatch.data('pricePromo');
	var nPromoPrice= parseFloat(sPromoPrice.replace(",", ".").replace(",-", ".00"));
	var sCurrentPrice = swatch.data('priceCurrent');
	var diffPricesStandard = swatch.data('diffPricesStandard');
	var diffPricesPromo = swatch.data('diffPricesPromo');
	var bRecommendedPrice = (typeof swatch.data('priceRecommended') !== 'undefined');
	var sRecommendedPrice = bRecommendedPrice ? swatch.data('priceRecommended') : 0;
	var bCurrencySignFirst  = (typeof swatch.data('currencySignFirst') !== 'undefined' && swatch.data('currencySignFirst'));
	var sCurrentPriceString = (bCurrencySignFirst) ? sCurrencySign + " " + sCurrentPrice : sCurrentPrice + sCurrencySign;
	var sPromoPriceString   = (bCurrencySignFirst) ? sCurrencySign + " " + sPromoPrice : sPromoPrice + sCurrencySign;
	var sPriceHTML = '';
	if(nPromoPrice > 0 && (!bRecommendedPrice || sRecommendedPrice == 0))
	{
		sPriceHTML += '<span class="strike-through">' + sCurrentPriceString + '</span>&nbsp;';
		sPriceHTML += '<span>';
		if(diffPricesPromo)
		{
			sPriceHTML +=  sPricePromoFrom + ' ';
		}
		sPriceHTML += sPromoPriceString + '</span>';
	} else
	{
		sPriceHTML += '<span>';
		if(diffPricesStandard)
		{
			sPriceHTML +=  sPriceStandardFrom + ' ';
		}
		sPriceHTML += sCurrentPriceString + '</span>';
	}
	if(bRecommendedPrice) {
		sPriceHTML = '';
		var sStandardPrice = swatch.data('priceStandard');
		var sStandardPriceString   = (bCurrencySignFirst) ? sCurrencySign + " " + sStandardPrice : sStandardPrice + sCurrencySign;
		if (nPromoPrice == sRecommendedPrice && nPromoPrice > 0) {
			sPriceHTML += '<span class="promoPrice">' + sPromoPriceString.replace('.',',') + '</span>'
			sPriceHTML += '<span class="standardPrice"><span class="recommendedPriceLabel">' + sRecommendedPriceLabel + ':&nbsp;</span>' + sStandardPriceString.replace('.',',') + '</span></span>'
		} else if (nPromoPrice != sRecommendedPrice && nPromoPrice > 0) {
			sPriceHTML += '<span class="recommendedPrice strike-through">' + sStandardPriceString.replace('.',',') + '</span>&nbsp;'
			sPriceHTML += '<span class="promoPrice">' + sPromoPriceString.replace('.',',') + '</span>'
		} else {
			sPriceHTML += '<span class="standardPrice">' + sStandardPriceString.replace('.',',') + '</span>'
		}

	}

	oThumbPrice = swatch.closest('.thumb').find('.thumbPrice:not(.isLendout)');

	updateSwatchPrice(oThumbPrice,sPriceHTML,nPromoPrice);

	if(swatch.hasClass('trigger')) {
		// check if the extra class hasPromo needs to be added
		if (nPromoPrice > 0 && (!bRecommendedPrice || sRecommendedPrice == 0)) {
			swatch.closest('.thumb').find('.thumbPrice:not(.isLendout)').addClass('hasPromo');
			thumb.find('.discountLabel,.discount').show();
		} else if(nPromoPrice === sRecommendedPrice && nPromoPrice > 0) {
			swatch.closest('.thumb').find('.thumbPrice:not(.isLendout)').removeClass('hasPromo');
			swatch.closest('.thumb').find('.thumbPrice:not(.isLendout)').addClass('hasRecommendedLabel');
			thumb.find('.discountLabel,.discount').hide();
		} else if (sStandardPrice < sRecommendedPrice) {
			swatch.closest('.thumb').find('.thumbPrice:not(.isLendout)').removeClass('hasRecommendedLabel');
			if (nPromoPrice > 0) {
				swatch.closest('.thumb').find('.thumbPrice:not(.isLendout)').addClass('hasPromo');
				thumb.find('.discountLabel,.discount').show();
			} else {
				swatch.closest('.thumb').find('.thumbPrice:not(.isLendout)').removeClass('hasPromo');
				thumb.find('.discountLabel,.discount').hide();
			}
		} else if (sRecommendedPrice > 0 && sRecommendedPrice != sCurrentPrice) {
			swatch.closest('.thumb').find('.thumbPrice:not(.isLendout)').addClass('hasPromo');
			swatch.closest('.thumb').find('.thumbPrice:not(.isLendout)').removeClass('hasRecommendedLabel');
			thumb.find('.discountLabel,.discount').show();
		} else {
			swatch.closest('.thumb').find('.thumbPrice:not(.isLendout)').removeClass('hasRecommendedLabel');
			swatch.closest('.thumb').find('.thumbPrice:not(.isLendout)').removeClass('hasPromo');
			thumb.find('.discountLabel,.discount').hide();
		}

		// check if we need to add the overlay
		if (swatch.data('overlayImage') != '') {
			var overlayImage = swatch.data('overlayImage');
			var overlayText = swatch.data('overlayText');

			if (swatch.closest('.thumb').find('.overlay').length > 0) swatch.closest('.thumb').find('.overlay').closest('a').remove();

			// add overlay code
			var overlayHtml = '<a href="' + colourLink + '">';
			overlayHtml += '<img src="' + overlayImage + '" alt="' + overlayText + '" class="overlay">';
			overlayHtml += '</a>';

			swatch.closest('.thumb').find('.productImage').closest('a').after(overlayHtml);
		}
		else if (swatch.closest('.thumb').find('.overlay').length > 0) {
			swatch.closest('.thumb').find('.overlay').closest('a').remove();
		}
		var minPercentagePromo = (typeof swatch.data('minPercentagePromo') !== 'undefined' ? swatch.data('minPercentagePromo') : 0);
		if (minPercentagePromo !== 0) {
			var discountPercentage = ((sCurrentPrice - nPromoPrice)/sCurrentPrice) * 100;
			discountPercentage     = (Math.round(discountPercentage / 5)) * 5;
			if (minPercentagePromo >= discountPercentage) {
				oThumbPrice.find('.discountLabel,.discount').hide();
			}
		}
	}

	// set selected class on active swatch
	thumb.find('.swatch').removeClass('selected');
	swatch.addClass('selected');

	if (swatch.data('colour-id')) {
		// Swap product dropdowns for each product sizes
		swatch.closest(".thumb").find(".sizeWrapper").addClass("hide");
		$('.sizeWrapper .selectedSizeWrapper .selectedSize:not(.hide)').addClass('hide');
		swatch.closest(".swatchesContainer").find(".selectedSkuId").removeAttr('data-skuId');
		thumb.find(".sizeWrapper.colourId" + swatch.data('colour-id') + ".hide").removeClass("hide")
		$(".sizeWrapper .sizeTitle.hide").removeClass('hide');
		$(".sizeWrapper .thumbSizeItem").removeClass('selected');
	}
}

	// Swatch click product thumbs
	$(el('mainContainer')).on('click','.dropdown-menu .thumbSizeItem',function(){
		handleThumbSizeChange($(this));
	});

	function handleThumbSizeChange(sizeEl) {
		var sizeElProductId = sizeEl.data('product-id');
		var thumbEl = $(el('mainContainer')).find(".thumb[data-product='" + sizeElProductId + "']");
		var selectedSizeSkuId = sizeEl.data('value');
		var elDropdownItems = sizeEl.closest('.dropdown-menu').find('.thumbSizeItem');
		var standardPrice = parseFloat(sizeEl.data('price-standard'));
		var currentPrice = parseFloat(sizeEl.data('price-current'));
		var bRecommendedPrice = (typeof sizeEl.data('price-recommended') !== 'undefined');
		var recommendedPrice = bRecommendedPrice ? parseFloat(sizeEl.data('price-recommended')) : 0;
		var bInstock = sizeEl.data('instock');

		elDropdownItems.removeClass('selected');
		sizeEl.addClass('selected');
		thumbEl.find('.selectedSkuId').attr('data-skuId', selectedSizeSkuId);
		sizeEl.parents('.thumbSetting').find('.swatchesContainer .selectedSkuId').attr('data-product-id', sizeEl.data('product-id'));

		var oSizeWrapper = sizeEl.parents('.sizeWrapper');
		oSizeWrapper.find('.selectedSizeWrapper .sizeTitle:not(.hide)').addClass('hide');
		oSizeWrapper.find('.selectedSizeWrapper .selectedSize').text(sizeEl.text());
		oSizeWrapper.find('.selectedSizeWrapper .selectedSize.hide').removeClass('hide');
		if(bEnableNewWishlist) {
			if (sWishlistProducts.indexOf(selectedSizeSkuId) > 0) {
				thumbEl.find('.btnAddWishlistWrapper .btn-add i').addClass('fa-heart').removeClass('fa-heart-o');
				thumbEl.find('.btnAddWishlistWrapper .btn-add').addClass('btnRemoveWishlist').removeClass('btnAddWishlist');
			} else {
				thumbEl.find('.btnAddWishlistWrapper .btn-add i').addClass('fa-heart-o').removeClass('fa-heart');
				thumbEl.find('.btnAddWishlistWrapper .btn-add').addClass('btnAddWishlist').removeClass('btnRemoveWishlist');
			}
		}
		if(bRecommendedPrice) {
			var sPricesHtml = ''
			if ((standardPrice != currentPrice) && currentPrice == recommendedPrice) {
				$(el('mainContainer')).find('#price' + sizeEl.data('product-id')).addClass('hasRecommendedLabel');
				// No trigger overlay
				$(el('mainContainer')).find('#price' + sizeEl.data('product-id')).removeClass('hasPromo');
				thumbEl.find('.discountLabel,.discount').hide();
				sPricesHtml += '<span class="promoPrice">' + sCurrencySign + ' ' + currentPrice.toFixed(2).replace('.',',') + '</span>'
				sPricesHtml += '<span class="standardPrice"><span class="recommendedPriceLabel">' + sRecommendedPriceLabel + ':&nbsp;</span>' + sCurrencySign + ' ' + standardPrice.toFixed(2).replace('.',',') + '</span></span>'
			} else if ((standardPrice != currentPrice) && currentPrice != recommendedPrice) {
				$(el('mainContainer')).find('#price' + sizeEl.data('product-id')).addClass('hasPromo');
				thumbEl.find('.discountLabel,.discount').show();
				sPricesHtml += '<div class="thumbPriceWrapperLabel"><span class="strike-through">' + sCurrencySign + " " + parseFloat(standardPrice).toFixed(2).replace('.',',') + '</span><span>&nbsp;' + sCurrencySign + " " + parseFloat(currentPrice).toFixed(2).replace('.',',') + '</span></div>'
			} else if (standardPrice < recommendedPrice) {
				sPricesHtml += '<span class="standardPrice">' + sCurrencySign + ' ' + standardPrice.toFixed(2).replace('.',',') + '</span>'
			} else {
				sPricesHtml += '<span class="standardPrice">' + sCurrencySign + ' ' + currentPrice.toFixed(2).replace('.',',') + '</span>'
			}
			$(el('mainContainer')).find('#price' + sizeEl.data('product-id')).html(sPricesHtml);
		}

		if(typeof bInstock !== 'undefined')
		{
			if(bInstock)
			{
				thumbEl.find('.thumbStockLabel .instockLabel').show();
				thumbEl.find('.thumbStockLabel .notInstockLabel').hide();
			}
			else
			{
				thumbEl.find('.thumbStockLabel .instockLabel').hide();
				thumbEl.find('.thumbStockLabel .notInstockLabel').show();
			}
		}
		if (thumbEl.find('.sizesA2bBtn').length > 0) {
			thumbEl.find('.btn[data-add="basket"]').trigger('click');
		}
	}

// set header of popup
function setPopupHeader(oPopup, sTitle, sSubtitle)
{
	oPopup.find('.modal-header').html(sTitle);
	oPopup.find('.modal-body .subtitle').html(sSubtitle);
}

// set header of popup
function setPopupContent(oPopup, sContent)
{
	oPopup.find('.content').html(sContent);
}

function removeParam(key, sourceURL) {
	var rtn = sourceURL.split("?")[0],
		param,
		params_arr = [],
		queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
	if (queryString !== "") {
		params_arr = queryString.split("&");
		for (var i = params_arr.length - 1; i >= 0; i -= 1) {
			param = params_arr[i].split("=")[0];
			if (param === key) {
				params_arr.splice(i, 1);
			}
		}
		if (params_arr.length > 0) {
			rtn = rtn + "?" + params_arr.join("&");
		}
	}
	return rtn;
}

function scrollToElement(oEl)
{
	var iHeightFixedHeader = 0;
	if($('.fixedActive').length > 0)
	{
		iHeightFixedHeader = $('.fixedActive').outerHeight();
	}

	$('body,html').animate({
		scrollTop: oEl.offset().top - oEl.outerHeight()/2 - iHeightFixedHeader
	}, 400);
}

function showContentPopup(sPageName) {
	// Get contentpage to show in popup, if exists
	uAjax = '/index.cfm/ajax/popup';
	var sParams = '&pageName=' + sPageName;

	var oCall = callAjax('popup', sParams, 'post');
	oCall.success(function(oData) {
		if (oData.errorType === '') {
			showFullScreenPopup(oData.html, '', 'contentPopup');
			initLazyResponsiveLoad(true,'content');

			if (typeof initFlexSliders === "function") initFlexSliders();
			if (typeof initFeaturedProducts === "function") initFeaturedProducts();
			if (typeof initFeaturedProductsGridSlider === "function") initFeaturedProductsGridSlider();
			if (typeof initForms === "function") initForms();
			if (typeof initContentEventHandlers === "function") initContentEventHandlers();
			if (typeof initHotSpotImages === "function") initHotSpotImages();
			if (typeof initPaymentOptions === "function") initPaymentOptions();
			ciResponsive.process();

			setTimeout(function() {
				centerPopups();
			}, 100);

		}
	});
}

var bMouseleaveCountShown = 0
function showIdleBasketPopup(bMouseleave)
{
	if((bMouseleave && bMouseleaveCountShown == 0) || !bMouseleave)
	{
		if(bMouseleave) bMouseleaveCountShown ++;

		var oCall = callAjax('showidlebasketpopup', "", 'post','/index.cfm/transaction/ajax/showidlebasketpopup');
		oCall.success(function(oData) {
			if (oData.html !==  "undefined" && oData.html !== "")
				{
				$(oData.html).modal().appendTo('#mainContainer');

				setTimeout(function() {
					centerPopups();
				}, 100);
			}
			else
			{
				if(bMouseleave) bMouseleaveCountShown --;
			}
		});
	}
}

function showSelectedWishlistPopup()
{
	var oCall = callAjax('showselectedwishlistpopup', "", 'post','/index.cfm/wishlist/ajax/showselectedwishlistpopup');
	oCall.success(function(oData)
	{
		if (oData.errorType === "")
		{
			clearErrors();

			$(el("rememberWishlistModal")).remove();
			$(el("mainContainer")).append(oData.html);
			$(el("rememberWishlistModal")).modal();

			centerPopups();
		}
		else
		{
			showAlert("error", oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function rememberWishlist(oBtn)
{
	oBtn.prop('disabled', true);

	var sParams = '&id=' + $(el("wishlistsDropdown")).val();
	var oCall = callAjax('rememberwishlist', sParams, 'post','/index.cfm/wishlist/ajax/rememberwishlist');
	oCall.success(function(oData)
	{
		if (oData.errorType === "")
		{
			clearErrors();
			if ($(".wishlistEditProducts").length > 0) {
				window.location = oData.redirectUrl;
			} else {
				location.reload();
			}
		}
		else
		{
			showAlert("error", oData.errorMessage, oData.errorUnhandled);
			oBtn.prop('disabled', false);
		}

	});
}

function showCustomerPopup(sPopupType) {
	// Get contentpage to show in popup, if exists
	uAjax = '/index.cfm/ajax/popup';
	var sParams = '&popupType=' + sPopupType;
	var oCall = callAjax('popup', sParams, 'post');
	oCall.success(function(oData) {
		if (oData.errorType === '') {
			showFullScreenPopup(oData.html, '', 'customerPopup');
			centerPopups();
		}
	});
}

function updateSwatchPrice(oThumbPrice,sPriceHTML,nPromoPrice)
{
	if(oThumbPrice.find('.discountLabel,.discount').length > 0)
	{
		var oDiscountLabelClone = $(oThumbPrice).find('.discountLabel,.discount').clone();
	}

	oThumbPrice.html(sPriceHTML);
	oThumbPrice.append(oDiscountLabelClone);
	if(nPromoPrice > 0)
	{
		oThumbPrice.find('.discountLabel,.discount').show();
	}
	else
	{
		oThumbPrice.find('.discountLabel,.discount').hide();
	}
}

function detectBrowserLanguage()
{
	var sBrowserLanguage = '';
	if(typeof navigator.browserLanguage !== 'undefined')
	{
		// IE fallback
		sBrowserLanguage = navigator.browserLanguage;
	}
	else if(typeof navigator.language !== 'undefined')
	{
		sBrowserLanguage = navigator.language
	}

	return sBrowserLanguage;
}

function getSelectedAddons(bGetVisibleAddonsOnly)
{
	var bVisibleOnly = (typeof bGetVisibleAddonsOnly !== "undefined") ? bGetVisibleAddonsOnly : false;
	var oAddons = (bVisibleOnly) ? $('.addons:visible') : $('.addons');
	var aLines = [];
	oAddons.find('input,select,textarea').each(function()
	{
		if(!$(this).hasClass("addon-product-qty-picker"))
		{
			var bActive        = false;
			var sType          = $(this).attr('type');
			var sSku           = "";

			if($(this).is('input') || $(this).is('textarea'))
			{
				if(sType === 'checkbox' && $(this).is(":checked"))
				{
					bActive = true;
					sSku =  $(this).data('sku');
				}
				else if(sType === 'text' && $(this).val() !== "")
				{
					bActive = true;
					sSku =  $(this).data('sku');
				}
				else if(sType === 'radio'  && $(this).is(":checked"))
				{
					bActive = true;
					sSku    = $(this).val();
					skyQty  = $(this).closest(".control-group").find(".addon-product-qty-picker").val();
				}
			}
			else if($(this).is('select') && $(this).val() !== "")
			{
				bActive = true;
				sSku =  $(this).val();
			}

			if(bActive)
			{
				var oLine = {};
				oLine.description = '+ ' + $(this).data('description');
				oLine.quantity = (typeof skyQty !== "undefined") ? skyQty : (typeof getSkuQty !== "undefined") ? getSkuQty() : 1;
				oLine.skuId = sSku;
				oLine.sample = false;
				oLine.entryId = "";

				if($(this).is(':radio'))
				{
					oLine.comment = $(this).data('text') ? $(this).data('text') : "";
				}
				if($(this).data('requirestext'))
				{
					oLine.comment = $(this).val();
				}
				if($(this).is('select'))
				{
					oLine.comment = $(this).find('option:selected').text();
				}
				aLines.push(oLine);
			}
		}
	});

	return aLines;
}

function scanBarCode(sBarCode)
{
	var sParams = '&barcode=' + sBarCode;
	var oCall = callAjax("scanBarCode", sParams, "get","/index.cfm/product/ajax/scanBarCode");

	// process feedback
	oCall.success(function(oData)
	{
		if(oData.errorType === '' && typeof oData.redirect !== 'undefined' && oData.redirect !== "")
		{
			window.location = oData.redirect;
		}
		else if(oData.errorType === 'loggedOut')
		{
			location.reload();
		}
		else if(oData.errorType !== '')
		{
			// show error message
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function sendPicturePack(ids,button)
{

	var sParams = '&skuIds=' + ids;
	sParams += "&email=" + button.closest('.modal').find('.picturePackEmail').val();

	var oCall = callAjax("sendPicturePack", sParams, "post","/index.cfm/customer/ajax/sendPicturePack");

	// process feedback
	oCall.success(function(oData)
	{
		if(oData.errorType === 'info')
		{

			button.closest('.modal').modal('hide');
			button.prop('disabled',false);
			inlineAlert('info', oData.errorMessage, false, '.sendPicturePack');
		}
		else if(oData.errorType === 'loggedOut')
		{
			location.reload();
		}
		else
		{
			// show error message
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
			button.prop('disabled',false);
		}
	});
}

function setSlider(oSlider, containerWidth, bShowNextSlide,asNavFor)
{
	var oSlides            = oSlider.find('.slides li.thumb,.slides li.carouselThumb,.slides .slide');
	var iItemCount         = getSliderItemCount(oSlider);
	var iItemWidth         = (containerWidth) / iItemCount;
	var timeout            = oSlider.data('timeout');
	var transitionSpeed    = oSlider.data('transitionSpeed');
	var bControlNav        = (oSlider.data('controlNav') === true);
	var bDirectionNav      = (typeof oSlider.data('directionNav') !== 'undefined') ? (oSlider.data('directionNav')) : true;
	var asNavFor           = (typeof asNavFor !== 'undefined') ? asNavFor : '';
	var sAnimation         = (typeof oSlider.data('animation') !== 'undefined') ? (oSlider.data('animation')) : "slide";
	var bTouch             = (typeof oSlider.data('touch') !== 'undefined') ? (oSlider.data('touch') === true): true;
	var sDirection         = (typeof oSlider.data("direction") !== "undefined") ? oSlider.data("direction") : "horizontal";
	var borderRadius       = oSlider.data('borderRadius');
	var sDirectionNavColor = oSlider.data('directionNavColor');

	if(!isNaN(timeout)){
		timeout = timeout * 1000;
	}

	if(typeof bShowNextSlide !== "undefined" && bShowNextSlide)
	{
		iItemCount += 0.5;
	}
	if(sDirection !== "vertical")
	{
		oSlides.css({'margin-left':'0','margin-right':'12px'});
	}
	else
	{
		oSlides.css({'margin-left':'0'});
	}
	oSlider.flexslider({
		animation     : sAnimation,
		animationLoop : ((!isNaN(timeout) && timeout > 0) ? true : false),
		controlNav    : bControlNav,
		directionNav  : bDirectionNav,
		itemWidth     : iItemWidth,
		itemMargin    : (sDirection !== "vertical") ? 12 : 0,
		slideshow     : ((!isNaN(timeout) && timeout > 0 || typeof timeout === "undefined") ? true : false),
		slideshowSpeed: ((!isNaN(timeout) && timeout > 0) ? timeout : 7000),
		animationSpeed: ((!isNaN(transitionSpeed) && transitionSpeed > 0) ? transitionSpeed : 700),
		minItems      : iItemCount,
		maxItems      : iItemCount,
		asNavFor      : asNavFor,
		touch         : bTouch,
		direction     : sDirection,
		start: function(slider){
			slider.resize();
			initResponsiveImages(oSlider);
			setSliderActiveSliders(slider,oSlider,iItemCount);

			if(typeof sDirectionNavColor !== "undefined")
			{
				oSlider.find('.flex-direction-nav a').css('color',sDirectionNavColor);
			}
		},
		after: function(slider){
			setSliderActiveSliders(slider,oSlider,iItemCount);
		}
	});
}

function setSliderActiveSliders(slider,oSlider,iItemCount)
{
	oSlider.find("li").removeClass("flexSliderActiveSlides");
	var iStart = (slider.move * (slider.currentSlide));
	var iEnd = (slider.move * (slider.currentSlide + iItemCount));
	for (i = iStart + 1; i <= iEnd; i++) {
		oSlider.find("li:nth-child(" + i + ")").addClass("flexSliderActiveSlides");
	}

	if(oSlider.parents(".block").hasClass("productconfigslider"))
	{
		calcTotalAmountProductconfigslider(oSlider);
	}
}

function calcTotalAmountProductconfigslider(oSlider)
{
	var oBlock = oSlider.parents(".block");
	var oProductConfigSliders = oBlock.find(".productConfigSliders");
	var nToTal = 0;
	var sSelection = "";
	oProductConfigSliders.find(".flexslider").each(function(index, oEl)
	{
		$(oEl).find(".flexSliderActiveSlides").each(function(index,oActiveEl)
		{
			if(typeof $(oActiveEl).data("productPriceStandard") !== "undefined")
			{
				nToTal += (typeof $(oActiveEl).data("productPricePromo") !== "undefined" && parseFloat($(oActiveEl).data("productPricePromo")) != 0) ? parseFloat($(oActiveEl).data("productPricePromo")) : parseFloat($(oActiveEl).data("productPriceStandard"));
			}
			if(typeof $(oActiveEl).data("productWebname") !== "undefined")
			{
				if(sSelection == "")
				{
					sSelection += "<h3>" + oBlock.find(".productConfigSliderWrapper").data("summaryTitleText") + "</h3>"
				}
				sSelection += "<p>" + ($(oActiveEl).data("productWebname"));

				if(typeof $(oActiveEl).data("productFreetext2") !== "undefined" && $(oActiveEl).data("productFreetext2") !== "")
				{
					sSelection += "<strong>" + ($(oActiveEl).data("productFreetext2")) + "</strong></p>";
				}
				else
				{
					sSelection += "</p>";
				}
			}
		});
	});

	oBlock.find(".productConfigSelection").html(sSelection);

	if(nToTal != 0)
	{
		oBlock.find(".productConfigSliderCtaA2b").show();
		oBlock.find(".productConfigAmount").html(sCurrencySign + " " + parseFloat(nToTal).toFixed(2).replace('.',','));
	}
	else
	{
		oBlock.find(".productConfigAmount").html("");
		oBlock.find(".productConfigSliderCtaA2b").hide();
	}
}

function initResponsiveImages(oSlider){

	oSlider.find('.flex-viewport img').each(function(img){
		if(typeof $(this).data('src') !== "undefined" && $(this).data('src') !== ""){
			$(this).attr('ci-src',$(this).data('src'));
		}
	});
	$('div[ci-bg-url]').removeAttr('ci-bg-url');
	ciResponsive.process();
}

function geoLookup(sLocation, sLookupCountry, callback, sLookupCountryCode)
{

	if(typeof geocoder == 'undefined' && typeof google !== 'undefined')
	{
		geocoder = new google.maps.Geocoder();
	}
	if(typeof geocoder !== 'undefined')
	{
		var oBody = {};

		if(typeof sLookupCountry === 'undefined') sLookupCountry = sGeolookupCountryCodeDefault;
		if(typeof sLookupCountryCode === 'undefined') sLookupCountryCode = sGeolookupCountryCodeDefault;

		if(!isNaN(sLocation))
		{
			oBody.componentRestrictions = {
				"postalCode": sLocation,
				"country": sLookupCountry.trim()
			};
		}
		else
		{
			oBody.address = sLocation + "," + sLookupCountry.trim();
		}

		geocoder.geocode(oBody, function(results, status)
		{
			var geoLookup = {};
			geoLookup.results     = results;
			geoLookup.lat         = (results.length) ? results[0].geometry.location.lat(): "";
			geoLookup.lng         = (results.length) ? results[0].geometry.location.lng(): "";
			geoLookup.status      = status;
			geoLookup.countryCode = sLookupCountryCode;
			geoLookup.location    = sLocation;

			if(geoLookup.status == google.maps.GeocoderStatus.OK)
			{
				if(callback.name == "searchShop")
				{
					searchShop(sLocation,geoLookup.results[0].geometry.location.lat(),geoLookup.results[0].geometry.location.lng());
				}
				else
				{
					callback(geoLookup);
				}
			}
		});
	}
}

function getSliderItemCount(oSlider)
{
	var iItemCountDesktop = oSlider.data('itemCountDesktop');
	var iItemCountTabletL = oSlider.data('itemCountTabletL');
	var iItemCountTabletP = oSlider.data('itemCountTabletP');
	var iItemCountMobile  = oSlider.data('itemCountMobile');

	if(window.innerWidth > 1199 && typeof iItemCountDesktop !== 'undefined')
	{
		var iItemCount = iItemCountDesktop;
	}
	else if(window.innerWidth > 978 && window.innerWidth <= 1199 && typeof iItemCountTabletL !== 'undefined')
	{
		var iItemCount = iItemCountTabletL;
	}
	else if(window.innerWidth >= 768 && window.innerWidth <= 978 && typeof iItemCountTabletP !== 'undefined')
	{
		var iItemCount = iItemCountTabletP;
	}
	else if(window.innerWidth < 768 && typeof iItemCountMobile !== 'undefined')
	{
		var iItemCount = iItemCountMobile;
	}
	else
	{
		var oSlides    = oSlider.find('.slides li.thumb');
		var iItemCount = getSliderItemCountFallback(oSlides);
	}

	return iItemCount;
}

function getSliderItemCountFallback(oSlides)
{
	var iItemCount = 4;
	if(window.innerWidth < 768)
	{
		ItemCount = 1;
	}
	else if(typeof $(oSlides) !== 'undefined')
	{
		if($(oSlides).hasClass('span4'))
		{
			if(window.innerWidth >= 768)
			{
				iItemCount = 3;
			}
			else
			{
				iItemCount = 2;
			}
		}
		else if($(oSlides).hasClass('span3'))
		{
			if(window.innerWidth > 978)
			{
				iItemCount = 4;
			}
			else if(window.innerWidth >= 768 && window.innerWidth <= 978)
			{
				iItemCount = 3;
			}
			else
			{
				iItemCount = 2;
			}
		}
		else if($(oSlides).hasClass('span2'))
		{
			if(window.innerWidth > 978)
			{
				iItemCount = 6;
			}
			else if(window.innerWidth >= 768 && window.innerWidth <= 978)
			{
				iItemCount = 3;
			}
			else
			{
				iItemCount = 2;
			}
		}
	}

	return iItemCount;
}

function getBoundingClientRect(oEl,sMetric)
{
	var rect = oEl[0].getBoundingClientRect();
	var boundingClientRectValue;

	if(sMetric === "width")
	{
		if (rect.width) {
			// `width` is available for IE9+
			boundingClientRectValue = rect.width;
		} else {
			// Calculate width for IE8 and below
			boundingClientRectValue = rect.right - rect.left;
		}
	}
	else if(sMetric === "height")
	{
		if (rect.height) {
			// `height` is available for IE9+
			boundingClientRectValue = rect.height;
		} else {
			// Calculate height for IE8 and below
			boundingClientRectValue = rect.bottom - rect.top;
		}
	}

	return boundingClientRectValue;
}

function showInfoAlert(sMessage)
{
	if($("header").length > 0)
	{
		var sEditMode = (editMode || editModeContent)? "editmodeEnabled":"";
		inlineAlert("info main-info " + sEditMode, sMessage, false, $("header").first());

		if (editMode || editModeContent) {
			$(".main-info").detach().appendTo("#contentManagement");
		}
	}
}

function switchPriceRangePreference(oEl, sPriceRange)
{
	oEl.prop("disabled", true);

	var sParams = "&pricerange=" + sPriceRange;

	var oCall = callAjax("switchPriceRangePreference", sParams, "post", "/index.cfm/product/ajax/switchpriceRangepreference");

	// process feedback
	oCall.success(function (oData) {
		if (oData.errorType !== '')
		{
			oEl.prop("disabled", false);
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
		else
		{
			location.reload();
		}
	});
}

function useBrowserLanguage(sBrowserLanguage, sActionType)
{
	$("header").removeClass("fixed");

	var sParams = "&browserLanguage=" + sBrowserLanguage +  "&actionType=" + sActionType;
	var oCall = callAjax("useBrowserLanguage", sParams, "post","/index.cfm/ajax/useBrowserLanguage");

	// process feedback
	oCall.success(function(oData)
	{
		if(oData.errorType === "")
		{
			if(sActionType === "redirect" && oData.redirectUrl !== "")
			{
				$(location).attr("href", oData.redirectUrl);
			}
			else if(sActionType === "alert" && oData.alertMessage !== "")
			{
				var sTimeout = (editMode) ? undefined : 6000;
				inlineAlert("info browserlanguage-info", oData.alertMessage, false, $("header"),false, sTimeout);

				// highlight language selector
				$(".headerLanguagesList").addClass("highlighted");
			}
		}
		else if(oData.errorType === 'loggedOut')
		{
			location.reload();
		}
	});
}

function loginFromId(oEl)
{

	var oLoader    = oEl.parents(".modal-body").find(".loaderWrapper");
	var oPopup    = oEl.parents(".modal");
	var customerId = oEl.data("customerId");
	var contactId = oEl.data("contactId");
	var redirectUrl = oEl.data("redirectUrl");
	var bLendingOrder = (typeof sLendoutId !== "undefined" && sLendoutId !== "");

	oLoader.css("display", "flex");
	oPopup.removeClass("enabled");

	uAjax = "/index.cfm/customer/ajax/loginFromId";
	var sParams = '&customerId=' + encodeURIComponent(customerId);
	if(typeof contactId !== "undefined")
	{
		sParams += "&contactId=" + encodeURIComponent(contactId);
	}
	if(bLendingOrder)
	{
		sParams += "&lendoutId=" + encodeURIComponent(sLendoutId);
	}

	var oCall = callAjax("loginById", sParams, "post");
	oCall.success(function(oData) {
		if (oData.errorType == '')
		{
			if(bLendingOrder)
			{
				$(('.formAddressWrapper.customer')).replaceWith(oData.lendoutCustomerAddress);
				$(('#deliveryAccordion')).replaceWith(oData.lendoutDeliveryAddress);
				setDeliveryDate($("#deliveryAccordion input[name='deliveryDate']"));
				$(el('returningCustomerId')).val(oData.customerId);
				lendoutStepActionProgress(3);
				$(el('lendoutFrm')).ajaxLoader('hide');

				oPopup.modal("hide");
			}
			if(typeof redirectUrl !== "undefined" && redirectUrl !== "")
			{
				window.location = redirectUrl;
			}
			else
			{
				var sLocation = (sChannel === 'B2B') ? "/" + sCurrentLanguageCode + ((typeof sPostLoginFromIdUrl !== "undefined") ? sPostLoginFromIdUrl : "/product/customer") : "/" + sCurrentLanguageCode + "/transaction";

				window.location = sLocation;
			}
		}
		else if(oData.errorType === 'classification')
		{
			oLoader.hide();
			oPopup.addClass("enabled");

			clearErrors();
			if($('#webshops').length == 0)
			{
				$('body').append(oData.html);
			}
			else
			{
				$('#webshops').replaceWith(oData.html);
			}

			$('#webshops').modal();
			centerPopups();
		}
		else
		{
			oLoader.hide();
			oPopup.addClass("enabled");

			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

(function($) {
	$.event.special.doubletap = {
		bindType: 'touchend',
		delegateType: 'touchend',
		handle: function(event) {
			var handleObj = event.handleObj,
				targetData = jQuery.data(event.target),
				now = new Date().getTime(),
				delta = targetData.lastTouch ? now - targetData.lastTouch : 0,
				delay = delay == null ? 300 : delay;
			if (delta < delay && delta > 30) {
				targetData.lastTouch = null;
				event.type = handleObj.origType;
				['clientX', 'clientY', 'pageX', 'pageY'].forEach(function(property) {
					event[property] = event.originalEvent.changedTouches[0][property];
				})
				handleObj.handler.apply(this, arguments);
			} else {
				targetData.lastTouch = now;
			}
		}
	};
})(jQuery);

(function($) {
	$.fn.center = function() {
		this.css("position", "absolute");
		this.css("top", Math.max(0, (($(window).height() - $(this).outerHeight()) / 2 - 200) +
			$(window).scrollTop()) + "px");
		return this;
	}
})(jQuery);

$(function () {

	centerPopups();
	initLazyResponsiveLoad();

	$('.waylf').click(function() {
		$(this).hide();
		$('.searchfield').show();
	});
	$('.alertContainer').delegate('.popupAlert', 'click', function() {
		$(this).alert('close');
	});

	var otextSlide = document.querySelector(".slider-usp");
	if(otextSlide){
		var text = otextSlide.querySelectorAll("li");

		var counter = 1;
		var size = text[0].clientHeight;

		otextSlide.style.transform = `translateY(-${size * counter}px)`;
		setInterval(()=>{
			if(counter >= text.length -1) return;
			otextSlide.style.transition = `transform 0.8s ease`;
			counter++;
			otextSlide.style.transform = `translateY(-${size * counter}px)`;
		}, 4000);
		otextSlide.addEventListener('transitionend', () => {
		if(text[counter].id === 'lastClone'){
			otextSlide.style.transition = `none`;
			counter = text.length - 2;
			otextSlide.style.transform = `translateY(-${size * counter}px)`;
		}
		if(text[counter].id === 'firstClone'){
			otextSlide.style.transition = `none`;
			counter = text.length - counter;
			otextSlide.style.transform = `translateY(-${size * counter}px)`;
		}
		});
	}

	var oSearchInput = $('header input[name="keyword"]');
	oSearchInput.on('blur', function(e)
	{
		setTimeout(function()
		{
			if(!bSuggestClicked && $('.jsHeaderSearch').length == 0)
			{
				$(el('suggest')).remove();
			}
			if(!bToggleClearSearchFieldClicked)
			{
				$('.toggleClearSearchField').remove();
			}
		},1);
	});

	$(el('mainContainer')).on('mousedown', '#suggest li', function(e) {
		bSuggestClicked=true;
	});

	$(el('mainContainer')).on('mouseup', '#suggest li', function(e) {
		bSuggestClicked=false;
	});

	$(el('mainContainer')).on('mousedown', '.toggleClearSearchField', function(e) {
		bToggleClearSearchFieldClicked=true;
	});

	$(el('mainContainer')).on('mouseup', '.toggleClearSearchField', function(e) {
		bToggleClearSearchFieldClicked=false;
	});

	oSearchInput.on('keyup', function(e)
	{
		var button = $(this);
		clearTimeout(typingTimer);
		typingTimer = setTimeout(function () {
			doneTyping(button, e);
		}, doneTypingInterval);
	});
	oSearchInput.on('keydown', function (e) {
		clearTimeout(typingTimer);
	});


	if($('.useToggleClearSearchFieldContainer').length > 0)
	{
		oSearchInput.on('mouseup keyup', function(e)
		{
			if($('.toggleClearSearchField').length == 0 && $(this).val() !== "")
			{
				$("<span class='toggleClearSearchField'><i class='icon-remove fa fa-times'></i></span>").insertAfter($(this));
			}
			else if($('.toggleClearSearchField').length == 1 && $(this).val() === "")
			{
				$('.toggleClearSearchField').remove();
			}
		});
	}

	$(el('mainContainer')).on('click','.toggleClearSearchField', function(event)
	{
		oSearchInput.val("");
		$(this).remove();
	});

	if(typeof sSearch !== 'undefined' && sSearch !=='')
	{
		oSearchInput.val(sSearch);
	}

	
	if($('.pinContainer').length > 0 || $('.pinElement').length > 0)
	{
		var iOffsetTop     = (typeof $(".pinElement").data("pin-offset") !== "undefined") ? $(".pinElement").data("pin-offset") : 92;
		var bMobileScreen  = (screenWidth <= 768);
		var bDesktopScreen = (screenWidth > 768);
		var bPinMobile     = true;
		var bPinDesktop    = true;

		if(typeof $(".pinElement").data("pin-mobile") !== "undefined")
		{
			bPinMobile = $(".pinElement").data("pin-mobile");
		}
		if(typeof $(".pinElement").data("pin-desktop") !== "undefined")
		{
			bPinDesktop = $(".pinElement").data("pin-desktop");
		}

		if(bMobileScreen && bPinMobile || bDesktopScreen && bPinDesktop)
		{
			$(".pinElement").onClassChange((el, newClass) => {
				if (newClass.indexOf("pinActive") >=0) {
					$('.pinContainer').addClass("pinnedElementParent");
				} else {
					$('.pinContainer').removeClass("pinnedElementParent");
				}
			});
			if($('.pinContainer').length > 0)
			{
				$('.pinElement').pin({containerSelector: ".pinContainer",padding: {top: iOffsetTop}, activeClass: 'pinActive'});
			}
			else
			{
				$('.pinElement').pin({padding: {top: iOffsetTop}, activeClass: 'pinActive'});
			}
		}
	}

	if($('.useToggleClearSearchFieldContainer').length > 0 && $('.toggleClearSearchFieldContainer').length == 0)
	{
		var sMarginBottom = oSearchInput.css("marginBottom");
		var sWidth        = ( 100 * parseFloat(oSearchInput.css("width")) / parseFloat(oSearchInput.parent().css('width')) ) + '%';
		oSearchInput.wrap('<div class="toggleClearSearchFieldContainer"></div>');
		oSearchInput.css("marginBottom", '0');
		oSearchInput.outerWidth("100%");
		$('.toggleClearSearchFieldContainer').css("marginBottom",sMarginBottom);
		$('.toggleClearSearchFieldContainer').width(sWidth);
	}

	$(el('mainContainer')).on('click', '.suggestTerm', function()
	{
		var oForm  = $(el('suggest')).parents('form');

		oSearchInput.val($(this).text().trim());
		oForm.submit();
	});

	$('#btnSubscribe').on('click', function() {
		subscribe($('#frmSubscribe'));
		return false;
	});

	$(el('frmSubscribe')).on('submit', function(e)
	{
		e.preventDefault();

		subscribe($(el('frmSubscribe')));
	});

	if($(window).width() > 767 && $('.jsDropdownSubmenu').length == 0 && (Modernizr.touch || !!(window.navigator.msMaxTouchPoints) || isTouchDevice() || isKiosk))
	{
		var oRootListItems = $('.navbar .nav-collapse > .menuItem > ul > li > a,.navbar .nav-collapse > .visible-desktop > .menuItem > ul > li > a,.navbar .level1');

		oRootListItems.on("click touchend", function(e) {
			if ($(this).parent().find('div:first').length) {
				e.preventDefault();

				var oListItem = $(this).parent();

				if (!$(e.target).is('.level1'))
				{
					oRootListItems.parent().find('div:first').hide();
					oRootListItems.parent().removeClass('touched');
				}

				oListItem.addClass('touched');
				oListItem.find('div:first').show();
			} else {
				var linkUrl = $(this).prop('href');
				window.location = linkUrl;
				event.preventDefault();
			}
			return false;
		});
		$('.navbar li .level1, .navbar li .dropdown-toggle').on('doubletap', function(event) {
			var linkUrl = $(this).prop('href');
			window.location = linkUrl;
			event.preventDefault();
			return false;
		});
		$(document).on('click touchstart', function(e) {
			if (!$(e.target).is('.level1') && !$(e.target).is('.navbar .nav-collapse > .menuItem > ul > li a') && !$(e.target).is('.navbar .nav-collapse > .visible-desktop > .menuItem > ul > li a')) {
				oRootListItems.parent().find('div:first').hide();
				oRootListItems.parent().removeClass('touched');
			}
		});

	} else {
		if ($(window).width() > 768) {
			$('.menuItemLink[data-toggle="dropdown"]').click(function(e) {
				e.preventDefault();

				var linkUrl = $(this).prop('href');
				window.location = linkUrl;
			});
		}
	}
	$('#menuPhone').change(function() {
		var menuLink = $(this).val();
		window.location = menuLink;
	});

	if (editMode)
	{
		initButtons();

		// reset opacity to prevent layout glitches
		$('.editTranslationWrapper').parents().css('opacity','1');

		// Show edit button
		$('#mainContainer').on({
			mouseenter: function() {
				$(this).find('.doEdit').show();
			},
			mouseleave: function() {
				$(this).find('.doEdit').hide();
			}
		}, '.editTranslation');

		$('#mainContainer').on('click', 'a', function(e)
		{
			var oManagementHeader = document.getElementById('managementHeader');

			if(!oManagementHeader.contains(e.target))
			{
				e.preventDefault();
			}
		});

		// Edit translation
		$('#mainContainer').on('click', '.editTranslation', function(e)
		{
			editTranslation($(this));
		});

		// Update translation
		$('#mainContainer').on('change keyup paste', '.translationText', function() {
			var element = $(this).closest('.popover').prev();
			if (element.children().length > 0) {
				element.find('.editTranslation').text($(this).val());
			} else {
				element.text($(this).val());
			}

		});

		// Save translation
		$('#mainContainer').on('click', '.btnEditTranslation', function(e) {
			saveTranslation($(this));
			return false;
		});

		$('#mainContainer').on('click', '.btnCancelEditTranslation', function()
		{
			$(this).parents('.popover').prev().popover('hide');
		});
	}
	// Show popup when parameter is specified
	if (sPopupType !== '' && sPopupType !== 'undefined') {
		showCustomerPopup(sPopupType);
	}

	if (editModeContent) {
		$('#mainContainer').on('click','.changeContentPage', function() {
			changeContentPage($(this).data('page'));
		});

		$('#mainContainer').on('click','.removeContentPage', function() {
			var page = $(this).data('page');
			setLinkedPage(page, '', $(this));
		});

		// Filter pages
		$('#mainContainer').on('keyup', '.contentManagement .filter', function() {

			var keyword = $(this).val();
			if (keyword === '') {
				$(el('pickPages')).find('tbody tr').show();
			} else {
				$(el('pickPages')).find('tbody tr').each(function() {
					var name = $(this).data('name');
					if (name.indexOf(keyword) < 0) {
						$(this).hide();
					} else {
						$(this).show();
					}
				});
			}
		});

		// Pick page
		$('#mainContainer').on('click', '.contentManagement .btnPick', function() {

			var page = $(this).data('page');
			var name = $(this).data('name');
			setLinkedPage(page, name, $(this));
		});
	}

	if ($(el('backToTop')).length) {
		var oBtn = $(el('backToTop'));
		if ($(el('whatsappChatButton')).length) {
			oBtn.show().css('margin-right','-500px'); // Temporarily show back to top button to calculate its height for the offset (negative margin to avoid flicker)
			var nBackToTopOffset = parseInt(oBtn.css('bottom').replace('px',''));
			$(el('whatsappChatButton')).css('bottom',(nBackToTopOffset + 50) + 'px')
			oBtn.hide().css('margin-right','');
		}

		$(window).scroll(function () {
			if ($(this).scrollTop() > 150) {
				oBtn.fadeIn();
			} else {
				oBtn.fadeOut();
			}
		});
		// scroll body to 0px on click
		oBtn.on('click', function() {
			$('body,html').animate({
				scrollTop: 0
			}, 800);
			return false;
		});
	}

	$('#mainContainer').on('click', '.searchInputToggle', function(evt) {
		evt.preventDefault();

		$(el('appendedInputButton')).animate({
			width: 'toggle'
		}, 350);
	});

	// Hover color
	$('.menuList').hover(function() {
		if ($(this).data('colour') !== '') {
			$(this).find('li:first-child a:first').css('color', $(this).data('colour'));
		}
	}, function() {
		$(this).find('li:first-child a:first').css('color', '');
	});

	$('.cookies .close').on('click',function(){
		closeCookiePopup($(this));
	});

	$('#mainContainer').on('click', '.main-info .close', function(){
		$(".nav-collapse.fsMenu, .faMenulink.min, .dontDisplayMenuLink>.menuItem").css("margin-top", 0);
	});

	//onclick for buttons mobile navigation on i tag
	$(el('mainContainer')).on('click', '.faMenulink', function(e) {

		if(!$(e.target).hasClass('directLink'))
		{
			//Function to display or hide the subitems of the menu
			var idOfDiv = $(this).attr("data-id");
			var currentId = document.getElementById('menu'+idOfDiv);

			if($(currentId).is(":visible") == false){
				$(currentId).show();
				$('#iPlusOf'+idOfDiv).hide();
				$('#iMinOf'+idOfDiv).show();
			} else {
				$(currentId).hide();
				$('#iPlusOf'+idOfDiv).show();
				$('#iMinOf'+idOfDiv).hide();
			}
		}
	});

	if($('.nav-horizontal').length)
	{
		var bMovingRight   = false;
		var oCurrentTarget = null;
		var xPrev          = 0;

		$(el('mainContainer')).on('mousemove mouseleave mouseenter', '.visible-desktop .menuList  li', function(e)
		{
			if(e.type == "mouseenter")
			{
				if(!bMovingRight)
				{
					oCurrentTarget = e.currentTarget;
					$(e.currentTarget).find(">.menuItem").show();
				}
				else
				{
					setTimeout(function ()
					{
						if(!bMovingRight || oCurrentTarget == null)
						{
							oCurrentTarget = e.currentTarget;
							$(e.currentTarget).find(">.menuItem").show();
						}
					}, 510);
				}
			}

			if(e.type == "mousemove")
			{
				if(xPrev<e.pageX)
				{
					bMovingRight = true;
					if(oCurrentTarget != e.currentTarget)
					{
						var hideTimer = setTimeout(function ()
						{
							if(oCurrentTarget != e.currentTarget)
							{
								bMovingRight = false;
								oCurrentTarget = null;
								hideTimer = null;
							}
						}, 500);
					}
				}
				else
				{
					bMovingRight = false;
					clearTimeout(hideTimer);
				}
				xPrev=e.pageX;
			}

			if(e.type == "mouseleave")
			{
				if(!bMovingRight && oCurrentTarget != e.currentTarget)
				{
					$(e.currentTarget).find('>.menuItem').hide();
				}
				else
				{
					setTimeout(function ()
					{
						if(!bMovingRight || oCurrentTarget == null && oCurrentTarget != e.currentTarget)
						{
							$(e.currentTarget).find('>.menuItem').hide();
						}
					}, 505);
				}
			}
		});
	}

	if($('.menuToggleContainer.isNotHomePage').length)
	{
		$('#mainContainer').on('click', '.menuToggleContainer', function(evt) {
			if($(this).hasClass('open'))
			{
				$(this).addClass('closed');
				$(this).removeClass('open');
				$(this).parents('.navbarInner').find('.collapse').hide();
			}
			else
			{
				$(this).addClass('open');
				$(this).removeClass('closed');
				$(this).parents('.navbarInner').find('.collapse').show();
			}
		});
	}

	$(el('mainContainer')).on('click', '#askQuestion', function()
	{
		if(validateForm($(el('popupQuestion'))))
		{
			var sParams = getValues($(el('popupQuestion')));

			var oCall = callAjax("sendQuestion", sParams, "post", "/index.cfm/ajax/sendQuestion");
			// process feedback
			oCall.success(function(oData) {
				if (oData.errorType === '')
				{
					$(el('popupQuestion')).modal('hide');
				}
				else {
					// show error message
					showAlert('error', oData.errorMessage, oData.errorUnhandled);
				}
			});
		}
	});

	$(el('mainContainer')).on('click', '#submitSimpleForm', function()
	{
		if(validateForm($(el('popupSimpleForm'))))
		{
			var oValueLabels = getValueLabels($(el('popupSimpleForm')));

			var oCall = callAjax("submitSimpleForm", oValueLabels, "post", "/index.cfm/ajax/submitSimpleForm");
			oCall.success(function(oData)
			{
				if (oData.errorType == '')
				{
					$(el('popupSimpleForm')).modal('hide');
				}
				else
				{
					// show error message
					showAlert('error', oData.errorMessage, oData.errorUnhandled);
				}
			});
		}
	});

	$(el('mainContainer')).on('click', '#suggest .suggestLine', function(event)
	{
		event.preventDefault();
		var linkUrl     = $(this).find('.colourURL').prop('href');
		window.location = linkUrl;

		return false;
	});

	// Add to basket from thumb
	$(el('mainContainer')).on('click','.btn[data-add="basket"]',function(e)
	{
		e.preventDefault();

		var iQty = $(this).closest('li').find('.thumbQtyInput').val();
		addProductToBasket($(this), iQty);
		return false;
	});

	// show popu with proposed URL
	if(sProposedUrl !== '')
	{
		clearErrors();
		$('#switchwebshop #btnContinueCountryShop').prop('href','https://' + sProposedUrl);
		var sText = $('#switchwebshop .modal-body .text').text();
		sText = sText.replace('${country}',sCountry).replace('${url}','<b>' + sProposedUrl.replace('https://','') + '</b>');
		$('#switchwebshop .modal-body .text').html(sText);

		sText = $('#switchwebshop #btnContinueCountryShop').text();
		sText = sText.replace('${url}',sProposedUrl.replace('https://',''));
		$('#switchwebshop #btnContinueCountryShop').text(sText);

		$('#switchwebshop').modal();
		centerPopups();
	}

	$(el('mainContainer')).on('click', '.btn-navbar.fsMenu', function () {
		loadMobileNavigation();
	});

	$(el('mainContainer')).on('show','.nav-collapse.fsMenu', function()
	{
		$('html, body').animate({ scrollTop: 0 }, 0);
		$('html, body').css({'overflow':'hidden', 'position': 'relative', 'height':'100%'});

		if ($('#mainContainer').find('.main-info').length > 0) {
			var iMainInfoHeight = $(".main-info").outerHeight() + "px";
			if ($(".faMenulink.min").css("position") == "fixed") {
				$(".nav-collapse.fsMenu, .faMenulink.min, .dontDisplayMenuLink>.menuItem").css("margin-top", iMainInfoHeight);
				if (!$(".nav-collapse.fsMenu").hasClass("mainInfoSizeGap")) {
					$(".nav-collapse.fsMenu").addClass("mainInfoSizeGap");
				}
			} else {
				$(".nav-collapse.fsMenu").css("margin-top", iMainInfoHeight);
			}
		}
	});

	$(el('mainContainer')).on('hide','.nav-collapse.fsMenu', function()
	{
		$('html, body').css({'overflow':'visible', 'position': 'static', 'height':'auto'});
		if ($('#mainContainer').find('.main-info').length > 0) {
			$(".nav-collapse.fsMenu, .faMenulink.min, .dontDisplayMenuLink>.menuItem").css("margin-top", 0);
		}
	});


	$(el('mainContainer')).on('change', '#addProductWishlistPopup #wishlistsDropdown', function(e)
	{
		var oSelectBtn = $('#addProductWishlistPopup').find(".selectBtn");
		oSelectBtn.prop('disabled',false);
	});


	$(el('mainContainer')).on('click', '#addProductWishlistPopup .selectBtn', function(e)
	{
		e.preventDefault();
		addToWishlistList($(this))
	});

	$(el('mainContainer')).on('click','.btnRemoveWishlist', function(e){
		e.preventDefault();
		if (bEnableNewWishlist) {
			$(this).prop('disabled',true);
			deleteFromWishlist($(this));
		} else {
			removeFromwishlist($(this).data('productId'));
		}
		
	});

	$(el('mainContainer')).on('click','.btnAddWishlist', function(e)
	{
		e.preventDefault();
		if (bEnableNewWishlist) {
			$(this).prop('disabled',true);
			var sProductId = $(this).closest('li').data('product');
			var oThumb = $('.thumb[data-product="' + sProductId + '"]');
			var selectedSizeSkuId = oThumb.find('.selectedSkuId').attr('data-skuid');
			if ((oThumb.find(".thumbSizeItem").length > 1 || oThumb.find(".swatch").length > 1) && typeof selectedSizeSkuId === "undefined") {
				window.location = $(this).attr('href');
			} else {
				addToWishlistPopup($(this), sProductId);
			}
		} else {
			addToWishlist($(this).data('productId'));
		}
	});

	// Swatch click product thumbs
	$(el('mainContainer')).on('click','.swatch',function(){
		selectSwatch($(this));
	});

	$(document).on('lazyloaded', function(e)
	{
		// Reset placeholderBackground when loaded
		if($(e.target.parentNode).hasClass('ci-image-wrapper'))
		{
			$(e.target.parentNode).css('background','transparent');
		}
	});

	$(el('mainContainer')).on('click','.sendPicturePack',function(oEvent){
		oEvent.preventDefault();
		popupSendPicturePack($(this).data('skuIds'),$(this));
		return false;
	});

	$('body').on('click','#sendConfirmPicturePackModal #btnSend',function(oEvent){
		oEvent.preventDefault();
		$(this).prop('disabled',true);

		sendPicturePack($(this).data('skuIds'),$(this));
		return false;
	});

	$('body').on('shown','.customerPopup', function(event)
	{
		ciResponsive.process();
	});

	if(typeof bUseBrowserLanguage !== "undefined" && bUseBrowserLanguage && typeof sUseBrowserLanguageActionType !== 'undefined' && sUseBrowserLanguageActionType !== "")
	{
		if((sUseBrowserLanguageActionType === "alert" || sUseBrowserLanguageActionType === "redirect") && document.cookie.indexOf("USEBROWSERLANGUAGE")  === -1)
		{
			var sBrowserLanguage = detectBrowserLanguage();
			useBrowserLanguage(sBrowserLanguage,sUseBrowserLanguageActionType);
		}
	}

	if (typeof sContentPagePromptPopupCookieCheck !== 'undefined' && sContentPagePromptPopupCookieCheck !== '') {
		showContentPopup(sContentPagePromptPopupCookieCheck);
	}

	if (typeof bShowIdleBasketPopup !== 'undefined' && bShowIdleBasketPopup) {
		showIdleBasketPopup();
	}

	if (typeof bPromptMainInfoAlert !== 'undefined' && bPromptMainInfoAlert == 1 && typeof sPromptMainInfoAlertKey !== "undefined" && typeof sPromptMainInfoAlertMessage !== "undefined")
	{
		showInfoAlert('<a href="#" class="showMainInfoAlert close" data-dismiss="alert"><i class="fa far fa-times"></i></a>' + sPromptMainInfoAlertMessage);

		$(el('mainContainer')).on('click','.showMainInfoAlert.close',function(e)
		{
			setCookie("mainInfoAlertSeen",sPromptMainInfoAlertKey,30);
		});
	}

	$(el('mainContainer')).on('click','.scanMode',function(e)
	{
		e.preventDefault();

		setScanMode($(this));
		return false;
	});

	$(el('mainContainer')).on('submit', '.siteSearch.scanmode', function(e)
	{
		e.preventDefault();

		var sBarCode = $(this).find('input').val();

		if(typeof sBarCode !== 'undefined' && sBarCode !== '')
		{
			scanBarCode(sBarCode);
		}
	});

	if($('.siteSearch.scanmode').length > 0)
	{
		oSearchInput.focus();
		oSearchInput.off("keyup keydown");
	}

	if(Modernizr.touch || !!(window.navigator.msMaxTouchPoints) || isTouchDevice())
	{
		$('body').addClass('isTouchDevice');
	}

	$(el('mainContainer')).on("click", '.jsDropdownSubmenu', function(e)
	{
		$('.jsDropdownSubmenuWrapper').find('.jsDropdownMenu').hide();

		if($(this).hasClass('activeJsDropdownSubmenu'))
		{
			$(this).removeClass('activeJsDropdownSubmenu');
		}
		else
		{
			$('.jsDropdownSubmenu').removeClass('activeJsDropdownSubmenu');
			$(this).addClass('activeJsDropdownSubmenu');
		}

		$(this).next('ul').toggle();
		e.stopPropagation();
		e.preventDefault();
	});

	$(el('mainContainer')).on('change', '.cartDropdownProductLineQuantity', function()
	{
		var iQty        = $(this).val();
		var iMultiplier = $(this).data('qtyMultiplier');
		var iStock      = parseInt($(this).data('stock'));
		var sLineId     = $(this).attr("line-id");

		if(iQty == 0){
			removeLine(sLineId);
		}
		else
		{
			validateBasketDropdownProductLineQuantity(iQty,iMultiplier,iStock,sLineId);
		}
	});

	$(el('mainContainer')).on('click', '.cartDropdownProductLineQuantityBtn', function(e) {
		e.preventDefault();

		var oEdtQty    = $(this).parents('.lineQty').find('.cartDropdownProductLineQuantity');

		var iCurrentVal = parseInt(oEdtQty.val());
		var iMultiplier = parseInt(oEdtQty.data('qtyMultiplier'));
		var sType      = $(this).attr('data-type');

		if (!isNaN(iCurrentVal))
		{
			if(sType === 'minus')
			{
				if(iCurrentVal > 0)
				{
					oEdtQty.val(iCurrentVal - (1*iMultiplier)).change();
				}
			}
			else if(sType === 'plus')
			{
				oEdtQty.val(iCurrentVal + (1*iMultiplier)).change();
			}
		}
	});

	$(el('mainContainer')).on("focus", '.jsHeaderSearch input', function(e)
	{
		e.preventDefault();

		handleTriggerJsHeaderSearch($(this));
	});

	$(el('mainContainer')).on("click", '.dismissJsHeaderSearch', function(e)
	{
		e.preventDefault();

		handleDismissJsHeaderSearch($(this));
	});

	$(el('mainContainer')).on("click", '.submitJsHeaderSearch', function(e)
	{
		e.preventDefault();

		$(".jsHeaderSearch").submit();
	});

	$(el('mainContainer')).on('keyup', '.maxCharsTextAreaWrapper textarea', function()
	{
		var iMaxChars = (typeof $(this).data("maxChars") !== "undefined" && !isNaN($(this).data("maxChars"))) ? parseInt($(this).data("maxChars")) : 999;
		$(this).val($(this).val().substring(0,iMaxChars));

		var charCount = parseInt($(this).val().length);
		$(this).parents(".maxCharsTextAreaWrapper").find('.charCount').html(charCount);
	});

	$(el('mainContainer')).on('keyup', '.maxCharsField', function()
	{
		var iMaxChars = (typeof $(this).data("maxChars") !== "undefined" && !isNaN($(this).data("maxChars"))) ? parseInt($(this).data("maxChars")) : 999;
		$(this).val($(this).val().substring(0,iMaxChars));
	});

	// fix collapse class (bootstrap bug)
	$('#footerAccordion .accordion-body').on('hide', function () {
		$(this).parents('.accordion-group').find('.accordion-toggle a[data-toggle="collapse"]').addClass('collapsed');
	});

	$(el('mainContainer')).on('show', '.productPaymentModal', function()
	{
		centerPopups();
	});

	$(el('mainContainer')).on('click', '#managementHeader #createQrCodeForPage', function()
	{
		$(el("createQrCodeForPage")).prop("disabled",true);

		createQrCode();
	});

	$(el('mainContainer')).on('change', '.toggleCheckBoxesByContainer', function()
	{
		var sSelectionContainer = $(this).data("selectionContainer");
		var bChecked = $(this).prop("checked");

		if($('#'+ sSelectionContainer).length > 0) // check by id
		{
			$('#'+ sSelectionContainer).find('input[type=checkbox]:not(.toggleCheckBoxesByContainer)').prop("checked",bChecked).trigger("change");
		}
		else if($('.'+ sSelectionContainer).length > 0) // check by class
		{
			$('.'+ sSelectionContainer).find('input[type=checkbox]:not(.toggleCheckBoxesByContainer)').prop("checked",bChecked).trigger("change");
		}
	});

	$(el('mainContainer')).on('click','.copiable', function(e) {

		var copyContent = $('.copiable').data().copyContent;
		var dialogContent = $('.copiable').data().dialogContent;
		navigator.clipboard.writeText(copyContent);
		var iFadeDelay = 1000;
		var fadeDuration = 1000;
		var topOffset  = $(".copiable").offset().top + 20;
		var leftOffset = $(".copiable").offset().left - 140;
		var oDiv = $('<div class="copiedToClipboardWrapper">')
			.css({
				"left": leftOffset + 'px',
				"top":  topOffset  + 'px'
			})
			.append($('<span class="clipboardMessage">' + dialogContent + '</span>'))
			.appendTo(document.body);

		setTimeout(function() {
			oDiv.addClass('fade-out');
			setTimeout(function() { oDiv.remove(); }, fadeDuration);
		}, iFadeDelay);
	});

	$(el('mainContainer')).on('click','.sliderClickHandler', function(e) {
		let imageIndex              = e.currentTarget.dataset.sliderCounter;
		let colorID                 = e.currentTarget.dataset.colourId;
		moveSlider(imageIndex, colorID);
	 });

	 $(el('mainContainer')).on('click','.move_up', function(e) {
		let colorId = e.currentTarget.dataset.colourId;
		if(selectedImageIndex < $(`ul#verticalSlider_${colorId} li`).length)
			moveSlider(selectedImageIndex + 1, colorId)
	});

	$(el('mainContainer')).on('click','.move_down', function(e) {
		let colorId = e.currentTarget.dataset.colourId;
		if(selectedImageIndex > 1)
			moveSlider(selectedImageIndex - 1, colorId)
	});

	$(el('mainContainer')).on("shown", ".addSkuPopup", function (e)
	{
		ciResponsive.process();

		var oSlider = $('.addSkuPopup .flexslider');
		if(oSlider.length > 0)
		{
			oSlider.each(function(index, oEl)
			{
				if($(oEl).hasClass('responsive'))
				{
					var iInnerWidth = $(oEl).innerWidth();
					setSlider($(oEl), iInnerWidth);

					setTimeout(function () {
						centerPopups();
					}, 1000);
				}
			});
		}
	});
	$(el('mainContainer')).on("shown", ".addSkuPopupMobile", function (e)
	{
		ciResponsive.process();

		var oSlider = $('.addSkuPopupMobile .flexslider');
		if(oSlider.length > 0)
		{
			oSlider.each(function(index, oEl)
			{
				if($(oEl).hasClass('responsive'))
				{
					var iInnerWidth = $(oEl).innerWidth();
					setSlider($(oEl), iInnerWidth);

					setTimeout(function () {
						centerPopups();
					}, 1000);
				}
			});
		}
	});

	if($('header.fixed').length && adminLoggedIn != 1 && editModeContent != 1)
	{
		var retriesLeft = 2;
		var validateFixedActiveClass = function()
		{
			var oFixedHeader                    = $('header.fixed');
			var oFixedHeaderCloneFixedActive    = oFixedHeader.clone();
			var oFixedHeaderCloneFixedNotActive = oFixedHeader.clone();
			var iMainInfoHeight 				= 0;

			oFixedHeaderCloneFixedActive.addClass('fixedActive fixedHeaderClone').css({left: "-10000px"}).appendTo("body");

			if(oFixedHeaderCloneFixedActive.css('position').toLowerCase() == "fixed")
			{
				// theme allstyles.css is loaded
				oFixedHeaderCloneFixedActive.css({position: "absolute"});
				oFixedHeaderCloneFixedNotActive.addClass('fixedHeaderClone').removeClass('fixedActive in').css({position: "absolute",left: "-10000px"}).appendTo("body");

				if ($('#mainContainer').find('.main-info').length > 0) {
					iMainInfoHeight = $(".main-info").outerHeight();
				}
				var iTopDistance = oFixedHeaderCloneFixedNotActive.outerHeight(true) - oFixedHeaderCloneFixedActive.outerHeight(true) + iMainInfoHeight;
				$('<div class="topSpacer"></div>').insertBefore(oFixedHeader);
				$('.topSpacer').css('height', oFixedHeaderCloneFixedNotActive.outerHeight(true) + 'px').hide();
				$('.fixedHeaderClone').remove();

				$(document).scroll(function()
				{
					if ($(this).scrollTop() >= iTopDistance)
					{
						var iDocumentHeight = $(document).innerHeight();
						var iWindowHeight   = $(window).innerHeight();

						if((iDocumentHeight - iTopDistance*2) >= iWindowHeight)
						{
							oFixedHeader.addClass('in fixedActive');
							if(oFixedHeader.css('position') === 'fixed')
							{
								$('.topSpacer').show();
							}
							else
							{
								oFixedHeader.removeClass('in fixedActive');
							}
							if(oFixedHeader.find('#suggest').length > 0)
							{
								$(el('suggest')).remove();
							}
						}
					}
					else
					{
						oFixedHeader.removeClass('in fixedActive');
						$('.topSpacer').hide();
					}
				});
			}
			else if(retriesLeft > 0)
			{
				retriesLeft--;
				$('.fixedHeaderClone').remove();
				setTimeout(validateFixedActiveClass, 1000);
			}
			else
			{
				$('.fixedHeaderClone').remove();
			}
		}
		validateFixedActiveClass();
	}
	if(bSetcontact)
	{
		uAjax = "/index.cfm/ajax/loadcontacts";
		var oCall = callAjax("loadContacts", "", "post");
		oCall.success(function(oData) {
			if (oData.errorType == '')
			{
				clearErrors();

				$(el("contactsPopup")).remove();
				$(el("mainContainer")).append(oData.html);
				$(el("contactsPopup")).modal();

				centerPopups();
			}
			else
			{
				showAlert('error', oData.errorMessage, oData.errorUnhandled);
			}
		});
	}
	$(el('mainContainer')).on('click','#contactsPopup.enabled .listItem', function(e)
	{
		e.preventDefault();

		loginFromId($(this));
		return false;
	});

	$(el('mainContainer')).on('click','#contactsPopup .loaderWrapper', function()
	{
		return false;
	});

	$(el('mainContainer')).on('change','.priceRangeSwitch input', function()
	{
		var sPriceRange = ($(this).is(":checked")) ? "retail":"wholesale";
		switchPriceRangePreference($(this),sPriceRange)

		return false;
	});

	$(el('mainContainer')).on('click','.priceRangeSwitchBtn', function()
	{
		switchPriceRangePreference($(this), $(this).data('pricerange'));
		return false;
	});

	$(el('mainContainer')).on('change','label.switch input', function()
	{
		var oSwitch    = $(this).parents('label.switch');
		var oLeftText  = oSwitch.find('.slider-text.left');
		var oRightText = oSwitch.find('.slider-text.right');
		var sOn        = oSwitch.data('on');
		var sOff       = oSwitch.data('off');

		if ($(this).is(':checked'))
		{
			oLeftText.text(sOn);
			oRightText.text("");
		}
		else
		{
			oLeftText.text("");
			oRightText.text(sOff);
		}

		return false;
	});

	$(el('mainContainer')).on('click','.btnEditSelectedWishlist', function()
	{
		showSelectedWishlistPopup($(this));
		return false;
	});

	$(el('mainContainer')).on('click','.btnRememberWishlist', function()
	{
		rememberWishlist($(this));
		return false;
	});

	window.onpopstate = function (e) {
		if(e.state == "addedProductToBasket")
		{
			window.history.replaceState(null, null, "");
			history.go(-1);
			location.reload();
		}
	};
});

var selectedImageIndex = 1 ; //auxilliar variable for the move up and move down functions
function moveSlider(imageIndex, colorID){
	selectedImageIndex = imageIndex;
	try{
		// elements
		var oVerticalSlider    		= document.getElementById(`verticalSlider_${colorID}`);
		var activeImageSlider 		= document.getElementById(`activeImageSlider_${colorID}`);

		if(oVerticalSlider.children.length > 1){

			// base variables
			var verticalSliderOffset    = $(`#verticalSlider_${colorID}`).offset().top;  // offset of the main slider
			var activeImageSlider       = $(`#activeImageSlider_${colorID}`).offset().top;  // offset of the main slider
			var offsetDiference         = $(`#verticalImage_${colorID}_2`).offset().top - $(`#verticalImage_${colorID}_1`).offset().top;  //diference of offset between images inside the slider
			var windowWidth				= $(window).width();
			var centrilizedImage        = windowWidth > 1400 ? 4 : 3; // marker to where to start moving the slider according to the amout of images framed in the slider
			// slider images loop
			Array.from(oVerticalSlider.children).forEach((item, imageIndex) => {

				//base variables
				imageIndex++; // image id
				var verticalSliderImage = $(`#verticalImage_${colorID}_${imageIndex}`);
				var activeSliderImage   =$(`#activeImageSlider_${colorID}_${imageIndex}`);


				//calculate each image position
				var originalPosition = verticalSliderOffset + (imageIndex - 1) * offsetDiference;
				var imageBaseOffset = (offsetDiference * imageIndex) + verticalSliderOffset;
				var position = 	 selectedImageIndex <= centrilizedImage ? originalPosition : imageBaseOffset - ((selectedImageIndex - 3) * offsetDiference);//use index to centrilize image 3 so when clicling the images 1 and 2 to prevent them for being centrilized with a empty space above

				// motion
				verticalSliderImage.offset({top: position});
				activeSliderImage.offset({top: activeImageSlider});
				// style selected images
				if(imageIndex == selectedImageIndex){
					verticalSliderImage.addClass("selected")
					activeSliderImage.css('visibility', 'visible');
				}else{
					verticalSliderImage.removeClass("selected");
					activeSliderImage.css('visibility', 'hidden');
				}
			});
		}
	} catch(err){
		alert(err)
	}
 }
var bVatConfirmed = false;
var rAmount       = /^\d+([,.]\d{1,2})?$/;
var rDate         = "[0-9-]{10,10}";
var rEmail        = "^[a-zA-Z0-9-_\+~]+(\.[a-zA-Z0-9-_\+~]+)*@([a-zA-Z_0-9-]+\.)+[a-zA-Z]{2,7}$";
var rNumber       = /^\d+$/;
var rPhone        = "\\+?[0-9.\\-\\(\\) ]+";
var sVatPrevious  = '';

$(function()
{
	// create input masks for all relevant input fields
	if($.isFunction($.fn.inputmask))
	{
		formatInputs();
	}

	// format ez mark styling
	if($.isFunction($.fn.ezMark))
	{
		formatEzMark();
	}

	// needInvoice checkbox listener
	if($('.inputNeedInvoice').length > 0){
		$('.inputNeedInvoice').change(function()
		{
			changeInvoice($(this));
		});
		changeInvoice(null);
	}

	$(el('mainContainer')).on("click", "#popupCustomerPhoneValidation .btnPopupCustomerPhoneValidation", function (e) {
		e.preventDefault();

		var type = $(this).data("type");

		if (type === "replace") {
			$(el("mainContainer")).find(".validatingNumberViaService").val($(this).data("value"));
		}
		else if (type === "invalid") {
			$(el("mainContainer")).find(".validatingNumberViaService").closest('.control-group').addClass('error').removeClass('success')
		}

		$(el("mainContainer")).find(".validatingNumberViaService").removeClass("validatingNumberViaService");

		$("#popupCustomerPhoneValidation").modal("hide");
	});

	if(bUseValidationServiceForPhoneFields)
	{
		$(el('mainContainer')).on("blur", "input[data-type='phone']", function (e) {
			validatePhoneInput($(this));
		});
	}
});

function changeInvoice()
{
	toggleCompanyInfo();
}

// format ez mark styling
function formatEzMark()
{
	// ezmark styling for radio buttons
	if($('input[type="radio"]').length > 0)
	{
		$('input[type="radio"]').ezMark();
	}
	// ezmark styling for checkboxes
	if($('input[type="checkbox"]').length > 0)
	{
		$('input[type=checkbox]').ezMark();
	}
}

// create input masks for all relevant input fields
function formatInputs()
{
	// dates
	$("input[data-type='date']").inputmask("dd-mm-yyyy");

	// text only
	$("input[data-type='textOnly']").inputmask({
		'mask': 'a',
		'greedy': false,
		'repeat': '*'
	});

	if(!bUseValidationServiceForPhoneFields)
	{
		// phone numbers
		$("input[data-type='phone']").inputmask('Regex', {regex: rPhone});
	}

	// times
	$("input[data-type='time']").inputmask({ alias: "hh:mm", positionCaretOnTab: false});
}

// set company info required based on selections
function toggleCompanyInfo()
{
	var bNeedInvoice = $('.inputNeedInvoice').prop('checked');

	if(bNeedInvoice === true)
	{
		$('.imCustomerContainer').addClass('hide');
		$('.imCompanyContainer').removeClass('hide');
		$('.inputCompany:visible,.inputDepartment:visible,.inputVat:visible').parents('.control-group').removeClass('invisible');
	}
	else
	{
		$('.inputCompany:visible,.inputDepartment:visible,.inputVat:visible').parents('.control-group').addClass('invisible');
		$('.imCompanyContainer').addClass('hide');
		$('.imCustomerContainer').removeClass('hide');
	}
}

function trueDisableForm(container){

	if(typeof container === 'undefined'){
		container = $('body');
	}

	container.find('input[disabled="disabled"]:not(input[type="checkbox"], input[type="radio"])').each(function(item){
		$(this).parent().html(
			'<label class="control-label">'+$(this).val()+'</label>'
		)
	});

	container.find('select[disabled="disabled"]').each(function(item){
		$(this).parent().html(
			'<label class="control-label">'+$(this).children('option:checked').html()+'</label>'
		);
	});

	container.find('input[disabled="disabled"][type="checkbox"], input[disabled="disabled"][type="radio"]').each(function(item) {
		if($(this).is(':checked')){
			$(this).remove();
		}
		else{
			$(this).parent().remove();
		}

	});

}

function validateEmailString(email) {
	var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(String(email).toLowerCase());
}

function validateMultipleEmailString(email) {
	var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	var emails = email.split(';');
	for (var i = 0; i < emails.length; i++) {
		var email = emails[i].trim();
		if (!re.test(String(email).toLowerCase())) {
			return false;
		}
	}
	return true;
}

// validate a complete form
function validateForm(oForm)
{
	// remove all errors
	oForm.find('.error').removeClass('error');
	oForm.find('.success').removeClass('success');
	$('[id^=fb]').hide();

	// validation
	var bValid = validateRequired(oForm);
	if(validateAmount(oForm) == false)
	{
		bValid = false;
	}
	if(validateBox(oForm) == false)
	{
		bValid = false;
	}
	if(validateEmail(oForm) == false)
	{
		bValid = false;
	}
	if(validateDate(oForm) == false)
	{
		bValid = false;
	}
	if(validateHousenumber(oForm) == false)
	{
		bValid = false;
	}
	if(validatePhone(oForm) == false)
	{
		bValid = false;
	}
	if(validateCheckbox(oForm) == false)
	{
		bValid = false;
	}
	if(validatePasswordCheck(oForm) == false)
	{
		bValid = false;
	}
	if(validateVAT(oForm) === false)
	{
		bValid = false;
	}
	if(validateDateOfBirth(oForm) === false)
	{
		bValid = false;
	}
	if(validatePsnId(oForm) === false)
	{
		bValid = false;
	}
	return bValid;
}

// check all required fields are filled out
function validateRequired(oForm)
{
	var bValid = true;

	var aFields = oForm.find('input[type!="radio"][required], textarea[required], select[required]');
	var aSets = oForm.data('fields');
	var aValidatedFields = [];

	if( typeof aSets === "undefined"){
		aSets = [];
	}

	for(var i=0; i < aSets.length; i++){
		var oResult = validateSet(aSets[i]);
		aValidatedFields = aValidatedFields.concat(oResult.fields);
		if(oResult.valid === false){
			bValid = false;
		}
	}
	// loop through form elements that are required
	oForm.find('input[type!="radio"][required], textarea[required], select[required]').each(function()
	{
		var bVisible = $(this).is(':visible');
		if($(this).parents(".collapse").length > 0)
		{
			bVisible = ($(this).parents(".collapse").height() > 0);
		}
		if(bVisible && !$(this).closest('.control-group').hasClass('error') && !$(this).closest('.control-group').hasClass('success')){
			// check if empty (and visible)
			if(fieldIsValid($(this)))
			{
				setFieldValidationState($(this),'success');
			}else
			{
				setFieldValidationState($(this),'error');
				bValid = false;
			}
		}
	});

	// loop through radios - validate if one is checked
	oForm.find('input[type="radio"][required]').each(function()
	{
		if(!$(this).closest('.control-group').hasClass('error') && !$(this).closest('.control-group').hasClass('success'))
		{
			var sName = $(this).prop('name');
			if(fieldIsChecked($('input[type="radio"][name="' + sName + '"')))
			{
				setFieldValidationState($(this),'success');
			}else
			{
				setFieldValidationState($(this),'error');
				bValid = false;
			}
		}
	});

	// loop through checboxes - validate if one is checked
	oForm.find('.checkbox-group.required').each(function()
	{
		if(!$(this).closest('.control-group').hasClass('error') && !$(this).closest('.control-group').hasClass('success'))
		{
			if($(this).find(":checkbox:checked").length > 0)
			{
				setFieldValidationState($(this),'success');
			}else
			{
				setFieldValidationState($(this),'error');
				bValid = false;
			}
		}
	});

	// set feedback
	if(bValid == false)
	{
		$('#fbRequired').show();
	}
	return bValid;
}

function validateSet(oSet){
	var aCheckedFields = [];
	var bValid = true;
	var aValidatedSet = [];
	for(var j = 0; j < oSet.set.length; j++){
		if(typeof oSet.set[j] === 'object'){
			var oResult = validateSet(oSet.set[j]);
			aCheckedFields = aCheckedFields.concat(oResult.fields);
			aValidatedSet.push(oResult.valid);
		}
		else{
			var oField = $(oSet.set[j]);
			if(fieldIsValid($(oField)))
			{
				aValidatedSet.push(true);
			}else
			{
				aValidatedSet.push(false);
			}
			aCheckedFields.push(oField);
		}
	}

	switch(oSet.condition.toUpperCase()){
		case 'AND':
			if(aValidatedSet.indexOf(false) !== -1){
				bValid = false;
				$.each(aCheckedFields,function(key,val){setFieldValidationState(val,'error')});
			}
			else{
				bValid = true;
				$.each(aCheckedFields,function(key,val){setFieldValidationState(val,'success')});
			}
			break;
		case 'OR':
			if(aValidatedSet.indexOf(true) !== -1){
				bValid = true;
				$.each(aCheckedFields,function(key,val){setFieldValidationState(val,'success')});
			}
			else{
				bValid = false;
				$.each(aCheckedFields,function(key,val){setFieldValidationState(val,'error')});
			}
			break;
	}

	return {'valid': bValid, 'fields' : aCheckedFields} ;
}

function fieldIsChecked(oField)
{
	return !(!oField.is(':checked') && oField.is(':visible'));
}

function fieldIsValid(oField){
	var sValue = oField.val() || "";
	return !(sValue.trim() == "" && oField.is(':visible'));
}

function resetForm(oForm)
{
	$(':input', oForm).not(':button, :submit, :reset').val('').removeAttr('checked').removeAttr('selected');
}
function setFieldValidationState(oField,sValidationState){
	oField.closest('.control-group').removeClass('error').removeClass('success');
	oField.closest('.control-group').addClass(sValidationState);
}

function validateAmount(oForm)
{
	var bValid   = true;
	var oAmounts = oForm.find('input[data-type="amount"]');
	var iAmount  = 0;

	// loop through inputs fields and validate
	oAmounts.each(function()
	{
		iValue = $(this).val().replace('-', '');
		iValue = parseFloat($(this).val());
		if(!rAmount.test(iValue))
		{
			$(this).closest('.control-group').addClass('error').removeClass('success');
			bValid = false;
		}else
		{
			$(this).closest('.control-group').addClass('success');
		}
	});

	return bValid;
}

// validate a box
function validateBox(oForm)
{
	var bValid  = true;
	var oBox = oForm.find('input[data-type="box"]');

	// loop through email address input fields
	oBox.each(function()
	{
		if($(this).is(':visible'))
		{
			// check if filled in
			if($(this).val().length > 20)
			{
				$(this).closest('.control-group').addClass('error').removeClass('success');
				bValid = false;
			}
			else
			{
				$(this).closest('.control-group').addClass('success');
			}
		}
	});

	// set feedback
	if(bValid == false)
	{
		$('#fbFormat,#fbHousenumber').show();
	}

	return bValid
}

// validate a checkbox
// this function checks if he checkbox is checked
function validateCheckbox(oForm)
{
	var bValid = true;
	var oCheckboxes = oForm.find('input[data-type="checkbox"]');

	// loop through email address input fields
	oCheckboxes.each(function()
	{
		if(!$(this).is(':checked'))
		{
			$(this).closest('.control-group').addClass('error').removeClass('success');
			bValid = false;
		}
		else
		{
			$(this).closest('.control-group').addClass('success');
		}
	});

	// set feedback
	if(bValid == false)
	{
		$('#fbFormat,#fbPhone').show();
	}

	return bValid
}

// check if dates are valid
// this function assumes the input mask already covered the correct date
// it only checks if only numbers are filled in
function validateDate(oForm)
{
	var bValid = true;
	var oDates = oForm.find('input[data-type="date"]');

	// loop through email address input fields
	oDates.each(function()
	{
		// check if filled in
		if($(this).val() != '' && !$(this).hasClass('inputBirthdate'))
		{
			if(RegExp(rDate).test($(this).val()) == false || $(this).closest('.control-group').hasClass('error'))
			{
				$(this).closest('.control-group').addClass('error').removeClass('success');
				bValid = false;
			}
			else
			{
				$(this).closest('.control-group').addClass('success');
			}
		}
	});

	// set feedback
	if(bValid == false)
	{
		$('#fbFormat,#fbDate').show();
	}

	return bValid
}

function validateDateOfBirth(oForm)
{
	var bValid        = true;
	var oDateOfBirths = oForm.find('input.inputBirthdate,input[data-validation-type="dateofbirth"]');
	var today         = new Date();
	var minDate       = new Date(1753,1,1);

	oDateOfBirths.each(function()
	{
		if($(this).val() !== ""){
			var birthdaySplitted      = $(this).val().split(/(?:\/|\.|-|_| )+/);
			var correctBirthdayFormat = birthdaySplitted[2] + '/' + birthdaySplitted[1] + '/' + birthdaySplitted[0];
			var birthday              = new Date(correctBirthdayFormat);
			if(!(birthday instanceof Date && !isNaN(birthday)) || birthday > today || birthday < minDate || parseInt(birthday.getDate()) !== parseInt(birthdaySplitted[0]))
			{
				$(this).closest('.control-group').addClass('error').removeClass('success');
				bValid = false;
			}else
			{
				$(this).closest('.control-group').addClass('success').removeClass('error');;
			}
		}
	});


	return bValid;
}

// regex check for an e-mail field
function validateEmail(oForm)
{
	var bValid  = true;
	var oEmails = oForm.find('input[data-type="email"]');
	var oEmailLists = oForm.find('input[data-type="emaillist"]');

	// loop through email address input fields
	oEmails.each(function()
	{
		var sEmail = $(this).val().trim();
		if(sEmail != '')
		{
			if(validateEmailString(sEmail) == false || $(this).closest('.control-group').hasClass('error'))
			{
				$(this).closest('.control-group').addClass('error').removeClass('success');
				bValid = false;
			}
			else
			{
				// valid, when trimmed
				$(this).val(sEmail);
				$(this).closest('.control-group').addClass('success');
			}
		}
		else
		{
			// empty when trimmed
			$(this).val(sEmail);
		}
	});

	// loop through email multiple address input fields
	oEmailLists.each(function()
	{
		var sEmails = $(this).val().trim();
		if(sEmails != '')
		{
			if(validateMultipleEmailString(sEmails) == false || $(this).closest('.control-group').hasClass('error'))
			{
				$(this).closest('.control-group').addClass('error').removeClass('success');
				bValid = false;
			}
			else
			{
				// valid, when trimmed
				$(this).val(sEmails);
				$(this).closest('.control-group').addClass('success');
			}
		}
		else
		{
			// empty when trimmed
			$(this).val(sEmails);
		}
	});

	// set feedback
	if(bValid == false)
	{
		$('#fbFormat,#fbEmail').show();
	}

	return bValid;
}

// validate a house number
function validateHousenumber(oForm)
{
	var bValid  = true;
	var oHousenumbers = oForm.find('input[data-type="housenumber"]');

	// loop through email address input fields
	oHousenumbers.each(function()
	{
		if(!$(this).closest('.control-group').hasClass('error') && !$(this).closest('.control-group').hasClass('success')){
			// check if filled in
			if($(this).val().length > 8)
			{
				$(this).closest('.control-group').addClass('error').removeClass('success');
				bValid = false;
			}
			else
			{
				$(this).closest('.control-group').addClass('success');
			}
		}
	});

	// set feedback
	if(bValid == false)
	{
		$('#fbFormat,#fbHousenumber').show();
	}

	return bValid
}

// Validate password equals password
function validatePasswordCheck(oForm)
{
	var bValid   		= true;
	var oPassword 		= oForm.find('#inputPassword');
	var oPasswordCheck 	= oForm.find('#inputPasswordCheck');

	if(oPassword.length > 0 && oPasswordCheck.length > 0 && oPassword.is(':visible') && oPasswordCheck.is(':visible'))
	{
		if(oPassword.val() !== oPasswordCheck.val())
		{
			bValid = false;
			oPassword.closest('.control-group').addClass('error').removeClass('success');
			oPasswordCheck.closest('.control-group').addClass('error').removeClass('success');
		}
	}

	return bValid;
}


function validatePhoneInput(oInput)
{
	var sCountryCode = oInput.parents('form').find('select[name="inputCountry"] option:selected').data('code');

	if(typeof sCountryCode === "undefined" || sCountryCode ==="" || sCountryCode === null)
	{
		//fallback to possible data attr on the phone input
		sCountryCode = oInput.data("phoneCountrycode");
	}

	// if country is present , use validationservice
	if(typeof sCountryCode !== "undefined" && sCountryCode !== "" && sCountryCode !== null)
	{
		$(el("mainContainer")).find(".validatingNumberViaService").removeClass("validatingNumberViaService");

		if(oInput.val().trim() !== "")
		{
			var oCall       = validatePhoneCall(sCountryCode, oInput.val().trim());

			oCall.success(function (oData)
			{
				if (oData.validation.valid)
				{
					clearErrors();

					oInput.closest('.control-group').removeClass('error');

					if (oData.validation.confirm)
					{
						oInput.addClass("validatingNumberViaService");

						// confirm the phone number
						$("#popupCustomerPhoneValidation").find(".content").html(oData.html);
						centerPopups();
						$("#popupCustomerPhoneValidation").modal();
					}
					else if (oData.validation.didYouMean !== "" && oData.validation.didYouMean !== oInput.val().trim())
					{
						oInput.val(oData.validation.didYouMean);
					}
				}
				else
				{
					oInput.closest('.control-group').addClass('error').removeClass('success');
				}
			});
		}
	}
}

// validate a phone number
// this function only checks the characters used, not the actual format
function validatePhone(oForm)
{
	var bValid  = true;
	var oPhones = oForm.find('input[data-type="phone"]');

	// loop through email address input fields
	oPhones.each(function()
	{
		// check if filled in
		if($(this).val() != '')
		{
			if(RegExp(rPhone).test($(this).val()) == false || $(this).closest('.control-group').hasClass('error'))
			{
				$(this).closest('.control-group').addClass('error').removeClass('success');
				bValid = false;
			}
			else
			{
				$(this).closest('.control-group').addClass('success');
			}
		}
	});

	// set feedback
	if(bValid == false)
	{
		$('#fbFormat,#fbPhone').show();
	}

	return bValid
}

function validatePhoneCall(sCountry, sPhone)
{
	return $.ajax({
		url: "/index.cfm/customer/validation/phone",
		data: "phonenumber=" + encodeURIComponent(sPhone) + "&countrycode=" + sCountry,
		dataType: 'json',
		type: "GET",
		async: false
	});
}

// validate a select box
function validateSelect(oForm)
{
	var bValid  = true;
	var oSelect = oForm.find('select:not(.multi-select)');

	// loop through all select boxes
	oSelect.each(function()
	{
		// check if an option is selected
		if($(this).val() === null)
		{
			$(this).closest('.control-group, .form-group').addClass('error has-error').removeClass('success');
			bValid = false;
		}
		else
		{
			$(this).closest('.control-group, .form-group').addClass('success').removeClass('error has-error');
		}
	});

	return bValid
}

// validate VAT numbers (only for EU at the moment)
function validateVAT(oForm, fCallback, uAjaxVat)
{
	if(typeof uAjaxVat === "undefined"){
		uAjaxVat = '/index.cfm/customer/ajax/validateVat';
	}

	var bValid       	= true;
	var oVat         	= oForm.find('input[name="inputVatNumber"],input[name="inputVat"],input[name="inputInvoiceVat"]');

	// if VAT is visible, and at least the country code is entered
	if(oVat.is(':visible') && oVat.length > 0 && oVat.attr("validationIsNotNeeded") != "true" && oVat.prop('readonly') != true){
		var sVat = oVat.val().trim();
		var sCountryCode = '';

		if($(el('changeAddress')).length)
		{
			sCountryCode = oForm.find('#changeAddress select[name="inputCountry"] option:selected').data('code');
		}
		else if($('.quickCheckoutWrapper').length)
		{
			var oActiveAccordionGroup = $('.activeAccordionGroup');
			sCountryCode = oActiveAccordionGroup.find('select[name="inputInvoiceCountry"]:visible option:selected').data('code');
		}
		else
		{
			sCountryCode = oForm.find('select[name="inputCountry"] option:selected').data('code');
		}

		// substract country code from vat, because the checkvat service takes these as separate parameters
		if(sVat.length > 3 && /^[a-zA-Z]/.test(sVat.substr(0,2))){
			sCountryCode = sVat.substr(0,2);
			sVat = sVat.substr(2).replace(/[^a-z0-9]/gi,'');
		}

		// check if vat changed - if it is, revalidate
		if(sVatPrevious != oVat.val()){
			bVatConfirmed = false;
			sVatPrevious = oVat.val();
		}

		// user has confirmed vat nbr to be valid - continue
		if(bVatConfirmed)
		{
			// assume VAT code is valid by user
			$(this).closest('.control-group, .form-group').addClass('success').removeClass('error has-error');
		}

		// check if filled in code is longer than 3 characters
		else if(sVat.length > 3)
		{
			// asynchronous AJAX call, to make sure tha validation comes through correctly
			$.ajax(
			{
				url: uAjaxVat,
				data: "vat=" + sVat + "&countryCode=" + sCountryCode,
				dataType: 'json',
				type: "GET",
				async: false,
				success: function(oData)
				{
					// check for errors
					if(oData.errorType === 'vat_service')
					{
						if(sVatValidationAllowInvalid == '0')
						{
							bValid = false;
							oVat.closest('.control-group').addClass('error').removeClass('success');
							showAlert('error', tErrVATValidationServiceNotAllowed, false);
						}
						else
						{
							showAlert('warning', tErrVATValidationService, false);
						}

					}
					else if(oData.errorType !== "")
					{
						if(sVatValidationAllowInvalid == '0')
						{
							bValid = false;
							oVat.closest('.control-group').addClass('error').removeClass('success');
							showAlert('error', oData.errorMessage, false);
						}
						else
						{
							showAlert('warning', oData.errorMessage, oData.unhandled);
						}
					}
					else if(oData.errorType === 'loggedOut')
					{
						location.reload();
					}
					else
					{
						// call went through
						if(oData.vatServiceResponse.valid == "false")
						{
							// no valid VAT code
							bValid = false;
							oVat.closest('.control-group').addClass('error').removeClass('success');

							var oPopup = $('#popupContinue');

							if(sVatValidationAllowInvalid == '0' || oPopup.length == 0 || oData.errorType === "icinvalid")
							{
								showAlert('error', tErrVat, false);
							}
							else {
								// configure popup
								setPopupHeader(oPopup, tPopupTitleConfirmVatValid, '');
								oPopup.find('.modal-body .content').html(tPopupTextConfirmVatValid);
								oPopup.find('.action').text(tBtnPopupTextConfirmVatValidContinue).click(function(){
									// user wants vat nbr to be valid: flag vat input as confirmed, and ...
									bVatConfirmed = true;

									// in register page
									if($('#btnRegister:visible').length)
									{
										$('#btnRegister:visible').trigger('click');
									}
									// in account edit
									else if($('#btnUpdateCredentials:visible').length)
									{
										$('#btnUpdateCredentials:visible').trigger('click');
									}
									else if($('#btnUpdateFinancialInfo:visible').length)
									{
										$('#btnUpdateFinancialInfo:visible').trigger('click');
									}

									$(el('popupContinue')).modal('hide');
									oPopup.find('.action,.cancel').unbind('click');
								});
								oPopup.find('.cancel').text(tBtnPopupTextConfirmVatValidCancel).click(function(){
									// unflag so it can be revalidated
									bVatConfirmed = false;

									oPopup.find('.action,.cancel').unbind('click');
								});

								oPopup.modal();
							}
						}
						else
						{
							// valid VAT code
							oVat.closest('.control-group, .form-group').addClass('success').removeClass('error has-error');

							if(typeof oData.validateType !== 'undefined' && oData.validateType === 'vies')
							{
								// concat countryCode + vatNumber
								if(typeof oData.vatServiceResponse.countryCode !== 'undefined' && oData.vatServiceResponse.countryCode !== "" && typeof oData.vatServiceResponse.vatNumber !== 'undefined' && oData.vatServiceResponse.vatNumber !== "")
								{
									oData.vatServiceResponse.vatNumber = oData.vatServiceResponse.countryCode + oData.vatServiceResponse.vatNumber;
								}
							}

							populateFormFromResult(oData.vatServiceResponse);
						}
					}
				},
				error: function()
				{
					showAlert('warning', tErrVATValidationService, false);
				}
			});
		}
		else if(sVat.length > 0)
		{
			// no valid VAT code
			bValid = false;
			oVat.closest('.control-group').addClass('error').removeClass('success');

			var oInlineInvalid = oVat.closest('.control-group').find('.help-inline.invalid');
			if(oInlineInvalid.length)
			{
				oInlineInvalid.html('<i class="icon-remove fa fa-remove"></i>' + tErrVat);
			}
			else
			{
				showAlert('error', tErrVat, false);
			}
		}
	}

	return bValid;
}

// validate psn id
function validatePsnId(oForm)
{
	var bValid = true;
	var psnIds = oForm.find('input[data-type="psnid"]');

	psnIds.each(function()
	{
		if($(this).val() !== "")
		{
			if($(this).val().length < 3 || $(this).val().length > 16)
			{
				bValid = false;
			}
			else if(!/^[A-Z]$/i.test($(this).val().charAt(0)))
			{
				bValid = false;
			}
			else if(!/^[a-zA-Z0-9-_]+$/.test($(this).val()))
			{
				bValid = false;
			}

			if(bValid)
			{
				$(this).closest('.control-group').addClass('success');
			}
			else
			{
				$(this).closest('.control-group').addClass('error').removeClass('success');
			}
		}

	});
	return bValid;
}

function populateFormFromResult(oData)
{
	if(typeof oData.box !== 'undefined' && oData.box !== "")
	{
		loopAndSetIfNotEmty($('#inputInvoiceHousenumber,.inputBox'),oData.box);
	}
	if(typeof oData.city !== 'undefined' && oData.city !== "")
	{
		loopAndSetIfNotEmty($('#inputInvoiceCity,.inputCity'),oData.city);
	}
	if(typeof oData.company !== 'undefined' && oData.company !== "")
	{
		loopAndSetIfNotEmty($('#inputInvoiceCompany,.inputCompany'),oData.company);
	}
	if(typeof oData.houseNumber !== 'undefined' && oData.houseNumber !== "")
	{
		loopAndSetIfNotEmty($('#inputInvoiceHousenumber,.inputHousenumber'),oData.houseNumber);
	}
	if(typeof oData.postalCode !== 'undefined' && oData.postalCode !== "")
	{
		loopAndSetIfNotEmty($('#inputInvoicePostalcode,.inputPostalcode'),oData.postalCode);
	}
	if(typeof oData.street !== 'undefined' && oData.street !== "")
	{
		loopAndSetIfNotEmty($('#inputInvoiceStreet,.inputStreet'),oData.street);
	}
	if(typeof oData.vatNumber !== 'undefined' && oData.vatNumber !== "")
	{
		loopAndSet($('#inputInvoiceVat,.inputVat'),oData.vatNumber);
	}
	//NL vatnumber
	if(typeof oData.name !== 'undefined' && oData.name !== "")
	{
		loopAndSetIfNotEmty($('#inputInvoiceCompany,.inputCompany'),oData.name);
	}
}

function loopAndSet(oElem,sData){
	oElem.each(function(iKey,oSubElem){
		$(oSubElem).val(sData);
	});
}

function loopAndSetIfNotEmty(oElem,sData){
	oElem.each(function(iKey,oSubElem){
		if($(oSubElem).val() === "") {
			$(oSubElem).val(sData);
		}
	});
}
var bPostalCodeBusy = false;
var oElemTriggered = {};
var sCurrentPostalCodeBusy = '';
var sPostalcodeSelector = (typeof sPostalcodeSelector !== "undefined") ? sPostalcodeSelector : "input[name='inputPostalcode']";
var sCitySelector = (typeof sCitySelector !== "undefined") ? sCitySelector : "input[name='inputCity']";
var sStreetSelector = (typeof sStreetSelector !== "undefined") ? sStreetSelector : "input[name='inputStreet']";
var sHouseNumberSelector = (typeof sHouseNumberSelector !== "undefined") ? sHouseNumberSelector : "input[name='inputHousenumber']";
var sCountrySelector = (typeof sCountrySelector !== "undefined") ? sCountrySelector : "select[name='inputCountry']";
var sCountrySelectorFallback = (typeof sCountrySelectorFallback !== "undefined") ? sCountrySelectorFallback : "input[type='hidden'][name='inputCountry']";

var oFieldStates = {};

$(function()
{

	$('.smartAddressFields').each(function(elem){
		var defaults = {}
		defaults[sPostalcodeSelector] = "";
		defaults[sHouseNumberSelector] = "";
		defaults[sCountrySelector] = "";

		oFieldStates[elem] = defaults;
	});

	if($('.smartAddressFields').length == 0){
		var defaults = {}
		defaults[sPostalcodeSelector] = "";
		defaults[sHouseNumberSelector] = "";
		defaults[sCountrySelector] = "";

		oFieldStates[0] = defaults;
	}


	$(el('mainContainer')).on('focus',sPostalcodeSelector+', '+sHouseNumberSelector, function(oEvent){
		var iIndexOfField = fnGetIndexOfSmartAddress($(this));
		var oFieldValues = fnGetFieldValues(iIndexOfField);

		oFieldStates[iIndexOfField][sPostalcodeSelector] = oFieldValues.sPostalCode;
		oFieldStates[iIndexOfField][sHouseNumberSelector] =  oFieldValues.sHouseNumber;
	});

	$(el('mainContainer')).on('keyup keydown',sPostalcodeSelector+', '+sHouseNumberSelector, function(oEvent){
		var iIndexOfField = fnGetIndexOfSmartAddress($(this));

		oFieldStates[iIndexOfField][sPostalcodeSelector] = "";
		oFieldStates[iIndexOfField][sHouseNumberSelector] =  "";
	});

	$(el('mainContainer')).on('blur',sPostalcodeSelector+', '+sHouseNumberSelector, function(oEvent){
		var iIndexOfField = fnGetIndexOfSmartAddress($(this));
		var oFieldValues = fnGetFieldValues(iIndexOfField);

		if(
			oFieldStates[iIndexOfField][sPostalcodeSelector] !== oFieldValues.sPostalCode
			|| oFieldStates[iIndexOfField][sHouseNumberSelector] !== oFieldValues.sHouseNumber
			|| oFieldStates[iIndexOfField][sCountrySelector] == "changed"
			|| (oFieldValues.sCountryCode == "NL" && oFieldValues.sStreet == "")
			|| oFieldValues.sCity == ""
		){

			// only perform action if the blur is for a postal code or if its for a number and it's for NL
			if(
				$(sHouseNumberSelector+':visible').length > 0
				&& $(this)[0] == oFieldValues.sHouseNumberElem
				&& oFieldValues.sCountryCode !== 'NL'
			){
				return
			}

			oFieldStates[iIndexOfField][sPostalcodeSelector] = oFieldValues.sPostalCode;
			oFieldStates[iIndexOfField][sHouseNumberSelector] =  oFieldValues.sHouseNumber;
			oFieldStates[iIndexOfField][sCountrySelector] = "";

			fnPostalCodeHandler(oFieldValues.sPostalCode, oFieldValues.sHouseNumber,undefined,oFieldValues.sCountryCode,$(this));
		}
	});

	$(el('mainContainer')).on('click','#btnPostalCodeLookup', function(oEvent){
		var iIndexOfField = fnGetIndexOfSmartAddress($(this));
		var oFieldValues = fnGetFieldValues(iIndexOfField);

		oFieldStates[iIndexOfField][sPostalcodeSelector] = oFieldValues.sPostalCode;
		oFieldStates[iIndexOfField][sHouseNumberSelector] =  oFieldValues.sHouseNumber;
		oFieldStates[iIndexOfField][sCountrySelector] = "";

		fnPostalCodeHandler(oFieldValues.sPostalCode, oFieldValues.sHouseNumber,undefined,oFieldValues.sCountryCode,$(this));
	});

	$(el('mainContainer')).on('change',sCountrySelector , function(oEvent){
		var iIndexOfField = fnGetIndexOfSmartAddress($(this));
		oFieldStates[iIndexOfField][sCountrySelector] = "changed";

		if(['NL','UK'].indexOf($(this).find('option:selected').data('code')) > -1){
			$('#btnPostalCodeLookup').removeClass('hidden');
		}
		else{
			$('#btnPostalCodeLookup').addClass('hidden');
		}
	});

	$(el('mainContainer')).on('click','#popupPostalCode .btnCity,#popupPostalCodeLarge .btnCity', function(oEvent)
	{
		oEvent.preventDefault();
		fnPostalcodeSelected($(this), null);
		return false;
	});
});


var fnGetIndexOfSmartAddress = function(elem){
	if($('.smartAddressFields').length == 0){
		return 0;
	}
	else{
		for(var i = 0; i < $('.smartAddressFields').length; i++){
			if($('.smartAddressFields')[i] == elem.closest('.smartAddressFields')[0]){
				return i;
			}
		}
	}
}

var fnGetFieldValues = function(iIndexOfField){
	oFieldValues = {
		"sCountryCode" : "",
		"sPostalCode" : "",
		"sHouseNumber" : "",
		"sStreet" : "",
		"sCity" : "",
		"sHouseNumberElem" : {}
	}

	if($('.smartAddressFields').length == 0){

		if($(sCountrySelector+':visible').length > 0){
			oFieldValues.sCountryCode = $(sCountrySelector+':visible option:selected').data('code');
		}
		else{
			oFieldValues.sCountryCode = $(sCountrySelectorFallback).first().data('code');
		}
		oFieldValues.sPostalCode = $(sPostalcodeSelector+':visible').val();
		oFieldValues.sHouseNumber = $(sHouseNumberSelector+':visible').val();
		oFieldValues.sStreet = $(sStreetSelector+':visible').val();
		oFieldValues.sCity = $(sCitySelector+':visible').val();
		oFieldValues.sHouseNumberElem =  $(sHouseNumberSelector+':visible')[0];
	}
	else{
		if($($('.smartAddressFields')[iIndexOfField]).find(sCountrySelector+':visible').length > 0){
			oFieldValues.sCountryCode = $($('.smartAddressFields')[iIndexOfField]).find(sCountrySelector+':visible option:selected').data('code');
		}
		else{
			oFieldValues.sCountryCode = $($('.smartAddressFields')[iIndexOfField]).find(sCountrySelectorFallback).first().data('code');
		}
		oFieldValues.sPostalCode = $($('.smartAddressFields')[iIndexOfField]).find(sPostalcodeSelector+':visible').val();
		oFieldValues.sHouseNumber = $($('.smartAddressFields')[iIndexOfField]).find(sHouseNumberSelector+':visible').val();
		oFieldValues.sStreet = $($('.smartAddressFields')[iIndexOfField]).find(sStreetSelector+':visible').val();
		oFieldValues.sCity = $($('.smartAddressFields')[iIndexOfField]).find(sCitySelector+':visible').val();
		oFieldValues.sHouseNumberElem =  $($('.smartAddressFields')[iIndexOfField]).find(sHouseNumberSelector+':visible')[0];
	}
	return oFieldValues;
}

// handler for keystrokes in the postal code input field
var fnPostalCodeHandler = function(sPostalCode, sRefine, bBilling,sCountryCode,elem)
{

	// only perform once (when typing fast)
	if(!bPostalCodeBusy)
	{
		if(typeof sCountryCode === "undefined"){
			if($(sCountrySelector+':visible').length > 0){
				sCountryCode = $(sCountrySelector+':visible option:selected').data('code');
			}
			else{
				sCountryCode = $(sCountrySelectorFallback).first().data('code');
			}
		}

		sCurrentPostalCodeBusy = sPostalCode;

		if(
			(sCountryCode == 'BE' && sPostalCode.length == 4)
			||
			(sCountryCode == 'NL' && sPostalCode.length >= 6)
			||
			(sCountryCode == 'GB' && sPostalCode.length >= 4)
			||
			(sCountryCode == 'UK' && sPostalCode.length >= 4)
			||
			(sCountryCode == 'FR' && sPostalCode.length == 5)
			||
			(sCountryCode == 'DE' && sPostalCode.length == 5)
			||
			(sCountryCode == 'LU' && sPostalCode.length == 4)
		)
		{

			// lock postal code lookup
			bPostalCodeBusy = true;
			oElemTriggered = elem;
			if(sCountryCode == 'NL' && sRefine == '')
			{
				sRefine = $(sHouseNumberSelector).val();
			}

			// make call
			var oCall = fnPostalCodeLookup(sPostalCode, sCountryCode, sRefine);
			oCall.success(function (oData) {
				if (typeof oData.resultData !== "undefined") {
					// check if more than one city is returned
					if (oData.resultData.length > 1) {
						// more than one, create button for each city and add to popup
						var oPopup;
						if (oData.resultFormat == 'large') {
							oPopup = $(el('popupPostalCodeLarge'));
						}
						else {
							oPopup = $(el('popupPostalCode'));
						}
						var oPopupBody = oPopup.find('.control-group');

						// clear current values in popup
						oPopup.find('.control-group').html('');

						// create buttons
						for (var i = 0; i < oData.resultData.length; i++) {
							sButton = '<button class="btnCity btn btn-primary defaultBtnGreyDark" ' +
								'data-postalcode="' + oData.resultData[i].postalCode + '" ' +
								'data-city="' + oData.resultData[i].city + '" ' +
								'data-address="' + oData.resultData[i].address + '" ' +
								'data-address2="' + oData.resultData[i].address2 + '" ' +
								'data-address3="' + oData.resultData[i].address3 + '" ' +
								'data-address4="' + oData.resultData[i].address4 + '" ' +
								'data-address5="' + oData.resultData[i].address5 + '" ' +
								'data-county="' + oData.resultData[i].county + '" ' +
								'data-housenr="' + oData.resultData[i].housenr + '" ' +
								'data-refine="' + oData.resultData[i].refine + '" ' +
								'data-refinement="' + oData.resultData[i].refinement + '" ' +
								'data-billing="' + bBilling + '" ' +
								'>' +
								oData.resultData[i].label +
								'</button>';

							oPopupBody.append(sButton);
						}

						// vertically center & show popup
						centerPopups();
						oPopup.modal();
					}
					else if (oData.resultData.length == 1) {
						// only one
						fnPostalcodeSelected(null, oData.resultData[0]);
					}
				}

				// set boolean to false, so other lookups can be performed
				bPostalCodeBusy = false;
			});
		}
	}
}

// select a postal code and close the popup
var fnPostalcodeSelected = function (oButton, oData)
{
	// close popup
	var oPopup = $('#popupPostalCode,#popupPostalCodeLarge');



	// determine if final address
	var bRefine = oButton == null ? oData.refine : oButton.data('refine');
	var sRefinement = oButton == null ? oData.refinement : oButton.data('refinement');

	// needs refinement
	if(bRefine){
		fnPostalCodeHandler(sCurrentPostalCodeBusy, sRefinement);

	}
	else {

		// fill in chosen fields
		if($('.smartAddressFields').length == 0){
			var sCity = oButton == null ? oData.city : oButton.data('city');
			if (sCity != '') {
				$(sCitySelector+':visible').val(sCity).trigger('blur');
			}

			var sPostalcode = oButton == null ? oData.postalCode : oButton.data('postalcode');
			if (sPostalcode != '') {
				$(sPostalcodeSelector+':visible').val(sPostalcode).trigger('blur');
			}

			var sAddress = oButton == null ? oData.address : oButton.data('address');
			if (sAddress != '') {
				$(sStreetSelector+':visible').val(sAddress).trigger('blur');
			}

			/* var sAddress2 = oButton == null ? oData.address2 : oButton.data('address2');
			if (sAddress2 != '') {
				$("#edtAddress2").val(sAddress2);
			} */
		}
		else{
			var iIndexOfField = fnGetIndexOfSmartAddress(oElemTriggered);

			var sCity = oButton == null ? oData.city : oButton.data('city');
			if (sCity != '') {
				$($('.smartAddressFields')[iIndexOfField]).find(sCitySelector+':visible').val(sCity).trigger('blur');
			}

			var sPostalcode = oButton == null ? oData.postalCode : oButton.data('postalcode');
			if (sPostalcode != '') {
				$($('.smartAddressFields')[iIndexOfField]).find(sPostalcodeSelector+':visible').val(sPostalcode).trigger('blur');
			}

			var sAddress = oButton == null ? oData.address : oButton.data('address');
			if (sAddress != '') {
				$($('.smartAddressFields')[iIndexOfField]).find(sStreetSelector+':visible').val(sAddress).trigger('blur');
			}

			/* var sAddress2 = oButton == null ? oData.address2 : oButton.data('address2');
			if (sAddress2 != '') {
				$($('.smartAddressFields')[iIndexOfField]).find("#edtAddress2").val(sAddress2);
			} */
		}
	}
	oPopup.modal('hide');

	// remove buttons for possible next postal code lookup
	oPopup.find('.control-group').html('');
}

// postal code lookup
var fnPostalCodeLookup = function(sPostalCode, sCountryCode, sRefine)
{
	// make AJAX call
	return $.ajax(
	{
		url: "/index.cfm/customer/ajax/lookupPostalCode",
		data: "postalcode=" + sPostalCode + "&countrycode=" + sCountryCode + "&refine=" + sRefine,
		dataType: 'json',
		type: "GET"
	});
}
